var RatingCard =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/v2/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(990);


/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = React;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filterShape = __webpack_require__(42);
	
	Object.defineProperty(exports, 'filterShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_filterShape).default;
	  }
	});
	
	var _searchFieldShape = __webpack_require__(303);
	
	Object.defineProperty(exports, 'searchFieldShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_searchFieldShape).default;
	  }
	});
	
	var _shelfItemShape = __webpack_require__(304);
	
	Object.defineProperty(exports, 'shelfItemShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shelfItemShape).default;
	  }
	});
	
	var _listShape = __webpack_require__(301);
	
	Object.defineProperty(exports, 'listShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_listShape).default;
	  }
	});
	
	var _listItemShape = __webpack_require__(300);
	
	Object.defineProperty(exports, 'listItemShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_listItemShape).default;
	  }
	});
	
	var _availabilityShape = __webpack_require__(293);
	
	Object.defineProperty(exports, 'availabilityShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_availabilityShape).default;
	  }
	});
	
	var _featuredContentShape = __webpack_require__(297);
	
	Object.defineProperty(exports, 'featuredContentShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_featuredContentShape).default;
	  }
	});
	
	var _shelfShape = __webpack_require__(305);
	
	Object.defineProperty(exports, 'shelfShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shelfShape).default;
	  }
	});
	
	var _userIdentityShape = __webpack_require__(45);
	
	Object.defineProperty(exports, 'userIdentityShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_userIdentityShape).default;
	  }
	});
	
	var _bibBriefShape = __webpack_require__(40);
	
	Object.defineProperty(exports, 'bibBriefShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bibBriefShape).default;
	  }
	});
	
	var _bibShape = __webpack_require__(30);
	
	Object.defineProperty(exports, 'bibShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bibShape).default;
	  }
	});
	
	var _checkedOutItemShape = __webpack_require__(295);
	
	Object.defineProperty(exports, 'checkedOutItemShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_checkedOutItemShape).default;
	  }
	});
	
	var _borrowingQuotaShape = __webpack_require__(294);
	
	Object.defineProperty(exports, 'borrowingQuotaShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_borrowingQuotaShape).default;
	  }
	});
	
	var _holdItemShape = __webpack_require__(298);
	
	Object.defineProperty(exports, 'holdItemShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_holdItemShape).default;
	  }
	});
	
	var _branchShape = __webpack_require__(41);
	
	Object.defineProperty(exports, 'branchShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_branchShape).default;
	  }
	});
	
	var _singleClickHoldsSettingsShape = __webpack_require__(43);
	
	Object.defineProperty(exports, 'singleClickHoldsSettingsShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_singleClickHoldsSettingsShape).default;
	  }
	});
	
	var _IconShape = __webpack_require__(291);
	
	Object.defineProperty(exports, 'iconShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconShape).default;
	  }
	});
	
	var _CarouselSettingShape = __webpack_require__(290);
	
	Object.defineProperty(exports, 'carouselSettingShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CarouselSettingShape).default;
	  }
	});
	
	var _childrenShape = __webpack_require__(296);
	
	Object.defineProperty(exports, 'childrenShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_childrenShape).default;
	  }
	});
	
	var _libraryShape = __webpack_require__(299);
	
	Object.defineProperty(exports, 'libraryShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_libraryShape).default;
	  }
	});
	
	var _siteShape = __webpack_require__(44);
	
	Object.defineProperty(exports, 'siteShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_siteShape).default;
	  }
	});
	
	var _accountShape = __webpack_require__(292);
	
	Object.defineProperty(exports, 'accountShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_accountShape).default;
	  }
	});
	
	var _messagingShape = __webpack_require__(302);
	
	Object.defineProperty(exports, 'messagingShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_messagingShape).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BcReactComponent = __webpack_require__(93);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BcReactComponent).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
	 * modified to make it possible to validate Immutable.js data.
	 *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
	 *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
	 */
	"use strict";
	
	var Immutable = __webpack_require__(23);
	
	var ANONYMOUS = "<<anonymous>>";
	
	var ImmutablePropTypes = {
	  listOf: createListOfTypeChecker,
	  mapOf: createMapOfTypeChecker,
	  orderedMapOf: createOrderedMapOfTypeChecker,
	  setOf: createSetOfTypeChecker,
	  orderedSetOf: createOrderedSetOfTypeChecker,
	  stackOf: createStackOfTypeChecker,
	  iterableOf: createIterableOfTypeChecker,
	  recordOf: createRecordOfTypeChecker,
	  shape: createShapeChecker,
	  contains: createShapeChecker,
	  mapContains: createMapContainsChecker,
	  // Primitive Types
	  list: createImmutableTypeChecker("List", Immutable.List.isList),
	  map: createImmutableTypeChecker("Map", Immutable.Map.isMap),
	  orderedMap: createImmutableTypeChecker("OrderedMap", Immutable.OrderedMap.isOrderedMap),
	  set: createImmutableTypeChecker("Set", Immutable.Set.isSet),
	  orderedSet: createImmutableTypeChecker("OrderedSet", Immutable.OrderedSet.isOrderedSet),
	  stack: createImmutableTypeChecker("Stack", Immutable.Stack.isStack),
	  seq: createImmutableTypeChecker("Seq", Immutable.Seq.isSeq),
	  record: createImmutableTypeChecker("Record", function (isRecord) {
	    return isRecord instanceof Immutable.Record;
	  }),
	  iterable: createImmutableTypeChecker("Iterable", Immutable.Iterable.isIterable)
	};
	
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return "array";
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return "object";
	  }
	  if (propValue instanceof Immutable.Iterable) {
	    return "Immutable." + propValue.toSource().split(" ")[0];
	  }
	  return propType;
	}
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      rest[_key - 6] = arguments[_key];
	    }
	
	    propFullName = propFullName || propName;
	    componentName = componentName || ANONYMOUS;
	    if (props[propName] == null) {
	      var locationName = location;
	      if (isRequired) {
	        return new Error("Required " + locationName + " `" + propFullName + "` was not specified in " + ("`" + componentName + "`."));
	      }
	    } else {
	      return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!immutableClassTypeValidator(propValue)) {
	      var propType = getPropType(propValue);
	      return new Error("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (!immutableClassTypeValidator(propValue)) {
	      var locationName = location;
	      var propType = getPropType(propValue);
	      return new Error("Invalid " + locationName + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
	    }
	
	    if (typeof typeChecker !== "function") {
	      return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
	    }
	
	    var propValues = propValue.toArray();
	    for (var i = 0, len = propValues.length; i < len; i++) {
	      var error = typeChecker.apply(undefined, [propValues, i, componentName, location, "" + propFullName + "[" + i + "]"].concat(rest));
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createKeysTypeChecker(typeChecker) {
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (typeof typeChecker !== "function") {
	      return new Error("Invalid keysTypeChecker (optional second argument) supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
	    }
	
	    var keys = propValue.keySeq().toArray();
	    for (var i = 0, len = keys.length; i < len; i++) {
	      var error = typeChecker.apply(undefined, [keys, i, componentName, location, "" + propFullName + " -> key(" + keys[i] + ")"].concat(rest));
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createListOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "List", Immutable.List.isList);
	}
	
	function createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, immutableClassName, immutableClassTypeValidator) {
	  function validate() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return createIterableTypeChecker(valuesTypeChecker, immutableClassName, immutableClassTypeValidator).apply(undefined, args) || keysTypeChecker && createKeysTypeChecker(keysTypeChecker).apply(undefined, args);
	  }
	
	  return createChainableTypeChecker(validate);
	}
	
	function createMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
	  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "Map", Immutable.Map.isMap);
	}
	
	function createOrderedMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
	  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "OrderedMap", Immutable.OrderedMap.isOrderedMap);
	}
	
	function createSetOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Set", Immutable.Set.isSet);
	}
	
	function createOrderedSetOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "OrderedSet", Immutable.OrderedSet.isOrderedSet);
	}
	
	function createStackOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Stack", Immutable.Stack.isStack);
	}
	
	function createIterableOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Iterable", Immutable.Iterable.isIterable);
	}
	
	function createRecordOfTypeChecker(recordKeys) {
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (!(propValue instanceof Immutable.Record)) {
	      var propType = getPropType(propValue);
	      var locationName = location;
	      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
	    }
	    for (var key in recordKeys) {
	      var checker = recordKeys[key];
	      if (!checker) {
	        continue;
	      }
	      var mutablePropValue = propValue.toObject();
	      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
	      if (error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
	function createShapeTypeChecker(shapeTypes) {
	  var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
	  var immutableClassTypeValidator = arguments[2] === undefined ? Immutable.Iterable.isIterable : arguments[2];
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (!immutableClassTypeValidator(propValue)) {
	      var propType = getPropType(propValue);
	      var locationName = location;
	      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
	    }
	    var mutablePropValue = propValue.toObject();
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
	      if (error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeChecker(shapeTypes) {
	  return createShapeTypeChecker(shapeTypes);
	}
	
	function createMapContainsChecker(shapeTypes) {
	  return createShapeTypeChecker(shapeTypes, "Map", Immutable.Map.isMap);
	}
	
	module.exports = ImmutablePropTypes;

/***/ },
/* 8 */,
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2016, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(92));
	var IntlMessageFormat = _interopDefault(__webpack_require__(38));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(84));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var invariant = _interopDefault(__webpack_require__(31));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(74));
	
	var babelHelpers = {};
	babelHelpers.typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	babelHelpers.classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	babelHelpers.createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	babelHelpers.defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	babelHelpers.extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	babelHelpers.inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	babelHelpers.objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	babelHelpers.possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	babelHelpers.toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	babelHelpers;
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };
	
	function addLocaleData() {
	    var data = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var locales = Array.isArray(data) ? data : [data];
	
	    locales.forEach(function (localeData) {
	        if (localeData && localeData.locale) {
	            IntlMessageFormat.__addLocaleData(localeData);
	            IntlRelativeFormat.__addLocaleData(localeData);
	        }
	    });
	}
	
	function hasLocaleData(locale) {
	    var localeParts = (locale || '').split('-');
	
	    while (localeParts.length > 0) {
	        if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	            return true;
	        }
	
	        localeParts.pop();
	    }
	
	    return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	    var normalizedLocale = locale && locale.toLowerCase();
	
	    return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var bool = React.PropTypes.bool;
	var number = React.PropTypes.number;
	var string = React.PropTypes.string;
	var func = React.PropTypes.func;
	var object = React.PropTypes.object;
	var oneOf = React.PropTypes.oneOf;
	var shape = React.PropTypes.shape;
	
	
	var intlConfigPropTypes = {
	    locale: string,
	    formats: object,
	    messages: object,
	
	    defaultLocale: string,
	    defaultFormats: object
	};
	
	var intlFormatPropTypes = {
	    formatDate: func.isRequired,
	    formatTime: func.isRequired,
	    formatRelative: func.isRequired,
	    formatNumber: func.isRequired,
	    formatPlural: func.isRequired,
	    formatMessage: func.isRequired,
	    formatHTMLMessage: func.isRequired
	};
	
	var intlShape = shape(babelHelpers['extends']({}, intlConfigPropTypes, intlFormatPropTypes, {
	    formatters: object,
	    now: func.isRequired
	}));
	
	var messageDescriptorPropTypes = {
	    id: string.isRequired,
	    description: string,
	    defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	    formatMatcher: oneOf(['basic', 'best fit']),
	
	    timeZone: string,
	    hour12: bool,
	
	    weekday: oneOf(['narrow', 'short', 'long']),
	    era: oneOf(['narrow', 'short', 'long']),
	    year: oneOf(['numeric', '2-digit']),
	    month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	    day: oneOf(['numeric', '2-digit']),
	    hour: oneOf(['numeric', '2-digit']),
	    minute: oneOf(['numeric', '2-digit']),
	    second: oneOf(['numeric', '2-digit']),
	    timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	
	    style: oneOf(['decimal', 'currency', 'percent']),
	    currency: string,
	    currencyDisplay: oneOf(['symbol', 'code', 'name']),
	    useGrouping: bool,
	
	    minimumIntegerDigits: number,
	    minimumFractionDigits: number,
	    maximumFractionDigits: number,
	    minimumSignificantDigits: number,
	    maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	    style: oneOf(['best fit', 'numeric']),
	    units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
	};
	
	var pluralFormatPropTypes = {
	    style: oneOf(['cardinal', 'ordinal'])
	};
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	    '&': '&amp;',
	    '>': '&gt;',
	    '<': '&lt;',
	    '"': '&quot;',
	    '\'': '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	        return ESCAPED_CHARS[match];
	    });
	}
	
	function filterProps(props, whitelist) {
	    var defaults = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    return whitelist.reduce(function (filtered, name) {
	        if (props.hasOwnProperty(name)) {
	            filtered[name] = props[name];
	        } else if (defaults.hasOwnProperty(name)) {
	            filtered[name] = defaults[name];
	        }
	
	        return filtered;
	    }, {});
	}
	
	function invariantIntlContext() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var intl = _ref.intl;
	
	    invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	
	    if ((typeof objA === 'undefined' ? 'undefined' : babelHelpers['typeof'](objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : babelHelpers['typeof'](objB)) !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < keysA.length; i++) {
	        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	    var props = _ref2.props;
	    var state = _ref2.state;
	    var _ref2$context = _ref2.context;
	    var context = _ref2$context === undefined ? {} : _ref2$context;
	    var nextContext = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var _context$intl = context.intl;
	    var intl = _context$intl === undefined ? {} : _context$intl;
	    var _nextContext$intl = nextContext.intl;
	    var nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	    return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	function getDisplayName(Component) {
	    return Component.displayName || Component.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    var _options$intlPropName = options.intlPropName;
	    var intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName;
	    var _options$withRef = options.withRef;
	    var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	    var InjectIntl = function (_Component) {
	        babelHelpers.inherits(InjectIntl, _Component);
	
	        function InjectIntl(props, context) {
	            babelHelpers.classCallCheck(this, InjectIntl);
	
	            var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(InjectIntl).call(this, props, context));
	
	            invariantIntlContext(context);
	            return _this;
	        }
	
	        babelHelpers.createClass(InjectIntl, [{
	            key: 'getWrappedInstance',
	            value: function getWrappedInstance() {
	                invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	                return this.refs.wrappedInstance;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return React__default.createElement(WrappedComponent, babelHelpers['extends']({}, this.props, babelHelpers.defineProperty({}, intlPropName, this.context.intl), {
	                    ref: withRef ? 'wrappedInstance' : null
	                }));
	            }
	        }]);
	        return InjectIntl;
	    }(React.Component);
	
	    InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	
	    InjectIntl.contextTypes = {
	        intl: intlShape
	    };
	
	    InjectIntl.WrappedComponent = WrappedComponent;
	
	    return InjectIntl;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	function resolveLocale(locales) {
	    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	    return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	    return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    babelHelpers.classCallCheck(this, IntlPluralFormat);
	
	    var useOrdinal = options.style === 'ordinal';
	    var pluralFn = findPluralFunction(resolveLocale(locales));
	
	    this.format = function (value) {
	        return pluralFn(value, useOrdinal);
	    };
	};
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	    second: 60, // seconds to minute
	    minute: 60, // minutes to hour
	    hour: 24, // hours to day
	    day: 30, // days to month
	    month: 12 };
	
	// months to year
	function updateRelativeFormatThresholds(newThresholds) {
	    var thresholds = IntlRelativeFormat.thresholds;
	    thresholds.second = newThresholds.second;
	    thresholds.minute = newThresholds.minute;
	    thresholds.hour = newThresholds.hour;
	    thresholds.day = newThresholds.day;
	    thresholds.month = newThresholds.month;
	}
	
	function getNamedFormat(formats, type, name) {
	    var format = formats && formats[type] && formats[type][name];
	    if (format) {
	        return format;
	    }
	
	    if (false) {
	        console.error('[React Intl] No ' + type + ' format named: ' + name);
	    }
	}
	
	function formatDate(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'date', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting date.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatTime(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'time', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    // When no formatting options have been specified, default to outputting a
	    // time; e.g.: "9:42 AM".
	    if (Object.keys(filteredOptions).length === 0) {
	        filteredOptions = {
	            hour: 'numeric',
	            minute: 'numeric'
	        };
	    }
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting time.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatRelative(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var now = new Date(options.now);
	    var defaults = format && getNamedFormat(formats, 'relative', format);
	    var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults);
	
	    // Capture the current threshold values, then temporarily override them with
	    // specific values just for this render.
	    var oldThresholds = babelHelpers['extends']({}, IntlRelativeFormat.thresholds);
	    updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	    try {
	        return state.getRelativeFormat(locale, filteredOptions).format(date, {
	            now: isFinite(now) ? now : state.now()
	        });
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting relative time.\n' + e);
	        }
	    } finally {
	        updateRelativeFormatThresholds(oldThresholds);
	    }
	
	    return String(date);
	}
	
	function formatNumber(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var defaults = format && getNamedFormat(formats, 'number', format);
	    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getNumberFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting number.\n' + e);
	        }
	    }
	
	    return String(value);
	}
	
	function formatPlural(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	
	
	    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	
	    try {
	        return state.getPluralFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting plural.\n' + e);
	        }
	    }
	
	    return 'other';
	}
	
	function formatMessage(config, state) {
	    var messageDescriptor = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	    var values = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var messages = config.messages;
	    var defaultLocale = config.defaultLocale;
	    var defaultFormats = config.defaultFormats;
	    var id = messageDescriptor.id;
	    var defaultMessage = messageDescriptor.defaultMessage;
	
	    // `id` is a required field of a Message Descriptor.
	
	    invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	    var message = messages && messages[id];
	    var hasValues = Object.keys(values).length > 0;
	
	    // Avoid expensive message formatting for simple messages without values. In
	    // development messages will always be formatted in case of missing values.
	    if (!hasValues && ("production") === 'production') {
	        return message || defaultMessage || id;
	    }
	
	    var formattedMessage = void 0;
	
	    if (message) {
	        try {
	            var formatter = state.getMessageFormat(message, locale, formats);
	
	            formattedMessage = formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
	            }
	        }
	    } else {
	        if (false) {
	            // This prevents warnings from littering the console in development
	            // when no `messages` are passed into the <IntlProvider> for the
	            // default locale, and a default message is in the source.
	            if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	
	                console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
	            }
	        }
	    }
	
	    if (!formattedMessage && defaultMessage) {
	        try {
	            var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	            formattedMessage = _formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
	            }
	        }
	    }
	
	    if (!formattedMessage) {
	        if (false) {
	            console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
	        }
	    }
	
	    return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	    var rawValues = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	    // Process all the values before they are used when formatting the ICU
	    // Message string. Since the formatted message might be injected via
	    // `innerHTML`, all String-based values need to be HTML-escaped.
	    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	        var value = rawValues[name];
	        escaped[name] = typeof value === 'string' ? escape(value) : value;
	        return escaped;
	    }, {});
	
	    return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	var format = Object.freeze({
	    formatDate: formatDate,
	    formatTime: formatTime,
	    formatRelative: formatRelative,
	    formatNumber: formatNumber,
	    formatPlural: formatPlural,
	    formatMessage: formatMessage,
	    formatHTMLMessage: formatHTMLMessage
	});
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	    formats: {},
	    messages: {},
	
	    defaultLocale: 'en',
	    defaultFormats: {}
	};
	
	var IntlProvider = function (_Component) {
	    babelHelpers.inherits(IntlProvider, _Component);
	
	    function IntlProvider(props, context) {
	        babelHelpers.classCallCheck(this, IntlProvider);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(IntlProvider).call(this, props, context));
	
	        invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	        var intlContext = context.intl;
	
	        // Used to stabilize time when performing an initial rendering so that
	        // all relative times use the same reference "now" time.
	
	        var initialNow = void 0;
	        if (isFinite(props.initialNow)) {
	            initialNow = Number(props.initialNow);
	        } else {
	            // When an `initialNow` isn't provided via `props`, look to see an
	            // <IntlProvider> exists in the ancestry and call its `now()`
	            // function to propagate its value for "now".
	            initialNow = intlContext ? intlContext.now() : Date.now();
	        }
	
	        // Creating `Intl*` formatters is expensive. If there's a parent
	        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	        // memoize the `Intl*` constructors and cache them for the lifecycle of
	        // this IntlProvider instance.
	
	        var _ref = intlContext || {};
	
	        var _ref$formatters = _ref.formatters;
	        var formatters = _ref$formatters === undefined ? {
	            getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	            getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	            getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	            getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	            getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	        } : _ref$formatters;
	
	
	        _this.state = babelHelpers['extends']({}, formatters, {
	
	            // Wrapper to provide stable "now" time for initial render.
	            now: function now() {
	                return _this._didDisplay ? Date.now() : initialNow;
	            }
	        });
	        return _this;
	    }
	
	    babelHelpers.createClass(IntlProvider, [{
	        key: 'getConfig',
	        value: function getConfig() {
	            var intlContext = this.context.intl;
	
	            // Build a whitelisted config object from `props`, defaults, and
	            // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	            var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	            // Apply default props. This must be applied last after the props have
	            // been resolved and inherited from any <IntlProvider> in the ancestry.
	            // This matches how React resolves `defaultProps`.
	            for (var propName in defaultProps) {
	                if (config[propName] === undefined) {
	                    config[propName] = defaultProps[propName];
	                }
	            }
	
	            if (!hasLocaleData(config.locale)) {
	                var _config = config;
	                var locale = _config.locale;
	                var defaultLocale = _config.defaultLocale;
	                var defaultFormats = _config.defaultFormats;
	
	
	                if (false) {
	                    console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
	                }
	
	                // Since there's no registered locale data for `locale`, this will
	                // fallback to the `defaultLocale` to make sure things can render.
	                // The `messages` are overridden to the `defaultProps` empty object
	                // to maintain referential equality across re-renders. It's assumed
	                // each <FormattedMessage> contains a `defaultMessage` prop.
	                config = babelHelpers['extends']({}, config, {
	                    locale: defaultLocale,
	                    formats: defaultFormats,
	                    messages: defaultProps.messages
	                });
	            }
	
	            return config;
	        }
	    }, {
	        key: 'getBoundFormatFns',
	        value: function getBoundFormatFns(config, state) {
	            return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	                boundFormatFns[name] = format[name].bind(null, config, state);
	                return boundFormatFns;
	            }, {});
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var config = this.getConfig();
	
	            // Bind intl factories and current config to the format functions.
	            var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	            var _state = this.state;
	            var now = _state.now;
	            var formatters = babelHelpers.objectWithoutProperties(_state, ['now']);
	
	
	            return {
	                intl: babelHelpers['extends']({}, config, boundFormatFns, {
	                    formatters: formatters,
	                    now: now
	                })
	            };
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._didDisplay = true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }]);
	    return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	
	IntlProvider.contextTypes = {
	    intl: intlShape
	};
	
	IntlProvider.childContextTypes = {
	    intl: intlShape.isRequired
	};
	
	IntlProvider.propTypes = babelHelpers['extends']({}, intlConfigPropTypes, {
	    children: React.PropTypes.element.isRequired,
	    initialNow: React.PropTypes.any
	});
	
	var FormattedDate = function (_Component) {
	    babelHelpers.inherits(FormattedDate, _Component);
	
	    function FormattedDate(props, context) {
	        babelHelpers.classCallCheck(this, FormattedDate);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedDate).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedDate, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatDate = this.context.intl.formatDate;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedDate = formatDate(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedDate);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedDate
	            );
	        }
	    }]);
	    return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	
	FormattedDate.contextTypes = {
	    intl: intlShape
	};
	
	FormattedDate.propTypes = babelHelpers['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	var FormattedTime = function (_Component) {
	    babelHelpers.inherits(FormattedTime, _Component);
	
	    function FormattedTime(props, context) {
	        babelHelpers.classCallCheck(this, FormattedTime);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedTime).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedTime, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatTime = this.context.intl.formatTime;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedTime = formatTime(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedTime);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedTime
	            );
	        }
	    }]);
	    return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	
	FormattedTime.contextTypes = {
	    intl: intlShape
	};
	
	FormattedTime.propTypes = babelHelpers['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	    var absDelta = Math.abs(delta);
	
	    if (absDelta < MINUTE) {
	        return 'second';
	    }
	
	    if (absDelta < HOUR) {
	        return 'minute';
	    }
	
	    if (absDelta < DAY) {
	        return 'hour';
	    }
	
	    // The maximum scheduled delay will be measured in days since the maximum
	    // timer delay is less than the number of milliseconds in 25 days.
	    return 'day';
	}
	
	function getUnitDelay(units) {
	    switch (units) {
	        case 'second':
	            return SECOND;
	        case 'minute':
	            return MINUTE;
	        case 'hour':
	            return HOUR;
	        case 'day':
	            return DAY;
	        default:
	            return MAX_TIMER_DELAY;
	    }
	}
	
	var FormattedRelative = function (_Component) {
	    babelHelpers.inherits(FormattedRelative, _Component);
	
	    function FormattedRelative(props, context) {
	        babelHelpers.classCallCheck(this, FormattedRelative);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedRelative).call(this, props, context));
	
	        invariantIntlContext(context);
	
	        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	        // `now` is stored as state so that `render()` remains a function of
	        // props + state, instead of accessing `Date.now()` inside `render()`.
	        _this.state = { now: now };
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedRelative, [{
	        key: 'scheduleNextUpdate',
	        value: function scheduleNextUpdate(props, state) {
	            var _this2 = this;
	
	            var updateInterval = props.updateInterval;
	
	            // If the `updateInterval` is falsy, including `0`, then auto updates
	            // have been turned off, so we bail and skip scheduling an update.
	
	            if (!updateInterval) {
	                return;
	            }
	
	            var time = new Date(props.value).getTime();
	            var delta = time - state.now;
	            var units = props.units || selectUnits(delta);
	
	            var unitDelay = getUnitDelay(units);
	            var unitRemainder = Math.abs(delta % unitDelay);
	
	            // We want the largest possible timer delay which will still display
	            // accurate information while reducing unnecessary re-renders. The delay
	            // should be until the next "interesting" moment, like a tick from
	            // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	            var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	            clearTimeout(this._timer);
	
	            this._timer = setTimeout(function () {
	                _this2.setState({ now: _this2.context.intl.now() });
	            }, delay);
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            this.scheduleNextUpdate(nextProps, nextState);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.scheduleNextUpdate(this.props, this.state);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatRelative = this.context.intl.formatRelative;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedRelative = formatRelative(value, babelHelpers['extends']({}, this.props, this.state));
	
	            if (typeof children === 'function') {
	                return children(formattedRelative);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedRelative
	            );
	        }
	    }]);
	    return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	
	FormattedRelative.contextTypes = {
	    intl: intlShape
	};
	
	FormattedRelative.propTypes = babelHelpers['extends']({}, relativeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    updateInterval: React.PropTypes.number,
	    initialNow: React.PropTypes.any,
	    children: React.PropTypes.func
	});
	
	FormattedRelative.defaultProps = {
	    updateInterval: 1000 * 10
	};
	
	var FormattedNumber = function (_Component) {
	    babelHelpers.inherits(FormattedNumber, _Component);
	
	    function FormattedNumber(props, context) {
	        babelHelpers.classCallCheck(this, FormattedNumber);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedNumber).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedNumber, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatNumber = this.context.intl.formatNumber;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedNumber = formatNumber(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedNumber);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedNumber
	            );
	        }
	    }]);
	    return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	
	FormattedNumber.contextTypes = {
	    intl: intlShape
	};
	
	FormattedNumber.propTypes = babelHelpers['extends']({}, numberFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	var FormattedPlural = function (_Component) {
	    babelHelpers.inherits(FormattedPlural, _Component);
	
	    function FormattedPlural(props, context) {
	        babelHelpers.classCallCheck(this, FormattedPlural);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedPlural).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedPlural, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatPlural = this.context.intl.formatPlural;
	            var _props = this.props;
	            var value = _props.value;
	            var other = _props.other;
	            var children = _props.children;
	
	
	            var pluralCategory = formatPlural(value, this.props);
	            var formattedPlural = this.props[pluralCategory] || other;
	
	            if (typeof children === 'function') {
	                return children(formattedPlural);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedPlural
	            );
	        }
	    }]);
	    return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	
	FormattedPlural.contextTypes = {
	    intl: intlShape
	};
	
	FormattedPlural.propTypes = babelHelpers['extends']({}, pluralFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	
	    other: React.PropTypes.node.isRequired,
	    zero: React.PropTypes.node,
	    one: React.PropTypes.node,
	    two: React.PropTypes.node,
	    few: React.PropTypes.node,
	    many: React.PropTypes.node,
	
	    children: React.PropTypes.func
	});
	
	FormattedPlural.defaultProps = {
	    style: 'cardinal'
	};
	
	var FormattedMessage = function (_Component) {
	    babelHelpers.inherits(FormattedMessage, _Component);
	
	    function FormattedMessage(props, context) {
	        babelHelpers.classCallCheck(this, FormattedMessage);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedMessage).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.context.intl.formatMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var values = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var tokenDelimiter = void 0;
	            var tokenizedValues = void 0;
	            var elements = void 0;
	
	            var hasValues = values && Object.keys(values).length > 0;
	            if (hasValues) {
	                (function () {
	                    // Creates a token with a random UID that should not be guessable or
	                    // conflict with other parts of the `message` string.
	                    var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	                    var generateToken = function () {
	                        var counter = 0;
	                        return function () {
	                            return 'ELEMENT-' + uid + '-' + (counter += 1);
	                        };
	                    }();
	
	                    // Splitting with a delimiter to support IE8. When using a regex
	                    // with a capture group IE8 does not include the capture group in
	                    // the resulting array.
	                    tokenDelimiter = '@__' + uid + '__@';
	                    tokenizedValues = {};
	                    elements = {};
	
	                    // Iterates over the `props` to keep track of any React Element
	                    // values so they can be represented by the `token` as a placeholder
	                    // when the `message` is formatted. This allows the formatted
	                    // message to then be broken-up into parts with references to the
	                    // React Elements inserted back in.
	                    Object.keys(values).forEach(function (name) {
	                        var value = values[name];
	
	                        if (React.isValidElement(value)) {
	                            var token = generateToken();
	                            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	                            elements[token] = value;
	                        } else {
	                            tokenizedValues[name] = value;
	                        }
	                    });
	                })();
	            }
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedMessage = formatMessage(descriptor, tokenizedValues || values);
	
	            var nodes = void 0;
	
	            var hasElements = elements && Object.keys(elements).length > 0;
	            if (hasElements) {
	                // Split the message into parts so the React Element values captured
	                // above can be inserted back into the rendered message. This
	                // approach allows messages to render with React Elements while
	                // keeping React's virtual diffing working properly.
	                nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	                    return !!part;
	                }).map(function (part) {
	                    return elements[part] || part;
	                });
	            } else {
	                nodes = [formattedMessage];
	            }
	
	            if (typeof children === 'function') {
	                return children.apply(undefined, babelHelpers.toConsumableArray(nodes));
	            }
	
	            return React.createElement.apply(undefined, [tagName, null].concat(babelHelpers.toConsumableArray(nodes)));
	        }
	    }]);
	    return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	
	FormattedMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedMessage.propTypes = babelHelpers['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	var FormattedHTMLMessage = function (_Component) {
	    babelHelpers.inherits(FormattedHTMLMessage, _Component);
	
	    function FormattedHTMLMessage(props, context) {
	        babelHelpers.classCallCheck(this, FormattedHTMLMessage);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedHTMLMessage).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedHTMLMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatHTMLMessage = this.context.intl.formatHTMLMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var rawValues = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	            if (typeof children === 'function') {
	                return children(formattedHTMLMessage);
	            }
	
	            // Since the message presumably has HTML in it, we need to set
	            // `innerHTML` in order for it to be rendered and not escaped by React.
	            // To be safe, all string prop values were escaped when formatting the
	            // message. It is assumed that the message is not UGC, and came from the
	            // developer making it more like a template.
	            //
	            // Note: There's a perf impact of using this component since there's no
	            // way for React to do its virtual DOM diffing.
	            return React.createElement(tagName, {
	                dangerouslySetInnerHTML: {
	                    __html: formattedHTMLMessage
	                }
	            });
	        }
	    }]);
	    return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	
	FormattedHTMLMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedHTMLMessage.propTypes = babelHelpers['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedHTMLMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	addLocaleData(defaultLocaleData);
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;

/***/ },
/* 12 */,
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__(345);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MessagesIcon = exports.HoldsIcon = exports.Fees = exports.CheckedOutIcon = exports.BorrowingHistoryIcon = exports.Ellipsis = exports.Card = exports.CalendarWarning = exports.List = exports.ExternalArrow = exports.Bars = exports.Resume = exports.Angle = exports.Institution = exports.Redo = exports.Chevron = exports.Link = exports.Bullseye = exports.Truck = exports.MinusCircled = exports.PauseCircled = exports.Location = exports.PushPin = exports.RSS = exports.Warning = exports.Video = exports.Unlock = exports.TextFile = exports.Tag = exports.Summary = exports.StarHalf = exports.StarFull = exports.StarEmpty = exports.Spinner = exports.ShelfItem = exports.SexualContent = exports.Search = exports.Remove = exports.Quotation = exports.Printer = exports.Plus = exports.PencilEdit = exports.Pencil = exports.PaperPlane = exports.OffensiveLanguage = exports.NewTab = exports.More = exports.Minus = exports.Lock = exports.ListView = exports.Laptop = exports.JacketView = exports.Info = exports.IconWithBackground = exports.GroupedView = exports.GraphicViolence = exports.FrighteningScenes = exports.RightArrowCircled = exports.Flag = exports.Filter = exports.Failure = exports.Eye = exports.Cross = exports.ContentAdvisory = exports.Comment = exports.CogAlternate = exports.Cog = exports.Clock = exports.CheckmarkCircle = exports.Checkmark = exports.Carets = exports.Cancel = exports.CalendarEmpty = exports.Books = exports.CompactDisc = exports.Newspaper = exports.GameController = exports.VideoCamera = exports.MusicalNote = exports.Headphones = exports.Device = exports.Book = exports.AccessibleFormat = exports.Attention = exports.Arrows = undefined;
	
	var _Arrows = __webpack_require__(104);
	
	Object.defineProperty(exports, 'Arrows', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Arrows).default;
	  }
	});
	
	var _Attention = __webpack_require__(124);
	
	Object.defineProperty(exports, 'Attention', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Attention).default;
	  }
	});
	
	var _AccessibleFormat = __webpack_require__(95);
	
	Object.defineProperty(exports, 'AccessibleFormat', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccessibleFormat).default;
	  }
	});
	
	var _Book = __webpack_require__(128);
	
	Object.defineProperty(exports, 'Book', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Book).default;
	  }
	});
	
	var _Device = __webpack_require__(171);
	
	Object.defineProperty(exports, 'Device', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Device).default;
	  }
	});
	
	var _Headphones = __webpack_require__(195);
	
	Object.defineProperty(exports, 'Headphones', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Headphones).default;
	  }
	});
	
	var _MusicalNote = __webpack_require__(227);
	
	Object.defineProperty(exports, 'MusicalNote', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MusicalNote).default;
	  }
	});
	
	var _VideoCamera = __webpack_require__(287);
	
	Object.defineProperty(exports, 'VideoCamera', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoCamera).default;
	  }
	});
	
	var _GameController = __webpack_require__(189);
	
	Object.defineProperty(exports, 'GameController', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GameController).default;
	  }
	});
	
	var _Newspaper = __webpack_require__(231);
	
	Object.defineProperty(exports, 'Newspaper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Newspaper).default;
	  }
	});
	
	var _CompactDisc = __webpack_require__(165);
	
	Object.defineProperty(exports, 'CompactDisc', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CompactDisc).default;
	  }
	});
	
	var _Books = __webpack_require__(130);
	
	Object.defineProperty(exports, 'Books', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Books).default;
	  }
	});
	
	var _CalendarEmpty = __webpack_require__(136);
	
	Object.defineProperty(exports, 'CalendarEmpty', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CalendarEmpty).default;
	  }
	});
	
	var _Cancel = __webpack_require__(140);
	
	Object.defineProperty(exports, 'Cancel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cancel).default;
	  }
	});
	
	var _Carets = __webpack_require__(145);
	
	Object.defineProperty(exports, 'Carets', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Carets).default;
	  }
	});
	
	var _Checkmark = __webpack_require__(149);
	
	Object.defineProperty(exports, 'Checkmark', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkmark).default;
	  }
	});
	
	var _CheckmarkCircle = __webpack_require__(151);
	
	Object.defineProperty(exports, 'CheckmarkCircle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckmarkCircle).default;
	  }
	});
	
	var _Clock = __webpack_require__(157);
	
	Object.defineProperty(exports, 'Clock', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Clock).default;
	  }
	});
	
	var _Cog = __webpack_require__(159);
	
	Object.defineProperty(exports, 'Cog', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cog).default;
	  }
	});
	
	var _CogAlternate = __webpack_require__(161);
	
	Object.defineProperty(exports, 'CogAlternate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CogAlternate).default;
	  }
	});
	
	var _Comment = __webpack_require__(163);
	
	Object.defineProperty(exports, 'Comment', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Comment).default;
	  }
	});
	
	var _ContentAdvisory = __webpack_require__(167);
	
	Object.defineProperty(exports, 'ContentAdvisory', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ContentAdvisory).default;
	  }
	});
	
	var _Cross = __webpack_require__(169);
	
	Object.defineProperty(exports, 'Cross', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cross).default;
	  }
	});
	
	var _Eye = __webpack_require__(177);
	
	Object.defineProperty(exports, 'Eye', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Eye).default;
	  }
	});
	
	var _Failure = __webpack_require__(179);
	
	Object.defineProperty(exports, 'Failure', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Failure).default;
	  }
	});
	
	var _Filter = __webpack_require__(183);
	
	Object.defineProperty(exports, 'Filter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Filter).default;
	  }
	});
	
	var _Flag = __webpack_require__(185);
	
	Object.defineProperty(exports, 'Flag', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Flag).default;
	  }
	});
	
	var _RightArrowCircled = __webpack_require__(259);
	
	Object.defineProperty(exports, 'RightArrowCircled', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RightArrowCircled).default;
	  }
	});
	
	var _FrighteningScenes = __webpack_require__(187);
	
	Object.defineProperty(exports, 'FrighteningScenes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FrighteningScenes).default;
	  }
	});
	
	var _GraphicViolence = __webpack_require__(191);
	
	Object.defineProperty(exports, 'GraphicViolence', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GraphicViolence).default;
	  }
	});
	
	var _GroupedView = __webpack_require__(193);
	
	Object.defineProperty(exports, 'GroupedView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupedView).default;
	  }
	});
	
	var _IconWithBackground = __webpack_require__(199);
	
	Object.defineProperty(exports, 'IconWithBackground', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconWithBackground).default;
	  }
	});
	
	var _Info = __webpack_require__(201);
	
	Object.defineProperty(exports, 'Info', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Info).default;
	  }
	});
	
	var _JacketView = __webpack_require__(205);
	
	Object.defineProperty(exports, 'JacketView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JacketView).default;
	  }
	});
	
	var _Laptop = __webpack_require__(207);
	
	Object.defineProperty(exports, 'Laptop', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Laptop).default;
	  }
	});
	
	var _ListView = __webpack_require__(213);
	
	Object.defineProperty(exports, 'ListView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListView).default;
	  }
	});
	
	var _Lock = __webpack_require__(217);
	
	Object.defineProperty(exports, 'Lock', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Lock).default;
	  }
	});
	
	var _Minus = __webpack_require__(221);
	
	Object.defineProperty(exports, 'Minus', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Minus).default;
	  }
	});
	
	var _More = __webpack_require__(225);
	
	Object.defineProperty(exports, 'More', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_More).default;
	  }
	});
	
	var _NewTab = __webpack_require__(229);
	
	Object.defineProperty(exports, 'NewTab', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NewTab).default;
	  }
	});
	
	var _OffensiveLanguage = __webpack_require__(233);
	
	Object.defineProperty(exports, 'OffensiveLanguage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OffensiveLanguage).default;
	  }
	});
	
	var _PaperPlane = __webpack_require__(235);
	
	Object.defineProperty(exports, 'PaperPlane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PaperPlane).default;
	  }
	});
	
	var _Pencil = __webpack_require__(239);
	
	Object.defineProperty(exports, 'Pencil', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pencil).default;
	  }
	});
	
	var _PencilEdit = __webpack_require__(241);
	
	Object.defineProperty(exports, 'PencilEdit', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PencilEdit).default;
	  }
	});
	
	var _Plus = __webpack_require__(243);
	
	Object.defineProperty(exports, 'Plus', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Plus).default;
	  }
	});
	
	var _Printer = __webpack_require__(245);
	
	Object.defineProperty(exports, 'Printer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Printer).default;
	  }
	});
	
	var _Quotation = __webpack_require__(249);
	
	Object.defineProperty(exports, 'Quotation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Quotation).default;
	  }
	});
	
	var _Remove = __webpack_require__(255);
	
	Object.defineProperty(exports, 'Remove', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Remove).default;
	  }
	});
	
	var _Search = __webpack_require__(261);
	
	Object.defineProperty(exports, 'Search', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Search).default;
	  }
	});
	
	var _SexualContent = __webpack_require__(263);
	
	Object.defineProperty(exports, 'SexualContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SexualContent).default;
	  }
	});
	
	var _ShelfItem = __webpack_require__(265);
	
	Object.defineProperty(exports, 'ShelfItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfItem).default;
	  }
	});
	
	var _Spinner = __webpack_require__(267);
	
	Object.defineProperty(exports, 'Spinner', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Spinner).default;
	  }
	});
	
	var _StarEmpty = __webpack_require__(269);
	
	Object.defineProperty(exports, 'StarEmpty', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarEmpty).default;
	  }
	});
	
	var _StarFull = __webpack_require__(271);
	
	Object.defineProperty(exports, 'StarFull', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarFull).default;
	  }
	});
	
	var _StarHalf = __webpack_require__(273);
	
	Object.defineProperty(exports, 'StarHalf', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarHalf).default;
	  }
	});
	
	var _Summary = __webpack_require__(275);
	
	Object.defineProperty(exports, 'Summary', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Summary).default;
	  }
	});
	
	var _Tag = __webpack_require__(277);
	
	Object.defineProperty(exports, 'Tag', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tag).default;
	  }
	});
	
	var _TextFile = __webpack_require__(279);
	
	Object.defineProperty(exports, 'TextFile', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextFile).default;
	  }
	});
	
	var _Unlock = __webpack_require__(283);
	
	Object.defineProperty(exports, 'Unlock', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Unlock).default;
	  }
	});
	
	var _Video = __webpack_require__(285);
	
	Object.defineProperty(exports, 'Video', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Video).default;
	  }
	});
	
	var _Warning = __webpack_require__(289);
	
	Object.defineProperty(exports, 'Warning', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Warning).default;
	  }
	});
	
	var _RSS = __webpack_require__(251);
	
	Object.defineProperty(exports, 'RSS', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RSS).default;
	  }
	});
	
	var _PushPin = __webpack_require__(247);
	
	Object.defineProperty(exports, 'PushPin', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PushPin).default;
	  }
	});
	
	var _Location = __webpack_require__(215);
	
	Object.defineProperty(exports, 'Location', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Location).default;
	  }
	});
	
	var _PauseCircled = __webpack_require__(237);
	
	Object.defineProperty(exports, 'PauseCircled', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PauseCircled).default;
	  }
	});
	
	var _MinusCircled = __webpack_require__(223);
	
	Object.defineProperty(exports, 'MinusCircled', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MinusCircled).default;
	  }
	});
	
	var _Truck = __webpack_require__(281);
	
	Object.defineProperty(exports, 'Truck', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Truck).default;
	  }
	});
	
	var _Bullseye = __webpack_require__(134);
	
	Object.defineProperty(exports, 'Bullseye', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bullseye).default;
	  }
	});
	
	var _Link = __webpack_require__(209);
	
	Object.defineProperty(exports, 'Link', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Link).default;
	  }
	});
	
	var _Chevron = __webpack_require__(155);
	
	Object.defineProperty(exports, 'Chevron', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chevron).default;
	  }
	});
	
	var _Redo = __webpack_require__(253);
	
	Object.defineProperty(exports, 'Redo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Redo).default;
	  }
	});
	
	var _Institution = __webpack_require__(203);
	
	Object.defineProperty(exports, 'Institution', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Institution).default;
	  }
	});
	
	var _Angle = __webpack_require__(98);
	
	Object.defineProperty(exports, 'Angle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Angle).default;
	  }
	});
	
	var _Resume = __webpack_require__(257);
	
	Object.defineProperty(exports, 'Resume', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Resume).default;
	  }
	});
	
	var _Bars = __webpack_require__(126);
	
	Object.defineProperty(exports, 'Bars', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bars).default;
	  }
	});
	
	var _ExternalArrow = __webpack_require__(175);
	
	Object.defineProperty(exports, 'ExternalArrow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExternalArrow).default;
	  }
	});
	
	var _List = __webpack_require__(211);
	
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	
	var _CalendarWarning = __webpack_require__(138);
	
	Object.defineProperty(exports, 'CalendarWarning', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CalendarWarning).default;
	  }
	});
	
	var _Card = __webpack_require__(142);
	
	Object.defineProperty(exports, 'Card', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	
	var _Ellipsis = __webpack_require__(173);
	
	Object.defineProperty(exports, 'Ellipsis', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Ellipsis).default;
	  }
	});
	
	var _BorrowingHistoryIcon = __webpack_require__(132);
	
	Object.defineProperty(exports, 'BorrowingHistoryIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingHistoryIcon).default;
	  }
	});
	
	var _CheckedOutIcon = __webpack_require__(147);
	
	Object.defineProperty(exports, 'CheckedOutIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutIcon).default;
	  }
	});
	
	var _Fees = __webpack_require__(181);
	
	Object.defineProperty(exports, 'Fees', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Fees).default;
	  }
	});
	
	var _HoldsIcon = __webpack_require__(197);
	
	Object.defineProperty(exports, 'HoldsIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsIcon).default;
	  }
	});
	
	var _MessagesIcon = __webpack_require__(219);
	
	Object.defineProperty(exports, 'MessagesIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessagesIcon).default;
	  }
	});
	
	__webpack_require__(308);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ function(module, exports) {

	module.exports = _;

/***/ },
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(13);
	
	Object.defineProperty(exports, 'Button', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_button).default;
	  }
	});
	
	var _default = __webpack_require__(347);
	
	Object.defineProperty(exports, 'DefaultButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_default).default;
	  }
	});
	
	var _ghost = __webpack_require__(72);
	
	Object.defineProperty(exports, 'GhostButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ghost).default;
	  }
	});
	
	var _highlight = __webpack_require__(350);
	
	Object.defineProperty(exports, 'HighlightButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_highlight).default;
	  }
	});
	
	var _primary = __webpack_require__(354);
	
	Object.defineProperty(exports, 'PrimaryButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_primary).default;
	  }
	});
	
	var _remove = __webpack_require__(356);
	
	Object.defineProperty(exports, 'RemoveButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_remove).default;
	  }
	});
	
	var _secondary = __webpack_require__(358);
	
	Object.defineProperty(exports, 'SecondaryButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_secondary).default;
	  }
	});
	
	var _text = __webpack_require__(360);
	
	Object.defineProperty(exports, 'TextButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_text).default;
	  }
	});
	
	var _transactional = __webpack_require__(362);
	
	Object.defineProperty(exports, 'TransactionalButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_transactional).default;
	  }
	});
	
	var _blueCaretArrow = __webpack_require__(342);
	
	Object.defineProperty(exports, 'BlueCaretArrowButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_blueCaretArrow).default;
	  }
	});
	
	var _primaryGhostButton = __webpack_require__(352);
	
	Object.defineProperty(exports, 'PrimaryGhostButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_primaryGhostButton).default;
	  }
	});
	
	var _blueTextButton = __webpack_require__(344);
	
	Object.defineProperty(exports, 'BlueTextButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_blueTextButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.policyShape = exports.materialPolicyShape = exports.availabilityShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bibBriefShape = __webpack_require__(40);
	
	var _bibBriefShape2 = _interopRequireDefault(_bibBriefShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var availabilityShape = exports.availabilityShape = _reactImmutableProptypes2.default.mapContains({
	  availabilityLocationType: _react.PropTypes.string,
	  availableCopies: _react.PropTypes.number,
	  bibType: _react.PropTypes.string,
	  circulationType: _react.PropTypes.string,
	  eresourceDescription: _react.PropTypes.string,
	  eresourceUrl: _react.PropTypes.string,
	  heldCopies: _react.PropTypes.number,
	  libraryUseOnly: _react.PropTypes.bool,
	  localisedStatus: _react.PropTypes.string,
	  metadataId: _react.PropTypes.string,
	  singleBranch: _react.PropTypes.bool,
	  status: _react.PropTypes.string,
	  totalCopies: _react.PropTypes.number
	});
	
	var materialPolicyShape = exports.materialPolicyShape = _reactImmutableProptypes2.default.mapContains({
	  externalAPI: _react.PropTypes.bool,
	  healthy: _react.PropTypes.bool,
	  helpUrl: _react.PropTypes.string,
	  itemLevelHoldsPredetermined: _react.PropTypes.bool,
	  quickStartUrl: _react.PropTypes.string,
	  requiresDuration: _react.PropTypes.bool,
	  requiresEmailDuringHold: _react.PropTypes.bool,
	  requiresFormatDuringCheckout: _react.PropTypes.bool,
	  requiresFormatDuringHold: _react.PropTypes.bool,
	  showFormatDuringCheckout: _react.PropTypes.bool,
	  showFormatDuringHold: _react.PropTypes.bool,
	  showQuickstartLink: _react.PropTypes.bool,
	  supportAutoCheckout: _react.PropTypes.bool,
	  supportsBatchVolumeHolds: _react.PropTypes.bool,
	  supportsDownload: _react.PropTypes.bool,
	  supportsFastAvailability: _react.PropTypes.bool,
	  supportsReadNow: _react.PropTypes.bool,
	  supportsSuspendHold: _react.PropTypes.bool
	});
	
	var policyShape = exports.policyShape = _reactImmutableProptypes2.default.mapContains({
	  holdable: _react.PropTypes.bool,
	  itemLevelHoldableItems: _react.PropTypes.bool,
	  materialPolicy: materialPolicyShape,
	  materialType: _react.PropTypes.string,
	  provider: _react.PropTypes.string
	});
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  availability: availabilityShape,
	  briefInfo: _bibBriefShape2.default,
	  id: _react.PropTypes.string,
	  policy: policyShape
	});

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(83)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(90);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ },
/* 39 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.jacketShape = exports.ratingShape = exports.seriesShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var seriesShape = exports.seriesShape = _reactImmutableProptypes2.default.mapContains({
	  name: _react.PropTypes.string,
	  sortName: _react.PropTypes.string,
	  volume: _react.PropTypes.string,
	  volumeNumber: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
	});
	
	var ratingShape = exports.ratingShape = _reactImmutableProptypes2.default.mapContains({
	  averageRating: _react.PropTypes.number,
	  totalCount: _react.PropTypes.number
	});
	
	var jacketShape = exports.jacketShape = _reactImmutableProptypes2.default.mapContains({
	  large: _react.PropTypes.string,
	  local_url: _react.PropTypes.string,
	  medium: _react.PropTypes.string,
	  small: _react.PropTypes.string,
	  type: _react.PropTypes.string
	});
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  authors: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  callNumber: _react.PropTypes.string,
	  consumptionFormat: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  edition: _react.PropTypes.string,
	  format: _react.PropTypes.string,
	  id: _react.PropTypes.string,
	  isbns: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  jacket: jacketShape,
	  metadataId: _react.PropTypes.string,
	  multiscriptAuthor: _react.PropTypes.string,
	  multiscriptTitle: _react.PropTypes.string,
	  primaryLanguage: _react.PropTypes.string,
	  publicationDate: _react.PropTypes.string,
	  rating: ratingShape,
	  series: _reactImmutableProptypes2.default.listOf(seriesShape),
	  subtitle: _react.PropTypes.string,
	  superFormats: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  title: _react.PropTypes.string
	});

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  code: _react.PropTypes.string,
	  name: _react.PropTypes.string
	});

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var filterShape = _react.PropTypes.shape({
	  value: _react.PropTypes.string,
	  count: _react.PropTypes.number,
	  label: _react.PropTypes.string
	});
	
	exports.default = filterShape;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  branchId: _react.PropTypes.string,
	  enabled: _react.PropTypes.bool,
	  holdsDurationExpiration: _react.PropTypes.number
	});

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var siteShape = _reactImmutableProptypes2.default.contains({
	  siteId: _react.PropTypes.string,
	  libraryId: _react.PropTypes.number,
	  shortName: _react.PropTypes.string,
	  longName: _react.PropTypes.string,
	  logo: _react.PropTypes.string,
	  domain: _react.PropTypes.string
	});
	
	exports.default = siteShape;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userIdentityShape = _reactImmutableProptypes2.default.contains({
	  name: _react.PropTypes.string.isRequired,
	  id: _react.PropTypes.number.isRequired,
	  active: _react.PropTypes.bool.isRequired,
	  avatar: _react.PropTypes.string,
	  homeLibrary: _react.PropTypes.string.isRequired,
	  homeLibrarySubdomain: _react.PropTypes.string.isRequired,
	  homeLibraryFullName: _react.PropTypes.string.isRequired,
	  homePatron: _react.PropTypes.bool.isRequired,
	  staff: _react.PropTypes.bool.isRequired
	});
	
	exports.default = userIdentityShape;

/***/ },
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScreenReaderMessage = __webpack_require__(375);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScreenReaderMessage).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GhostButton = __webpack_require__(348);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GhostButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.shallowEquals = shallowEquals;
	exports.isEmpty = isEmpty;
	
	var _immutable = __webpack_require__(23);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var is = _immutable2.default.is.bind(_immutable2.default);
	
	/* Implementation of shallowEquals that supports ImmutableJS structures */
	function shallowEquals(a, b) {
	  if (a === b || is(a, b)) {
	    return true;
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object' || a === null || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== 'object' || b === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
	  // eslint-disable-next-line no-restricted-syntax
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = keysA[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var key = _step.value;
	
	      if (!bHasOwnProperty(key) || !is(a[key], b[key])) {
	        return false;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return true;
	}
	
	/* isEmpty that supports both native arrays/objects and Immutable iterables (lists, maps, etc) */
	function isEmpty(obj) {
	  if (_immutable2.default.Iterable.isIterable(obj)) {
	    return obj.isEmpty();
	  }
	
	  return _lodash2.default.isEmpty(obj);
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(76)['default'];
	exports['default'] = exports;


/***/ },
/* 75 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Function.prototype.bind implementation from Mozilla Developer Network:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
	
	"use strict";
	
	var bind = Function.prototype.bind || function (oThis) {
	    if (typeof this !== 'function') {
	      // closest thing possible to the ECMAScript 5
	      // internal IsCallable function
	      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	    }
	
	    var aArgs   = Array.prototype.slice.call(arguments, 1),
	        fToBind = this,
	        fNOP    = function() {},
	        fBound  = function() {
	          return fToBind.apply(this instanceof fNOP
	                 ? this
	                 : oThis,
	                 aArgs.concat(Array.prototype.slice.call(arguments)));
	        };
	
	    if (this.prototype) {
	      // native functions don't have a prototype
	      fNOP.prototype = this.prototype;
	    }
	    fBound.prototype = new fNOP();
	
	    return fBound;
	};
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jshint esnext: true */
	
	"use strict";
	var src$es5$$ = __webpack_require__(75);
	exports["default"] = createFormatCache;
	
	// -----------------------------------------------------------------------------
	
	function createFormatCache(FormatConstructor) {
	    var cache = src$es5$$.objCreate(null);
	
	    return function () {
	        var args    = Array.prototype.slice.call(arguments);
	        var cacheId = getCacheId(args);
	        var format  = cacheId && cache[cacheId];
	
	        if (!format) {
	            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();
	
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	
	        return format;
	    };
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function getCacheId(inputs) {
	    // When JSON is not available in the runtime, we will not create a cache id.
	    if (typeof JSON === 'undefined') { return; }
	
	    var cacheId = [];
	
	    var i, len, input;
	
	    for (i = 0, len = inputs.length; i < len; i += 1) {
	        input = inputs[i];
	
	        if (input && typeof input === 'object') {
	            cacheId.push(orderedProps(input));
	        } else {
	            cacheId.push(input);
	        }
	    }
	
	    return JSON.stringify(cacheId);
	}
	
	function orderedProps(obj) {
	    var props = [],
	        keys  = [];
	
	    var key, i, len, prop;
	
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	        }
	    }
	
	    var orderedKeys = keys.sort();
	
	    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
	        key  = orderedKeys[i];
	        prop = {};
	
	        prop[key] = obj[key];
	        props[i]  = prop;
	    }
	
	    return props;
	}
	
	//# sourceMappingURL=memoizer.js.map

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(78)['default'];
	exports['default'] = exports;


/***/ },
/* 78 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  /*
	   * Generated by PEG.js 0.8.0.
	   *
	   * http://pegjs.majda.cz/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function SyntaxError(message, expected, found, offset, line, column) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.offset   = offset;
	    this.line     = line;
	    this.column   = column;
	
	    this.name     = "SyntaxError";
	  }
	
	  peg$subclass(SyntaxError, Error);
	
	  function parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = [],
	        peg$c1 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements
	                };
	            },
	        peg$c2 = peg$FAILED,
	        peg$c3 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c4 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText
	                };
	            },
	        peg$c5 = /^[^ \t\n\r,.+={}#]/,
	        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c7 = "{",
	        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c9 = null,
	        peg$c10 = ",",
	        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c12 = "}",
	        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c14 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2]
	                };
	            },
	        peg$c15 = "number",
	        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c17 = "date",
	        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c19 = "time",
	        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c21 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2]
	                };
	            },
	        peg$c22 = "plural",
	        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                };
	            },
	        peg$c25 = "selectordinal",
	        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c27 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                }
	            },
	        peg$c28 = "select",
	        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c30 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options
	                };
	            },
	        peg$c31 = "=",
	        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c33 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern
	                };
	            },
	        peg$c34 = "offset:",
	        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c36 = function(number) {
	                return number;
	            },
	        peg$c37 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options
	                };
	            },
	        peg$c38 = { type: "other", description: "whitespace" },
	        peg$c39 = /^[ \t\n\r]/,
	        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c41 = { type: "other", description: "optionalWhitespace" },
	        peg$c42 = /^[0-9]/,
	        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c44 = /^[0-9a-f]/i,
	        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c46 = "0",
	        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c48 = /^[1-9]/,
	        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c50 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
	        peg$c53 = "\\\\",
	        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c55 = function() { return '\\'; },
	        peg$c56 = "\\#",
	        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c58 = function() { return '\\#'; },
	        peg$c59 = "\\{",
	        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c61 = function() { return '\u007B'; },
	        peg$c62 = "\\}",
	        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c64 = function() { return '\u007D'; },
	        peg$c65 = "\\u",
	        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c67 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c68 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$reportedPos      = 0,
	        peg$cachedPos        = 0,
	        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$reportedPos, peg$currPos);
	    }
	
	    function offset() {
	      return peg$reportedPos;
	    }
	
	    function line() {
	      return peg$computePosDetails(peg$reportedPos).line;
	    }
	
	    function column() {
	      return peg$computePosDetails(peg$reportedPos).column;
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        peg$reportedPos
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(message, null, peg$reportedPos);
	    }
	
	    function peg$computePosDetails(pos) {
	      function advance(details, startPos, endPos) {
	        var p, ch;
	
	        for (p = startPos; p < endPos; p++) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	        }
	      }
	
	      if (peg$cachedPos !== pos) {
	        if (peg$cachedPos > pos) {
	          peg$cachedPos = 0;
	          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
	        }
	        advance(peg$cachedPosDetails, peg$cachedPos, pos);
	        peg$cachedPos = pos;
	      }
	
	      return peg$cachedPosDetails;
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, pos) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      var posDetails = peg$computePosDetails(pos),
	          found      = pos < input.length ? input.charAt(pos) : null;
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        pos,
	        posDetails.line,
	        posDetails.column
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$c2;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$c2;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$c2;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c3(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c4(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c5.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c6); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c5.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	          }
	        } else {
	          s1 = peg$c2;
	        }
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c7;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c8); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c10;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c11); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$c2;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$c2;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = peg$c9;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c12;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c14(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c15) {
	        s1 = peg$c15;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c16); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c17) {
	          s1 = peg$c17;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c18); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c19) {
	            s1 = peg$c19;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c20); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c10;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$c2;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$c2;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$c2;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = peg$c9;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c21(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c28) {
	        s1 = peg$c28;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$c2;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c30(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c31;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$c2;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c7;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c8); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c12;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$reportedPos = s0;
	                      s1 = peg$c33(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c34) {
	        s1 = peg$c34;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c36(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = peg$c9;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$c2;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c37(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c39.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c40); }
	          }
	        }
	      } else {
	        s0 = peg$c2;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c41); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c42.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c43); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c44.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c45); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c46;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c47); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c48.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c49); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	        if (s2 !== peg$FAILED) {
	          s2 = input.substring(s1, peg$currPos);
	        }
	        s1 = s2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c50(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c51.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c52); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c53) {
	          s1 = peg$c53;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c54); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$reportedPos = s0;
	          s1 = peg$c55();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c56) {
	            s1 = peg$c56;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c57); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c58();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c59) {
	              s1 = peg$c59;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c60); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$reportedPos = s0;
	              s1 = peg$c61();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c62) {
	                s1 = peg$c62;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c63); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c64();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c65) {
	                  s1 = peg$c65;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$c2;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$c2;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$c2;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s3 = input.substring(s2, peg$currPos);
	                  }
	                  s2 = s3;
	                  if (s2 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c67(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c68(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
	    }
	  }
	
	  return {
	    SyntaxError: SyntaxError,
	    parse:       parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ },
/* 79 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value) {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(39), src$es5$$ = __webpack_require__(82), src$compiler$$ = __webpack_require__(79), intl$messageformat$parser$$ = __webpack_require__(77);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	        return messageFormat._format(pattern, values);
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	            throw new Error('A value must be provided for: ' + id);
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 81 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(39);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 83 */
[1483, 80, 81],
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(89)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(91);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(38), src$diff$$ = __webpack_require__(86), src$es5$$ = __webpack_require__(88);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45,  // seconds to minute
	        minute: 45,  // minutes to hour
	        hour  : 22,  // hours to day
	        day   : 26,  // days to month
	        month : 11   // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	
	    for (i = 0, l = FIELDS.length; i < l; i += 1) {
	        units = FIELDS[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 86 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond: millisecond,
	        second     : second,
	        minute     : minute,
	        hour       : hour,
	        day        : day,
	        week       : week,
	        month      : month,
	        year       : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map

/***/ },
/* 87 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 88 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 89 */
[1483, 85, 87],
/* 90 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 91 */
90,
/* 92 */
90,
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _utilsImmutable = __webpack_require__(73);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BcReactComponent = function (_Component) {
	  _inherits(BcReactComponent, _Component);
	
	  function BcReactComponent() {
	    _classCallCheck(this, BcReactComponent);
	
	    return _possibleConstructorReturn(this, (BcReactComponent.__proto__ || Object.getPrototypeOf(BcReactComponent)).apply(this, arguments));
	  }
	
	  _createClass(BcReactComponent, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          location = _props.location,
	          params = _props.params;
	      var nextLocation = nextProps.location,
	          nextParams = nextProps.params;
	
	
	      if (this.routerWillUpdate && location && params && nextLocation && nextParams) {
	        if (nextParams !== params || nextLocation.query !== location.query) {
	          this.routerWillUpdate(nextProps);
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _utilsImmutable.shallowEquals)(this.props, nextProps) || !(0, _utilsImmutable.shallowEquals)(this.state, nextState);
	    }
	  }, {
	    key: 'bindAll',
	    value: function bindAll() {
	      var _this2 = this;
	
	      for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
	        methods[_key] = arguments[_key];
	      }
	
	      methods.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }]);
	
	  return BcReactComponent;
	}(_react.Component);
	
	BcReactComponent.propTypes = {
	  location: _react.PropTypes.objectOf(_react.PropTypes.any),
	  params: _react.PropTypes.objectOf(_react.PropTypes.string)
	};
	
	exports.default = BcReactComponent;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var AccessibleFormat = function AccessibleFormat(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-accessible-format ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M11.328125,7.734375 L8.671875,14.765625 C10.21875,14.78125 11.765625,14.828125 13.3125,14.828125 C13.609375,14.828125 13.90625,14.8125 14.203125,14.796875 C13.390625,12.421875 12.4375,10 11.328125,7.734375 Z M0,25 L0.03125,23.765625 C1.5,23.3125 3.09375,23.625 3.75,21.9375 L7.453125,12.3125 L11.828125,1 L13.828125,1 C13.890625,1.109375 13.953125,1.21875 14,1.328125 L17.203125,8.828125 C18.375,11.59375 19.453125,14.390625 20.640625,17.140625 C21.34375,18.765625 21.890625,20.4375 22.671875,22.03125 C22.78125,22.28125 23,22.75 23.21875,22.921875 C23.734375,23.328125 25.171875,23.421875 25.90625,23.703125 C25.953125,24 26,24.296875 26,24.59375 C26,24.734375 25.984375,24.859375 25.984375,25 C24,25 22.015625,24.75 20.03125,24.75 C17.984375,24.75 15.9375,24.921875 13.890625,24.984375 C13.890625,24.578125 13.90625,24.171875 13.953125,23.765625 L16,23.328125 C16.421875,23.234375 17.25,23.125 17.25,22.546875 C17.25,21.984375 15.234375,17.34375 14.984375,16.703125 L7.953125,16.671875 C7.546875,17.578125 5.96875,21.671875 5.96875,22.265625 C5.96875,23.46875 8.265625,23.515625 9.15625,23.640625 C9.171875,23.9375 9.171875,24.234375 9.171875,24.546875 C9.171875,24.6875 9.15625,24.828125 9.140625,24.96875 C7.328125,24.96875 5.5,24.65625 3.6875,24.65625 C3.46875,24.65625 3.15625,24.75 2.9375,24.78125 C1.953125,24.953125 0.984375,25 0,25 Z' })
	  );
	};
	
	AccessibleFormat.propTypes = _bcPropTypes.iconShape;
	
	exports.default = AccessibleFormat;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccessibleFormat = __webpack_require__(94);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccessibleFormat).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AngleLeft;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function AngleLeft(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: 'icon-svg-angle-left ' + className,
	      focusable: 'false',
	      'aria-hidden': true,
	      width: width,
	      height: height,
	      viewBox: '0 0 8 14' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M8,1.16432866 C8,1.27655311 7.94501718,1.40280561 7.86254296,1.48697395 L2.4604811,7 L7.86254296,12.5130261 C7.94501718,12.5971944 8,12.7234469 8,12.8356713 C8,12.9478958 7.94501718,13.0741483 7.86254296,13.1583166 L7.17525773,13.8597194 C7.09278351,13.9438878 6.96907216,14 6.85910653,14 C6.74914089,14 6.62542955,13.9438878 6.54295533,13.8597194 L0.137457045,7.32264529 C0.0549828179,7.23847695 0,7.11222445 0,7 C0,6.88777555 0.0549828179,6.76152305 0.137457045,6.67735471 L6.54295533,0.140280561 C6.62542955,0.0561122244 6.74914089,0 6.85910653,0 C6.96907216,0 7.09278351,0.0561122244 7.17525773,0.140280561 L7.86254296,0.841683367 C7.94501718,0.925851703 8,1.03807615 8,1.16432866 Z' })
	  );
	}
	
	AngleLeft.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AngleRight;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function AngleRight(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: 'icon-svg-angle-right ' + className,
	      focusable: 'false',
	      'aria-hidden': true,
	      width: width,
	      height: height,
	      viewBox: '0 0 8 14' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M8,1.16432866 C8,1.27655311 7.94501718,1.40280561 7.86254296,1.48697395 L2.4604811,7 L7.86254296,12.5130261 C7.94501718,12.5971944 8,12.7234469 8,12.8356713 C8,12.9478958 7.94501718,13.0741483 7.86254296,13.1583166 L7.17525773,13.8597194 C7.09278351,13.9438878 6.96907216,14 6.85910653,14 C6.74914089,14 6.62542955,13.9438878 6.54295533,13.8597194 L0.137457045,7.32264529 C0.0549828179,7.23847695 0,7.11222445 0,7 C0,6.88777555 0.0549828179,6.76152305 0.137457045,6.67735471 L6.54295533,0.140280561 C6.62542955,0.0561122244 6.74914089,0 6.85910653,0 C6.96907216,0 7.09278351,0.0561122244 7.17525773,0.140280561 L7.86254296,0.841683367 C7.94501718,0.925851703 8,1.03807615 8,1.16432866 Z', transform: 'matrix(-1 0 0 1 8 0)' })
	  );
	}
	
	AngleRight.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Right = __webpack_require__(97);
	
	var _Right2 = _interopRequireDefault(_Right);
	
	var _Left = __webpack_require__(96);
	
	var _Left2 = _interopRequireDefault(_Left);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { Left: _Left2.default, Right: _Right2.default };

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Down;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Down(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-arrows-font-awesome-down ' + className,
	      viewBox: '0 0 1792 1792',
	      width: width,
	      height: height },
	    _react2.default.createElement('path', { fill: color, d: 'M1675 832q0 53-37 90l-651 652q-39 37-91 37-53 0-90-37l-651-652q-38-36-38-90 0-53 38-91l74-75q39-37 91-37 53 0 90 37l294 294v-704q0-52 38-90t90-38h128q52 0 90 38t38 90v704l294-294q37-37 90-37 52 0 91 37l75 75q37 39 37 91z' })
	  );
	}
	
	Down.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 100 */
[1430, 99],
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Up;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Up(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-arrows-font-awesome-up ' + className,
	      viewBox: '0 0 1792 1792',
	      width: width,
	      height: height },
	    _react2.default.createElement('path', { fill: color, d: 'M1675 971q0 51-37 90l-75 75q-38 38-91 38-54 0-90-38l-294-293v704q0 52-37.5 84.5t-90.5 32.5h-128q-53 0-90.5-32.5t-37.5-84.5v-704l-294 293q-36 38-90 38t-90-38l-75-75q-38-38-38-90 0-53 38-91l651-651q35-37 90-37 54 0 91 37l651 651q37 39 37 91z' })
	  );
	}
	
	Up.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Up = __webpack_require__(101);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Up).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Up = __webpack_require__(102);
	
	var _Up2 = _interopRequireDefault(_Up);
	
	var _Down = __webpack_require__(100);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Up: _Up2.default,
	  Down: _Down2.default
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _light = __webpack_require__(111);
	
	var _light2 = _interopRequireDefault(_light);
	
	var _medium = __webpack_require__(120);
	
	var _medium2 = _interopRequireDefault(_medium);
	
	var _long = __webpack_require__(116);
	
	var _long2 = _interopRequireDefault(_long);
	
	var _fontAwesome = __webpack_require__(103);
	
	var _fontAwesome2 = _interopRequireDefault(_fontAwesome);
	
	var _move = __webpack_require__(122);
	
	var _move2 = _interopRequireDefault(_move);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  light: _light2.default,
	  medium: _medium2.default,
	  long: _long2.default,
	  fontAwesome: _fontAwesome2.default,
	  move: _move2.default
	}; /*
	    * Exports
	    */

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function LightDown(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-arrows-light-down ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M16 5.5l-1-1-7 7-7-7-1 1 8 8 8-8z' })
	  );
	}
	
	LightDown.propTypes = _bcPropTypes.iconShape;
	
	exports.default = LightDown;

/***/ },
/* 106 */
[1430, 105],
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LightLeft;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function LightLeft(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-arrows-light-left ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M10.5 16l1-1-7-7 7-7-1-1-8 8 8 8z' })
	  );
	}
	
	LightLeft.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 108 */
[1446, 107],
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LightRight;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function LightRight(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-arrows-light-right ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M5.5 0l-1 1 7 7-7 7 1 1 8-8-8-8z' })
	  );
	}
	
	LightRight.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 110 */
[1467, 109],
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Down = __webpack_require__(106);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	var _Left = __webpack_require__(108);
	
	var _Left2 = _interopRequireDefault(_Left);
	
	var _Right = __webpack_require__(110);
	
	var _Right2 = _interopRequireDefault(_Right);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { Down: _Down2.default, Left: _Left2.default, Right: _Right2.default }; /*
	                                                                                           * Exports
	                                                                                           */

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function LongLeft(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-arrows-long-left ' + className,
	      viewBox: '0 0 1792 1792',
	      width: width,
	      height: height },
	    _react2.default.createElement('path', { d: 'M1792 800v192q0 14-9 23t-23 9h-1248v224q0 21-19 29t-35-5l-384-350q-10-10-10-23 0-14 10-24l384-354q16-14 35-6 19 9 19 29v224h1248q14 0 23 9t9 23z' })
	  );
	}
	
	LongLeft.propTypes = _bcPropTypes.iconShape;
	exports.default = LongLeft;

/***/ },
/* 113 */
[1446, 112],
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function LongRight(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-arrows-long-right ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { d: 'M10 13.5l5.5-5.5-5.5-5.5v4.5h-9v2h9z' })
	  );
	}
	
	LongRight.propTypes = _bcPropTypes.iconShape;
	exports.default = LongRight;

/***/ },
/* 115 */
[1467, 114],
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Right = __webpack_require__(115);
	
	var _Right2 = _interopRequireDefault(_Right);
	
	var _Left = __webpack_require__(113);
	
	var _Left2 = _interopRequireDefault(_Left);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Exports
	 */
	exports.default = { Right: _Right2.default, Left: _Left2.default };

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function MediumDown(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-arrow-medium-down ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M16 5.5l-2-2-6 6-6-6-2 2 8 8 8-8z' })
	  );
	}
	
	MediumDown.propTypes = _bcPropTypes.iconShape;
	
	exports.default = MediumDown;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MediumSortArrows;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function MediumSortArrows(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-sort-arrows ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M12 7l-4-4-4 4zM4 10l4 4 4-4z' })
	  );
	}
	
	MediumSortArrows.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MediumUp(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-arrow-medium-up ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M0 10.5l2 2 6-6 6 6 2-2-8-8-8 8z' })
	  );
	}
	
	MediumUp.propTypes = _bcPropTypes.iconShape;
	
	exports.default = MediumUp;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Down = __webpack_require__(117);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	var _Up = __webpack_require__(119);
	
	var _Up2 = _interopRequireDefault(_Up);
	
	var _SortArrows = __webpack_require__(118);
	
	var _SortArrows2 = _interopRequireDefault(_SortArrows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Down: _Down2.default,
	  Up: _Up2.default,
	  SortArrows: _SortArrows2.default
	}; /*
	    * Exports
	    */

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function MoveRight(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { xmlns: 'http://www.w3.org/2000/svg', focusable: 'false', className: 'icon-svg-arrow-move ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13.5000137,8.08594476 C13.5000137,8.35157007 13.3984511,8.60938288 13.2109509,8.7968831 L8.1250073,13.8828267 C7.93750708,14.0625144 7.67969427,14.1718895 7.41406895,14.1718895 C7.14844364,14.1718895 6.89844334,14.0625144 6.71094312,13.8828267 L6.12500492,13.2968885 C5.93750469,13.1093882 5.82812956,12.8515754 5.82812956,12.5859501 C5.82812956,12.3203248 5.93750469,12.062512 6.12500492,11.8750118 L8.41407015,9.58594654 L2.91406359,9.58594654 C2.35156292,9.58594654 2,9.11719598 2,8.58594535 L2,7.58594416 C2,7.05469353 2.35156292,6.58594297 2.91406359,6.58594297 L8.41407015,6.58594297 L6.12500492,4.28906523 C5.93750469,4.10937751 5.82812956,3.85156471 5.82812956,3.58593939 C5.82812956,3.32031407 5.93750469,3.06250127 6.12500492,2.88281355 L6.71094312,2.29687535 C6.89844334,2.10937513 7.14844364,2 7.41406895,2 C7.67969427,2 7.93750708,2.10937513 8.1250073,2.29687535 L13.2109509,7.38281892 C13.3984511,7.56250663 13.5000137,7.82031944 13.5000137,8.08594476 Z' })
	  );
	}
	
	MoveRight.propTypes = _bcPropTypes.iconShape;
	
	exports.default = MoveRight;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Right = __webpack_require__(121);
	
	var _Right2 = _interopRequireDefault(_Right);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Right: _Right2.default
	}; /*
	    * Exports
	    */

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	var Attention = function (_BcReactComponent) {
	  _inherits(Attention, _BcReactComponent);
	
	  function Attention() {
	    _classCallCheck(this, Attention);
	
	    return _possibleConstructorReturn(this, (Attention.__proto__ || Object.getPrototypeOf(Attention)).apply(this, arguments));
	  }
	
	  _createClass(Attention, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          xmlns: 'http://www.w3.org/2000/svg',
	          focusable: 'false',
	          'aria-hidden': true,
	          className: 'icon-svg-failure ' + className,
	          preserveAspectRatio: 'xMinYMin meet',
	          viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M16,8 C16,9.44086038 15.6397848,10.7741935 14.9193548,12 C14.1989249,13.2258065 13.2258065,14.1989249 12,14.9193548 C10.7741935,15.6397848 9.44086038,16 8,16 C6.55913962,16 5.22580645,15.6397848 4,14.9193548 C2.77419355,14.1989249 1.8010751,13.2258065 1.08064516,12 C0.360215218,10.7741935 0,9.44086038 0,8 C0,6.55913962 0.360215218,5.22580645 1.08064516,4 C1.8010751,2.77419355 2.77419355,1.8010751 4,1.08064516 C5.22580645,0.360215218 6.55913962,0 8,0 C9.44086038,0 10.7741935,0.360215218 12,1.08064516 C13.2258065,1.8010751 14.1989249,2.77419355 14.9193548,4 C15.6397848,5.22580645 16,6.55913962 16,8 Z M8,9.61290323 C7.59139769,9.61290323 7.24193548,9.75806452 6.9516129,10.0483871 C6.66129032,10.3387097 6.51612903,10.6881719 6.51612903,11.0967742 C6.51612903,11.5053765 6.66129032,11.8548387 6.9516129,12.1451613 C7.24193548,12.4354839 7.59139769,12.5806452 8,12.5806452 C8.40860231,12.5806452 8.75806452,12.4354839 9.0483871,12.1451613 C9.33870968,11.8548387 9.48387097,11.5053765 9.48387097,11.0967742 C9.48387097,10.6881719 9.33870968,10.3387097 9.0483871,10.0483871 C8.75806452,9.75806452 8.40860231,9.61290323 8,9.61290323 Z M6.58064516,4.29032258 L6.83870968,8.67741935 C6.83870968,8.76344102 6.87634425,8.84408619 6.9516129,8.91935484 C7.02688156,8.99462349 7.11827973,9.03225806 7.22580645,9.03225806 L8.77419355,9.03225806 C8.88172027,9.03225806 8.97311844,8.99462349 9.0483871,8.91935484 C9.12365575,8.84408619 9.16129032,8.76344102 9.16129032,8.67741935 L9.41935484,4.29032258 C9.41935484,4.16129032 9.38172027,4.05913962 9.30645161,3.98387097 C9.23118296,3.90860231 9.13978478,3.87096774 9.03225806,3.87096774 L6.96774194,3.87096774 C6.86021522,3.87096774 6.76881704,3.90860231 6.69354839,3.98387097 C6.61827973,4.05913962 6.58064516,4.16129032 6.58064516,4.29032258 Z' })
	      );
	    }
	  }]);
	
	  return Attention;
	}(_baseBcReactComponent2.default);
	
	Attention.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Attention;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Attention = __webpack_require__(123);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Attention).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Bars;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Bars(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-failure', className),
	      preserveAspectRatio: 'xMinYMin meet',
	      viewBox: '0 0 1792 1792',
	      xmlns: 'http://www.w3.org/2000/svg' },
	    _react2.default.createElement('path', { d: 'M1664 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z' })
	  );
	}
	
	Bars.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Bars = __webpack_require__(125);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bars).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Book = function Book(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-book ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M24.481,0.9998 C24.301,0.9998 24.116,1.0328 23.934,1.1028 L13.546,5.0978 C13.37,5.1658 13.185,5.1998 13,5.1998 C12.815,5.1998 12.63,5.1658 12.454,5.0978 L2.066,1.1028 C1.884,1.0328 1.7,0.9998 1.519,0.9998 C0.714,0.9998 0,1.6498 0,2.5218 L0,11.3078 L0,20.2638 C0,20.8928 0.388,21.4568 0.975,21.6828 L12.454,26.0978 C12.63,26.1658 12.815,26.1998 13,26.1998 C13.185,26.1998 13.37,26.1658 13.546,26.0978 L25.025,21.6828 C25.612,21.4568 26,20.8928 26,20.2638 L26,11.3078 L26,2.5218 C26,1.6498 25.286,0.9998 24.481,0.9998 M2,3.2198 L11.736,6.9648 C12.141,7.1208 12.566,7.1998 13,7.1998 C13.434,7.1998 13.859,7.1208 14.264,6.9648 L24,3.2198 L24,11.3078 L24,19.9348 L13,24.1658 L2,19.9348 L2,11.3078 L2,3.2198' }),
	      _react2.default.createElement('path', { stroke: color, strokeWidth: '2', d: 'M13,6.3079 L13,25.3079' }),
	      _react2.default.createElement('path', { fill: color, d: 'M4.5,10.7888 L4.5,9.2888 L10,11.4038 L10,12.9038 L4.5,10.7888 Z M4.5,15.7888 L4.5,14.2888 L10,16.4038 L10,17.9038 L4.5,15.7888 Z M22,10.7888 L16.5,12.9038 L16.5,11.4038 L22,9.2888 L22,10.7888 Z M22,15.7888 L16.5,17.9038 L16.5,16.4038 L22,14.2888 L22,15.7888 Z' })
	    )
	  );
	};
	
	Book.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Book;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Book = __webpack_require__(127);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Book).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Books;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Books(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 18 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-books ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M3.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM3 5h-2v-1h2v1z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M8.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM8 5h-2v-1h2v1z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M11.954 2.773l-2.679 1.35c-0.246 0.124-0.345 0.426-0.222 0.671l4.5 8.93c0.124 0.246 0.426 0.345 0.671 0.222l2.679-1.35c0.246-0.124 0.345-0.426 0.222-0.671l-4.5-8.93c-0.124-0.246-0.426-0.345-0.671-0.222z' })
	  );
	}
	
	Books.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Books = __webpack_require__(129);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Books).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingHistoryIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function BorrowingHistoryIcon(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-borrowing-history ' + className,
	      width: width, height: height,
	      viewBox: '0 0 48 48' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M33.6825001,37.9975414 C33.6825001,39.8319368 33.2239011,41.5294367 32.3067037,43.0900416 C31.3895063,44.6506465 30.1506048,45.889548 28.5899999,46.8067454 C27.029395,47.7239428 25.3318951,48.1825418 23.4974997,48.1825418 C22.320201,48.1825418 21.1839716,47.984044 20.08881,47.5870478 C18.9936485,47.1900516 17.994314,46.6356262 17.0908059,45.9237716 C16.8717738,45.7321181 16.7554125,45.4925518 16.7417232,45.2050719 C16.7280339,44.9175921 16.8307053,44.6643358 17.0497373,44.4453038 L17.5014914,43.9935497 C17.6657656,43.8292755 17.8779533,43.7402934 18.1380539,43.7266041 C18.3981545,43.7129148 18.6240315,43.7745177 18.815685,43.9114126 C20.1846364,45.0065742 21.7452413,45.5541546 23.4974997,45.5541546 C24.8664511,45.5541546 26.1327318,45.2187612 27.2963406,44.5479751 C28.4599493,43.877189 29.3771473,42.959991 30.0479334,41.7963823 C30.7187195,40.6327736 31.0541129,39.3664929 31.0541129,37.9975414 C31.0541129,36.6285899 30.7187195,35.3623092 30.0479334,34.1987005 C29.3771473,33.0350918 28.4599493,32.1178938 27.2963406,31.4471077 C26.1327318,30.7763216 24.8664511,30.4409282 23.4974997,30.4409282 C22.5118545,30.4409282 21.5741228,30.6188917 20.684304,30.9748193 C19.7944852,31.330747 19.0073384,31.8372589 18.3228624,32.4943557 L20.4173584,34.5888517 C20.6090119,34.7805052 20.6500804,35.0132265 20.5405641,35.2870171 C20.4310477,35.5608076 20.225705,35.6977026 19.9245358,35.6977026 L13.9695961,35.6977026 C13.7779426,35.6977026 13.6205134,35.6360998 13.4973077,35.5128941 C13.3741021,35.3896885 13.3124993,35.2322592 13.3124993,35.0406058 L13.3124993,29.085666 C13.3124993,28.7844969 13.4493942,28.5791541 13.7231848,28.4696378 C13.9969753,28.3601214 14.2296967,28.40119 14.4213501,28.5928434 L16.4747776,30.6462709 C17.405665,29.7427628 18.4734473,29.0445975 19.6781245,28.5517749 C20.8828018,28.0589523 22.1559268,27.812541 23.4974997,27.812541 C25.3318951,27.812541 27.029395,28.27114 28.5899999,29.1883374 C30.1506048,30.1055348 31.3895063,31.3375913 32.3067037,32.8845069 C33.2239011,34.4314225 33.6825001,36.1357673 33.6825001,37.9975414 Z M26.2490925,41.2008883 C26.0848183,41.4199204 25.8657863,41.549971 25.5919957,41.5910395 C25.3182052,41.6321081 25.0717939,41.5705053 24.8527618,41.4062311 L22.1833061,39.311735 L22.1833061,33.7264122 C22.1833061,33.4526216 22.2791325,33.2199003 22.4707859,33.0282468 C22.6624394,32.8365934 22.8951607,32.740767 23.1689513,32.740767 L23.8260481,32.740767 C24.0998386,32.740767 24.33256,32.8365934 24.5242134,33.0282468 C24.7158669,33.2199003 24.8116933,33.4526216 24.8116933,33.7264122 L24.8116933,37.9975414 L26.4955038,39.311735 C26.7145359,39.4760092 26.8377415,39.6950413 26.8651208,39.9688318 C26.8925,40.2426223 26.8240522,40.4890336 26.659778,40.7080657 L26.2490925,41.2008883 Z' }),
	      _react2.default.createElement('path', { fill: color, d: 'M46,2 L2,2 C0.897,2 0,2.897 0,4 L0,37 C0,38.103 0.897,39 2,39 L9.814,39 C9.644,38.19 9.555,37.353 9.525,36.5 L2.5,36.5 L2.5,4.5 L45.5,4.5 L45.5,36.5 L38.475,36.5 C38.445,37.353 38.356,38.19 38.186,39 L46,39 C47.103,39 48,38.103 48,37 L48,4 C48,2.897 47.103,2 46,2' }),
	      _react2.default.createElement('polygon', { fill: color, points: '0 18 48 18 48 10 0 10' })
	    )
	  );
	}
	
	BorrowingHistoryIcon.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingHistoryIcon = __webpack_require__(131);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingHistoryIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Bullseye;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Bullseye(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-bullseye ' + className, width: width, height: height, viewBox: '0 0 1792 1792' },
	    _react2.default.createElement('path', { d: 'M1152 896q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zm128 0q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5zm128 0q0 212-150 362t-362 150-362-150-150-362 150-362 362-150 362 150 150 362zm128 0q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zm128 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z' })
	  );
	}
	
	Bullseye.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Bullseye = __webpack_require__(133);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bullseye).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CalendarEmpty;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function CalendarEmpty(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-calendar-empty ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('rect', { stroke: color, width: '12.5', height: '12.5', x: '1.75', y: '2.75', strokeWidth: '1.5', rx: '1.5' }),
	      _react2.default.createElement('path', { fill: color, d: 'M5.69999999,3 L10.3,3 C10.1343146,3 10,2.86568542 10,2.69999999 L10,0.300000012 C10,0.13431458 10.1343146,3.043592e-17 10.3,0 L11.7,0 C11.8656854,-3.043592e-17 12,0.13431458 12,0.300000012 L12,2.69999999 C12,2.86568542 11.8656854,3 11.7,3 L14,3 L14,5 L2,5 L2,3 L4.30000001,3 C4.13431458,3 4,2.86568542 4,2.69999999 L4,0.300000012 C4,0.13431458 4.13431458,3.043592e-17 4.30000001,0 L5.69999999,0 C5.86568542,-3.043592e-17 6,0.13431458 6,0.300000012 L6,2.69999999 C6,2.86568542 5.86568542,3 5.69999999,3 Z' })
	    )
	  );
	}
	
	CalendarEmpty.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CalendarEmpty = __webpack_require__(135);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CalendarEmpty).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CalendarWarning;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function CalendarWarning(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-calendar-warning', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M7.1125,6.33593751 C7.1125,6.24635411 7.1416666,6.16796876 7.2,6.10078125 C7.2583334,6.03359375 7.3291666,6 7.4125,6 L8.5875,6 C8.6708334,6 8.7416666,6.03359375 8.8,6.10078125 C8.8583334,6.16796876 8.8875,6.24635411 8.8875,6.33593751 L8.7125,9.99093768 C8.7125,10.0805211 8.6833334,10.1544273 8.625,10.2126564 C8.5666666,10.2708855 8.4958334,10.3000002 8.4125,10.3000002 L7.5875,10.3000002 C7.5041666,10.3000002 7.4333334,10.2708855 7.375,10.2126564 C7.3166666,10.1544273 7.2875,10.0805211 7.2875,9.99093768 L7.1125,6.33593751 Z' }),
	      _react2.default.createElement('circle', { cx: '8', cy: '12', r: '1' }),
	      _react2.default.createElement('rect', { stroke: color, width: '12.5', height: '12.5', x: '1.75', y: '2.75', strokeWidth: '1.5', rx: '1.5' }),
	      _react2.default.createElement('path', { fill: color, d: 'M5.69999999,3 L10.3,3 C10.1343146,3 10,2.86568542 10,2.69999999 L10,0.300000012 C10,0.13431458 10.1343146,-2.50752312e-17 10.3,-5.55111512e-17 L11.7,0 C11.8656854,-3.043592e-17 12,0.13431458 12,0.300000012 L12,2.69999999 C12,2.86568542 11.8656854,3 11.7,3 L14,3 L14,5 L2,5 L2,3 L4.30000001,3 C4.13431458,3 4,2.86568542 4,2.69999999 L4,0.300000012 C4,0.13431458 4.13431458,-2.50752312e-17 4.30000001,-5.55111512e-17 L5.69999999,0 C5.86568542,-3.043592e-17 6,0.13431458 6,0.300000012 L6,2.69999999 C6,2.86568542 5.86568542,3 5.69999999,3 Z' })
	    )
	  );
	}
	
	CalendarWarning.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CalendarWarning = __webpack_require__(137);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CalendarWarning).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Cancel(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? '' : _ref$title;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-cancel ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    title ? _react2.default.createElement(
	      'title',
	      null,
	      title
	    ) : null,
	    _react2.default.createElement('path', { fill: color, d: 'M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM12 10.5l-1.5 1.5-2.5-2.5-2.5 2.5-1.5-1.5 2.5-2.5-2.5-2.5 1.5-1.5 2.5 2.5 2.5-2.5 1.5 1.5-2.5 2.5 2.5 2.5z' })
	  );
	}
	
	Cancel.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Cancel;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cancel = __webpack_require__(139);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cancel).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Card;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Card(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-card ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 18 18' },
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('rect', { id: 'borrowing-a', width: '18', height: '14', y: '2', rx: '2' })
	    ),
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('use', { fill: '', fillOpacity: '0', xlinkHref: '#borrowing-a' }),
	      _react2.default.createElement('rect', { stroke: color, width: '16.5', height: '12.5', x: '.75', y: '2.75', strokeWidth: '1.5', rx: '2' }),
	      _react2.default.createElement('rect', { fill: color, width: '17', height: '3', y: '6' })
	    )
	  );
	}
	
	Card.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Card = __webpack_require__(141);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function LightDown(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 8 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 14 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-carets-down ' + className, width: width, height: height, viewBox: '0 0 8 14' },
	    _react2.default.createElement('path', { fill: color, d: 'M8 5.5q0 0.203-0.148 0.352l-3.5 3.5q-0.148 0.148-0.352 0.148t-0.352-0.148l-3.5-3.5q-0.148-0.148-0.148-0.352t0.148-0.352 0.352-0.148h7q0.203 0 0.352 0.148t0.148 0.352z' })
	  );
	}
	
	LightDown.propTypes = _bcPropTypes.iconShape;
	
	exports.default = LightDown;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Down = __webpack_require__(143);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Down2.default;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Down = __webpack_require__(144);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Down: _Down2.default
	};

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CheckedOutIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function CheckedOutIcon(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-checked-out-icon ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 48 48' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M8.8569,16.9219 C8.8569,16.8279 8.9029,16.7349 8.9959,16.6409 C9.0879,16.5469 9.1799,16.4999 9.2729,16.4999 L23.9419,16.4999 C24.0339,16.4999 24.1269,16.5469 24.2189,16.6409 C24.3109,16.7349 24.3569,16.8279 24.3569,16.9219 L24.3569,18.3279 C24.3569,18.4219 24.3109,18.5159 24.2189,18.6089 C24.1269,18.7029 24.0339,18.7499 23.9419,18.7499 L9.2729,18.7499 C9.1799,18.7499 9.0879,18.7029 8.9959,18.6089 C8.9029,18.5159 8.8569,18.4219 8.8569,18.3279 L8.8569,16.9219 Z M8.8569,12.4219 C8.8569,12.3279 8.9029,12.2349 8.9959,12.1409 C9.0879,12.0469 9.1799,11.9999 9.2729,11.9999 L23.9419,11.9999 C24.0339,11.9999 24.1269,12.0469 24.2189,12.1409 C24.3109,12.2349 24.3569,12.3279 24.3569,12.4219 L24.3569,13.8279 C24.3569,13.9219 24.3109,14.0159 24.2189,14.1089 C24.1269,14.2029 24.0339,14.2499 23.9419,14.2499 L9.2729,14.2499 C9.1799,14.2499 9.0879,14.2029 8.9959,14.1089 C8.9029,14.0159 8.8569,13.9219 8.8569,13.8279 L8.8569,12.4219 Z M21.5249,34.4999 L6.6429,34.4999 C6.0429,34.4999 5.5239,34.2769 5.0859,33.8319 C4.6479,33.3869 4.4289,32.8599 4.4289,32.2499 C4.4289,31.6409 4.6479,31.1129 5.0859,30.6679 C5.5239,30.2229 6.0429,29.9999 6.6429,29.9999 L22.0719,29.9999 C23.3479,25.5509 26.6909,21.9889 30.9999,20.4039 L30.9999,4.6879 C30.9999,4.2189 30.8379,3.8199 30.5159,3.4919 C30.1929,3.1639 29.8009,2.9999 29.3389,2.9999 L6.6429,2.9999 C4.7979,2.9999 3.2289,3.6559 1.9379,4.9689 C0.6459,6.2809 -0.0001,7.8749 -0.0001,9.7499 L-0.0001,32.2499 C-0.0001,34.1249 0.6459,35.7189 1.9379,37.0309 C3.2289,38.3439 4.7979,38.9999 6.6429,38.9999 L22.4039,38.9999 C21.8839,37.5889 21.5789,36.0779 21.5249,34.4999 Z' }),
	      _react2.default.createElement('path', { fill: color, d: 'M48,34 C48,36.161 47.459,38.161 46.379,40 C45.298,41.839 43.839,43.298 42,44.379 C40.161,45.459 38.161,46 36,46 C33.839,46 31.839,45.459 30,44.379 C28.161,43.298 26.702,41.839 25.621,40 C24.541,38.161 24,36.161 24,34 C24,31.839 24.541,29.839 25.621,28 C26.702,26.161 28.161,24.702 30,23.621 C31.839,22.541 33.839,22 36,22 C38.161,22 40.161,22.541 42,23.621 C43.839,24.702 45.298,26.161 46.379,28 C47.459,29.839 48,31.839 48,34 Z M26.323,34 C26.323,35.742 26.758,37.355 27.629,38.839 C28.5,40.323 29.677,41.5 31.161,42.371 C32.645,43.242 34.258,43.677 36,43.677 C37.742,43.677 39.355,43.242 40.839,42.371 C42.323,41.5 43.5,40.323 44.371,38.839 C45.242,37.355 45.677,35.742 45.677,34 C45.677,32.258 45.242,30.645 44.371,29.161 C43.5,27.677 42.323,26.5 40.839,25.629 C39.355,24.758 37.742,24.323 36,24.323 C34.258,24.323 32.645,24.758 31.161,25.629 C29.677,26.5 28.5,27.677 27.629,29.161 C26.758,30.645 26.323,32.258 26.323,34 Z M29.807,33.032 C29.807,32.871 29.863,32.734 29.976,32.621 C30.089,32.508 30.226,32.452 30.387,32.452 L36,32.452 L36,29.209 C36,28.952 36.121,28.774 36.363,28.677 C36.605,28.581 36.807,28.613 36.968,28.774 L41.807,33.564 C41.903,33.693 41.952,33.839 41.952,34 C41.952,34.161 41.903,34.307 41.807,34.436 L37.016,39.177 C36.823,39.371 36.605,39.419 36.363,39.323 C36.121,39.226 36,39.048 36,38.791 L36,35.548 L30.387,35.548 C30.226,35.548 30.089,35.492 29.976,35.379 C29.863,35.266 29.807,35.129 29.807,34.968 L29.807,33.032 Z' })
	    )
	  );
	}
	
	CheckedOutIcon.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutIcon = __webpack_require__(146);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Checkmark;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Checkmark(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-checkmark ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M13.5 2l-7.5 7.5-3.5-3.5-2.5 2.5 6 6 10-10z' })
	  );
	}
	
	Checkmark.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Checkmark = __webpack_require__(148);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkmark).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function CheckmarkCircle(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-checkmark-circle ' + className,
	      preserveAspectRatio: 'xMinYMin meet',
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { color: color, fillRule: 'evenodd', d: 'M16,8 C16,9.44086038 15.6397848,10.7741935 14.9193548,12 C14.1989249,13.2258065 13.2258065,14.1989249 12,14.9193548 C10.7741935,15.6397848 9.44086038,16 8,16 C6.55913962,16 5.22580645,15.6397848 4,14.9193548 C2.77419355,14.1989249 1.8010751,13.2258065 1.08064516,12 C0.360215218,10.7741935 0,9.44086038 0,8 C0,6.55913962 0.360215218,5.22580645 1.08064516,4 C1.8010751,2.77419355 2.77419355,1.8010751 4,1.08064516 C5.22580645,0.360215218 6.55913962,0 8,0 C9.44086038,0 10.7741935,0.360215218 12,1.08064516 C13.2258065,1.8010751 14.1989249,2.77419355 14.9193548,4 C15.6397848,5.22580645 16,6.55913962 16,8 Z M7.06451613,12.2258065 L13,6.29032258 C13.1075267,6.20430091 13.1612903,6.08602167 13.1612903,5.93548387 C13.1612903,5.78494607 13.1075267,5.66666683 13,5.58064516 L12.2903226,4.83870968 C12.1827959,4.73118296 12.0591396,4.67741935 11.9193548,4.67741935 C11.7795701,4.67741935 11.6559138,4.73118296 11.5483871,4.83870968 L6.70967742,9.67741935 L4.4516129,7.41935484 C4.34408619,7.31182812 4.22042994,7.25806452 4.08064516,7.25806452 C3.94086038,7.25806452 3.81720414,7.31182812 3.70967742,7.41935484 L3,8.16129032 C2.89247328,8.24731199 2.83870968,8.36559123 2.83870968,8.51612903 C2.83870968,8.66666683 2.89247328,8.78494607 3,8.87096774 L6.35483871,12.2258065 C6.44086038,12.3333332 6.55913962,12.3870968 6.70967742,12.3870968 C6.86021522,12.3870968 6.97849446,12.3333332 7.06451613,12.2258065 Z' })
	  );
	}
	
	CheckmarkCircle.propTypes = {
	  className: _react.PropTypes.string,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  color: _react.PropTypes.string
	};
	
	exports.default = CheckmarkCircle;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckmarkCircle = __webpack_require__(150);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckmarkCircle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DoubleRight;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function DoubleRight(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 10 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 18 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      className: 'icon-svg-chevron-double-right ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 10 18' },
	    _react2.default.createElement('path', { d: 'M5.9765625,8.21428571 C5.9765625,8.30133972 5.94308069,8.37834788 5.87611607,8.4453125 L1.1953125,13.1261161 C1.12834788,13.1930807 1.05133972,13.2265625 0.964285714,13.2265625 C0.877231708,13.2265625 0.800223549,13.1930807 0.733258929,13.1261161 L0.231026786,12.6238839 C0.164062165,12.5569193 0.130580357,12.4799111 0.130580357,12.3928571 C0.130580357,12.3058031 0.164062165,12.228795 0.231026786,12.1618304 L4.17857143,8.21428571 L0.231026786,4.26674107 C0.164062165,4.19977645 0.130580357,4.12276829 0.130580357,4.03571429 C0.130580357,3.94866028 0.164062165,3.87165212 0.231026786,3.8046875 L0.733258929,3.30245536 C0.800223549,3.23549074 0.877231708,3.20200893 0.964285714,3.20200893 C1.05133972,3.20200893 1.12834788,3.23549074 1.1953125,3.30245536 L5.87611607,7.98325893 C5.94308069,8.05022355 5.9765625,8.12723171 5.9765625,8.21428571 Z M9.83370536,8.21428571 C9.83370536,8.30133972 9.80022355,8.37834788 9.73325893,8.4453125 L5.05245536,13.1261161 C4.98549074,13.1930807 4.90848258,13.2265625 4.82142857,13.2265625 C4.73437456,13.2265625 4.65736641,13.1930807 4.59040179,13.1261161 L4.08816964,12.6238839 C4.02120502,12.5569193 3.98772321,12.4799111 3.98772321,12.3928571 C3.98772321,12.3058031 4.02120502,12.228795 4.08816964,12.1618304 L8.03571429,8.21428571 L4.08816964,4.26674107 C4.02120502,4.19977645 3.98772321,4.12276829 3.98772321,4.03571429 C3.98772321,3.94866028 4.02120502,3.87165212 4.08816964,3.8046875 L4.59040179,3.30245536 C4.65736641,3.23549074 4.73437456,3.20200893 4.82142857,3.20200893 C4.90848258,3.20200893 4.98549074,3.23549074 5.05245536,3.30245536 L9.73325893,7.98325893 C9.80022355,8.05022355 9.83370536,8.12723171 9.83370536,8.21428571 Z' })
	  );
	}
	
	DoubleRight.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Left;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Left(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      className: 'icon-svg-chevron-left ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 28 28' },
	    _react2.default.createElement('path', { fill: '#404344', fillRule: 'evenodd', d: 'M20.1424139,6.0918399 L12.2342538,14 L20.1424139,21.9081601 C20.5147378,22.280484 20.5147378,22.8762023 20.1424139,23.2485262 L17.6701831,25.7207571 C17.2978591,26.093081 16.7021409,26.093081 16.3298169,25.7207571 L5.27924294,14.6701831 C4.90691902,14.2978591 4.90691902,13.7021409 5.27924294,13.3298169 L16.3298169,2.27924294 C16.7021409,1.90691902 17.2978591,1.90691902 17.6701831,2.27924294 L20.1424139,4.75147378 C20.5147378,5.1237977 20.5147378,5.71951598 20.1424139,6.0918399 Z' })
	  );
	}
	
	Left.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Right;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Right(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      className: 'icon-svg-chevron-right ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 28 28' },
	    _react2.default.createElement('path', { fill: '#404344', fillRule: 'evenodd', d: 'M22.7207571,6.0918399 L14.812597,14 L22.7207571,21.9081601 C23.093081,22.280484 23.093081,22.8762023 22.7207571,23.2485262 L20.2485262,25.7207571 C19.8762023,26.093081 19.280484,26.093081 18.9081601,25.7207571 L7.8575861,14.6701831 C7.48526218,14.2978591 7.48526218,13.7021409 7.8575861,13.3298169 L18.9081601,2.27924294 C19.280484,1.90691902 19.8762023,1.90691902 20.2485262,2.27924294 L22.7207571,4.75147378 C23.093081,5.1237977 23.093081,5.71951598 22.7207571,6.0918399 Z', transform: 'matrix(-1 0 0 1 30.578 0)' })
	  );
	}
	
	Right.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Left = __webpack_require__(153);
	
	var _Left2 = _interopRequireDefault(_Left);
	
	var _Right = __webpack_require__(154);
	
	var _Right2 = _interopRequireDefault(_Right);
	
	var _DoubleRight = __webpack_require__(152);
	
	var _DoubleRight2 = _interopRequireDefault(_DoubleRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { Left: _Left2.default, Right: _Right2.default, DoubleRight: _DoubleRight2.default };

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Clock(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-clock ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 12 12' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M12,6 C12,9.313 9.313,12 6,12 C2.687,12 0,9.313 0,6 C0,2.687 2.687,0 6,0 C9.313,0 12,2.687 12,6' }),
	      _react2.default.createElement('path', { fill: '#FFF', d: 'M10.75,6 C10.75,8.624 8.624,10.75 6,10.75 C3.376,10.75 1.25,8.624 1.25,6 C1.25,3.376 3.376,1.25 6,1.25 C8.624,1.25 10.75,3.376 10.75,6' }),
	      _react2.default.createElement('path', { fill: color, d: 'M5.4434,6.8228 C5.3624,6.7588 5.3224,6.6768 5.3224,6.5808 L5.3224,2.6128 C5.3224,2.5318 5.3504,2.4638 5.4074,2.4068 C5.4644,2.3508 5.5324,2.3228 5.6124,2.3228 L6.3874,2.3228 C6.4674,2.3228 6.5364,2.3508 6.5924,2.4068 C6.6494,2.4638 6.6774,2.5318 6.6774,2.6128 L6.6774,6.0488 L8.2984,7.2098 C8.3624,7.2588 8.3994,7.3228 8.4074,7.4038 C8.4154,7.4838 8.3954,7.5568 8.3464,7.6208 L7.9114,8.2498 C7.8624,8.3148 7.7984,8.3548 7.7174,8.3708 C7.6374,8.3868 7.5644,8.3708 7.5004,8.3228 L5.4434,6.8228 Z' })
	    )
	  );
	}
	
	Clock.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Clock;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Clock = __webpack_require__(156);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Clock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Cog;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Cog(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-cog ' + className, width: width, height: height, viewBox: '0 0 1792 1792' },
	    _react2.default.createElement('path', { fill: color, d: 'M1152 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm512-109v222q0 12-8 23t-20 13l-185 28q-19 54-39 91 35 50 107 138 10 12 10 25t-9 23q-27 37-99 108t-94 71q-12 0-26-9l-138-108q-44 23-91 38-16 136-29 186-7 28-36 28h-222q-14 0-24.5-8.5t-11.5-21.5l-28-184q-49-16-90-37l-141 107q-10 9-25 9-14 0-25-11-126-114-165-168-7-10-7-23 0-12 8-23 15-21 51-66.5t54-70.5q-27-50-41-99l-183-27q-13-2-21-12.5t-8-23.5v-222q0-12 8-23t19-13l186-28q14-46 39-92-40-57-107-138-10-12-10-24 0-10 9-23 26-36 98.5-107.5t94.5-71.5q13 0 26 10l138 107q44-23 91-38 16-136 29-186 7-28 36-28h222q14 0 24.5 8.5t11.5 21.5l28 184q49 16 90 37l142-107q9-9 24-9 13 0 25 10 129 119 165 170 7 8 7 22 0 12-8 23-15 21-51 66.5t-54 70.5q26 50 41 98l183 28q13 2 21 12.5t8 23.5z' })
	  );
	}
	
	Cog.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cog = __webpack_require__(158);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cog).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CogAlternate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function CogAlternate(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-cog-alternate ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M16 9.501v-3.003l-2.293-0.382c-0.093-0.283-0.207-0.557-0.339-0.82l1.351-1.891-2.123-2.123-1.888 1.349c-0.264-0.134-0.54-0.248-0.825-0.342l-0.381-2.288h-3.003l-0.381 2.288c-0.285 0.094-0.56 0.209-0.824 0.342l-1.888-1.349-2.123 2.123 1.351 1.891c-0.132 0.263-0.246 0.537-0.339 0.82l-2.293 0.382v3.003l2.299 0.383c0.093 0.281 0.206 0.552 0.338 0.813l-1.355 1.898 2.123 2.123 1.901-1.358c0.259 0.13 0.53 0.243 0.809 0.335l0.384 2.304h3.003l0.384-2.304c0.279-0.092 0.549-0.204 0.809-0.335l1.901 1.358 2.123-2.123-1.355-1.898c0.132-0.261 0.245-0.532 0.338-0.813l2.299-0.383zM8 10c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z' })
	  );
	}
	
	CogAlternate.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CogAlternate = __webpack_require__(160);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CogAlternate).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var Comment = function (_BcReactComponent) {
	  _inherits(Comment, _BcReactComponent);
	
	  function Comment() {
	    _classCallCheck(this, Comment);
	
	    return _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).apply(this, arguments));
	  }
	
	  _createClass(Comment, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-comment ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M8 1c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z' })
	      );
	    }
	  }]);
	
	  return Comment;
	}(_baseBcReactComponent2.default);
	
	Comment.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Comment;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Comment = __webpack_require__(162);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Comment).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var CompactDisc = function CompactDisc(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-compact-disc ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M13,0 C5.82,0 0,5.82 0,13 C0,20.18 5.82,26 13,26 C20.18,26 26,20.18 26,13 C26,5.82 20.18,0 13,0 M13,1.4 C19.396,1.4 24.6,6.604 24.6,13 C24.6,19.396 19.396,24.6 13,24.6 C6.604,24.6 1.4,19.396 1.4,13 C1.4,6.604 6.604,1.4 13,1.4' }),
	      _react2.default.createElement('path', { fill: color, d: 'M13,8 C10.239,8 8,10.239 8,13 C8,15.761 10.239,18 13,18 C15.761,18 18,15.761 18,13 C18,10.239 15.761,8 13,8 M13,9.4 C14.985,9.4 16.6,11.015 16.6,13 C16.6,14.985 14.985,16.6 13,16.6 C11.015,16.6 9.4,14.985 9.4,13 C9.4,11.015 11.015,9.4 13,9.4' }),
	      _react2.default.createElement('path', { fill: color, d: 'M13,11 C11.896,11 11,11.896 11,13 C11,14.104 11.896,15 13,15 C14.104,15 15,14.104 15,13 C15,11.896 14.104,11 13,11 M13,11.75 C13.689,11.75 14.25,12.311 14.25,13 C14.25,13.689 13.689,14.25 13,14.25 C12.311,14.25 11.75,13.689 11.75,13 C11.75,12.311 12.311,11.75 13,11.75' }),
	      _react2.default.createElement('path', { fill: color, fillRule: 'nonzero', d: 'M18.6666857,15.0978788 C18.7445143,14.905952 18.9631943,14.813457 19.1551212,14.8912857 C19.347048,14.9691143 19.439543,15.1877943 19.3617143,15.3797212 C19.0275712,16.2037247 18.5302482,16.9570819 17.8881506,17.5991793 C17.244699,18.2415914 16.4921158,18.7385803 15.6691212,19.0723143 C15.4771943,19.150143 15.2585143,19.057648 15.1806857,18.8657212 C15.102857,18.6737943 15.195352,18.4551143 15.3872788,18.3772857 C16.1177485,18.0810716 16.7859178,17.6398277 17.358035,17.068635 C17.9286073,16.4980626 18.3700856,15.8293003 18.6666857,15.0978788 Z M7.47791435,10.7576212 C7.40008573,10.949548 7.1814057,11.042043 6.98947883,10.9642143 C6.79755195,10.8863857 6.70505704,10.6677057 6.78288565,10.4757788 C7.11702882,9.65177528 7.61435177,8.89841814 8.25644941,8.25632068 C8.89990099,7.6139086 9.65248418,7.1169197 10.4754788,6.78318565 C10.6674057,6.70535704 10.8860857,6.79785195 10.9639143,6.98977883 C11.041743,7.1817057 10.949248,7.40038573 10.7573212,7.47821435 C10.0268515,7.77442842 9.35868222,8.2156723 8.78656504,8.78686504 C8.21599273,9.35743735 7.77451441,10.0261997 7.47791435,10.7576212 Z M20.2316202,15.7329937 C20.3094958,15.5410859 20.5281985,15.4486446 20.7201063,15.5265202 C20.9120141,15.6043958 21.0044554,15.8230985 20.9265798,16.0150063 C20.5075856,17.0475278 19.8857476,17.9896824 19.082265,18.793165 C18.2787824,19.5966476 17.3366278,20.2184856 16.3041063,20.6374798 C16.1121985,20.7153554 15.8934958,20.6229141 15.8156202,20.4310063 C15.7377446,20.2390985 15.8301859,20.0203958 16.0220937,19.9425202 C16.9621483,19.5610487 17.8197581,18.9950119 18.551935,18.262835 C19.2841119,17.5306581 19.8501487,16.6730483 20.2316202,15.7329937 Z M5.91287982,10.1224063 C5.83500419,10.3143141 5.6163015,10.4067554 5.4243937,10.3288798 C5.23248589,10.2510042 5.14004455,10.0323015 5.21792018,9.8403937 C5.63691442,8.80787218 6.25875236,7.86571756 7.06223496,7.06223496 C7.86571756,6.25875236 8.80787218,5.63691442 9.8403937,5.21792018 C10.0323015,5.14004455 10.2510042,5.23248589 10.3288798,5.4243937 C10.4067554,5.6163015 10.3143141,5.83500419 10.1224063,5.91287982 C9.18235168,6.29435126 8.32474195,6.86038814 7.59256504,7.59256504 C6.86038814,8.32474195 6.29435126,9.18235168 5.91287982,10.1224063 Z M21.7969812,16.3688899 C21.8748037,16.1769605 22.0934808,16.0844587 22.2854101,16.1622812 C22.4773395,16.2401037 22.5698413,16.4587808 22.4920188,16.6507101 C21.9896538,17.8896651 21.2425719,19.0210581 20.276665,19.986965 C19.3098944,20.9537357 18.1785335,21.7008856 16.9394101,22.2033188 C16.7474808,22.2811413 16.5288037,22.1886395 16.4509812,21.9967101 C16.3731587,21.8047808 16.4656605,21.5861037 16.6575899,21.5082812 C17.8040774,21.0434094 18.8508452,20.3521248 19.746335,19.456635 C20.640951,18.562019 21.3321725,17.5152217 21.7969812,16.3688899 Z M4.34751883,9.48661012 C4.26969632,9.67853947 4.05101923,9.77104134 3.85908988,9.69321883 C3.66716053,9.61539632 3.57465866,9.39671923 3.65248117,9.20478988 C4.15484616,7.96583488 4.90192806,6.83444185 5.86783496,5.86853496 C6.83460558,4.90176433 7.96596647,4.15461444 9.20508988,3.65218117 C9.39701923,3.57435866 9.61569632,3.66686053 9.69351883,3.85878988 C9.77134134,4.05071923 9.67883947,4.26939632 9.48691012,4.34721883 C8.34042262,4.81209058 7.29365484,5.50337524 6.39816504,6.39886504 C5.50354904,7.29348105 4.81232747,8.34027827 4.34751883,9.48661012 Z' })
	    )
	  );
	};
	
	CompactDisc.propTypes = _bcPropTypes.iconShape;
	
	exports.default = CompactDisc;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CompactDisc = __webpack_require__(164);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CompactDisc).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var ContentAdvisory = function (_BcReactComponent) {
	  _inherits(ContentAdvisory, _BcReactComponent);
	
	  function ContentAdvisory() {
	    _classCallCheck(this, ContentAdvisory);
	
	    return _possibleConstructorReturn(this, (ContentAdvisory.__proto__ || Object.getPrototypeOf(ContentAdvisory)).apply(this, arguments));
	  }
	
	  _createClass(ContentAdvisory, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-content-advisory', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M15.781 14.309v0l-6.829-13.611c-0.262-0.465-0.606-0.698-0.951-0.698s-0.69 0.233-0.951 0.698l-6.829 13.611c-0.523 0.93-0.078 1.691 0.989 1.691h13.583c1.067 0 1.512-0.761 0.989-1.691zM8 14c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM9 10c0 0.552-0.448 1-1 1s-1-0.448-1-1v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v3z' })
	      );
	    }
	  }]);
	
	  return ContentAdvisory;
	}(_baseBcReactComponent2.default);
	
	exports.default = ContentAdvisory;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ContentAdvisory = __webpack_require__(166);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ContentAdvisory).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Cross;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Cross(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-cross ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { d: 'M15.854 12.854c-0-0-0-0-0-0l-4.854-4.854 4.854-4.854c0-0 0-0 0-0 0.052-0.052 0.090-0.113 0.114-0.178 0.066-0.178 0.028-0.386-0.114-0.529l-2.293-2.293c-0.143-0.143-0.351-0.181-0.529-0.114-0.065 0.024-0.126 0.062-0.178 0.114 0 0-0 0-0 0l-4.854 4.854-4.854-4.854c-0-0-0-0-0-0-0.052-0.052-0.113-0.090-0.178-0.114-0.178-0.066-0.386-0.029-0.529 0.114l-2.293 2.293c-0.143 0.143-0.181 0.351-0.114 0.529 0.024 0.065 0.062 0.126 0.114 0.178 0 0 0 0 0 0l4.854 4.854-4.854 4.854c-0 0-0 0-0 0-0.052 0.052-0.090 0.113-0.114 0.178-0.066 0.178-0.029 0.386 0.114 0.529l2.293 2.293c0.143 0.143 0.351 0.181 0.529 0.114 0.065-0.024 0.126-0.062 0.178-0.114 0-0 0-0 0-0l4.854-4.854 4.854 4.854c0 0 0 0 0 0 0.052 0.052 0.113 0.090 0.178 0.114 0.178 0.066 0.386 0.029 0.529-0.114l2.293-2.293c0.143-0.143 0.181-0.351 0.114-0.529-0.024-0.065-0.062-0.126-0.114-0.178z' })
	  );
	}
	
	Cross.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cross = __webpack_require__(168);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cross).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Device = function Device(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-device ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('rect', { width: '18', height: '22', x: '4', y: '2', fill: color, rx: '2' }),
	      _react2.default.createElement('rect', { width: '14', height: '16', x: '6', y: '4', fill: '#FFF' }),
	      _react2.default.createElement('circle', { cx: '13', cy: '22', r: '1', fill: '#FFF' })
	    )
	  );
	};
	
	Device.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Device;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Device = __webpack_require__(170);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Device).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Ellipsis;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Ellipsis(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      className: 'icon-svg-ellipsis ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 18 18' },
	    _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M3,10 C1.8954305,10 1,9.1045695 1,8 C1,6.8954305 1.8954305,6 3,6 C4.1045695,6 5,6.8954305 5,8 C5,9.1045695 4.1045695,10 3,10 Z M8,10 C6.8954305,10 6,9.1045695 6,8 C6,6.8954305 6.8954305,6 8,6 C9.1045695,6 10,6.8954305 10,8 C10,9.1045695 9.1045695,10 8,10 Z M13,10 C11.8954305,10 11,9.1045695 11,8 C11,6.8954305 11.8954305,6 13,6 C14.1045695,6 15,6.8954305 15,8 C15,9.1045695 14.1045695,10 13,10 Z' })
	  );
	}
	
	Ellipsis.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Ellipsis = __webpack_require__(172);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Ellipsis).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ExternalArrow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function ExternalArrow(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      className: 'icon-svg-external-arrow ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 18 18' },
	    _react2.default.createElement('path', { d: 'M14.1428571,9.39285714 L14.1428571,12.6071429 C14.1428571,13.4040218 13.8599359,14.0853766 13.2940848,14.6512277 C12.7282338,15.2170787 12.046879,15.5 11.25,15.5 L2.89285714,15.5 C2.09597816,15.5 1.41462336,15.2170787 0.848772321,14.6512277 C0.282921278,14.0853766 0,13.4040218 0,12.6071429 L0,4.25 C0,3.45312102 0.282921278,2.77176622 0.848772321,2.20591518 C1.41462336,1.64006414 2.09597816,1.35714286 2.89285714,1.35714286 L9.96428571,1.35714286 C10.0580362,1.35714286 10.1350443,1.38727648 10.1953125,1.44754464 C10.2555807,1.5078128 10.2857143,1.58482096 10.2857143,1.67857143 L10.2857143,2.32142857 C10.2857143,2.41517904 10.2555807,2.4921872 10.1953125,2.55245536 C10.1350443,2.61272352 10.0580362,2.64285714 9.96428571,2.64285714 L2.89285714,2.64285714 C2.45089065,2.64285714 2.07254622,2.80022164 1.7578125,3.11495536 C1.44307878,3.42968907 1.28571429,3.8080335 1.28571429,4.25 L1.28571429,12.6071429 C1.28571429,13.0491094 1.44307878,13.4274538 1.7578125,13.7421875 C2.07254622,14.0569212 2.45089065,14.2142857 2.89285714,14.2142857 L11.25,14.2142857 C11.6919665,14.2142857 12.0703109,14.0569212 12.3850446,13.7421875 C12.6997784,13.4274538 12.8571429,13.0491094 12.8571429,12.6071429 L12.8571429,9.39285714 C12.8571429,9.29910667 12.8872765,9.22209852 12.9475446,9.16183036 C13.0078128,9.1015622 13.084821,9.07142857 13.1785714,9.07142857 L13.8214286,9.07142857 C13.915179,9.07142857 13.9921872,9.1015622 14.0524554,9.16183036 C14.1127235,9.22209852 14.1428571,9.29910667 14.1428571,9.39285714 Z M18,0.714285714 L18,5.85714286 C18,6.03125087 17.9363846,6.18191901 17.8091518,6.30915179 C17.681919,6.43638456 17.5312509,6.5 17.3571429,6.5 C17.1830348,6.5 17.0323667,6.43638456 16.9051339,6.30915179 L15.1372768,4.54129464 L8.58816964,11.0904018 C8.52120502,11.1573664 8.44419686,11.1908482 8.35714286,11.1908482 C8.27008885,11.1908482 8.19308069,11.1573664 8.12611607,11.0904018 L6.98102679,9.9453125 C6.91406217,9.87834788 6.88058036,9.80133972 6.88058036,9.71428571 C6.88058036,9.62723171 6.91406217,9.55022355 6.98102679,9.48325893 L13.5301339,2.93415179 L11.7622768,1.16629464 C11.635044,1.03906186 11.5714286,0.888393728 11.5714286,0.714285714 C11.5714286,0.540177701 11.635044,0.389509565 11.7622768,0.262276786 C11.8895096,0.135044007 12.0401777,0.0714285714 12.2142857,0.0714285714 L17.3571429,0.0714285714 C17.5312509,0.0714285714 17.681919,0.135044007 17.8091518,0.262276786 C17.9363846,0.389509565 18,0.540177701 18,0.714285714 Z' })
	  );
	}
	
	ExternalArrow.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExternalArrow = __webpack_require__(174);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExternalArrow).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Eye;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Eye(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-eye ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M8 3c-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-1.486-2.968-4.511-5-8-5zM11.945 5.652c0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.737-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114v0zM8 6.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z' })
	  );
	}
	
	Eye.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Eye = __webpack_require__(176);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Eye).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Failure = function (_BcReactComponent) {
	  _inherits(Failure, _BcReactComponent);
	
	  function Failure() {
	    _classCallCheck(this, Failure);
	
	    return _possibleConstructorReturn(this, (Failure.__proto__ || Object.getPrototypeOf(Failure)).apply(this, arguments));
	  }
	
	  _createClass(Failure, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          _props$color = _props.color,
	          color = _props$color === undefined ? 'currentColor' : _props$color;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-failure ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { fill: color, className: 'path1', d: 'M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9 13h-2v-2h2v2zM9 9h-2v-6h2v6z' })
	      );
	    }
	  }]);
	
	  return Failure;
	}(_baseBcReactComponent2.default);
	
	Failure.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Failure;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Failure = __webpack_require__(178);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Failure).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Fees;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Fees(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'svg-icon-fees ' + className,
	      width: width, height: height,
	      viewBox: '0 0 48 48' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M46,2 L2,2 C0.897,2 0,2.897 0,4 L0,37 C0,38.103 0.897,39 2,39 L9.814,39 C9.644,38.19 9.555,37.353 9.525,36.5 L2.5,36.5 L2.5,4.5 L45.5,4.5 L45.5,36.5 L38.475,36.5 C38.445,37.353 38.356,38.19 38.186,39 L46,39 C47.103,39 48,38.103 48,37 L48,4 C48,2.897 47.103,2 46,2' }),
	      _react2.default.createElement('polygon', { fill: color, points: '0 18 48 18 48 10 0 10' }),
	      _react2.default.createElement('path', { fill: color, d: 'M24,24 C17.373,24 12,29.373 12,36 C12,42.627 17.373,48 24,48 C30.627,48 36,42.627 36,36 C36,29.373 30.627,24 24,24 M24,26.5 C29.238,26.5 33.5,30.762 33.5,36 C33.5,41.238 29.238,45.5 24,45.5 C18.762,45.5 14.5,41.238 14.5,36 C14.5,30.762 18.762,26.5 24,26.5' }),
	      _react2.default.createElement('path', { fill: color, d: 'M23.74487 43.0009065C21.34487 43.0009065 19.12787 41.5989065 18.09687 39.4299065 17.85987 38.9309065 18.07287 38.3349065 18.57087 38.0979065 19.06987 37.8599065 19.66587 38.0729065 19.90387 38.5719065 20.60487 40.0469065 22.11287 41.0009065 23.74487 41.0009065 25.37687 41.0009065 26.88487 40.0469065 27.58587 38.5719065 27.82387 38.0729065 28.41887 37.8589065 28.91887 38.0979065 29.41687 38.3349065 29.62987 38.9309065 29.39287 39.4299065 28.36187 41.5989065 26.14487 43.0009065 23.74487 43.0009065M22 33.5C22 34.329 21.329 35 20.5 35 19.671 35 19 34.329 19 33.5 19 32.671 19.671 32 20.5 32 21.329 32 22 32.671 22 33.5M29 33.5C29 34.329 28.329 35 27.5 35 26.671 35 26 34.329 26 33.5 26 32.671 26.671 32 27.5 32 28.329 32 29 32.671 29 33.5' }),
	      _react2.default.createElement('path', { fill: color, d: 'M46,2 L2,2 C0.897,2 0,2.897 0,4 L0,37 C0,38.103 0.897,39 2,39 L9.814,39 C9.644,38.19 9.555,37.353 9.525,36.5 L2.5,36.5 L2.5,4.5 L45.5,4.5 L45.5,36.5 L38.475,36.5 C38.445,37.353 38.356,38.19 38.186,39 L46,39 C47.103,39 48,38.103 48,37 L48,4 C48,2.897 47.103,2 46,2' }),
	      _react2.default.createElement('polygon', { fill: color, points: '0 18 48 18 48 10 0 10' })
	    )
	  );
	}
	
	Fees.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Fees = __webpack_require__(180);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Fees).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Filter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Filter(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-filter ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { d: 'M0 2l6 6v6l4-1v-5l6-6z' })
	  );
	}
	
	Filter.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Filter = __webpack_require__(182);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Filter).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Flag = Flag;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Flag(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$hidden = _ref.hidden,
	      hidden = _ref$hidden === undefined ? true : _ref$hidden;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-flag ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M0 0h2v16h-2v-16z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M10 1c-0.5 0-0.75-0.25-1-0.5s-0.5-0.5-1-0.5h-5v10h5c0.5 0 0.75 0.25 1 0.5s0.5 0.5 1 0.5h5v-10h-5z' })
	  );
	}
	
	Flag.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Flag;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Flag = __webpack_require__(184);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Flag).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var FrighteningScenes = function (_BcReactComponent) {
	  _inherits(FrighteningScenes, _BcReactComponent);
	
	  function FrighteningScenes() {
	    _classCallCheck(this, FrighteningScenes);
	
	    return _possibleConstructorReturn(this, (FrighteningScenes.__proto__ || Object.getPrototypeOf(FrighteningScenes)).apply(this, arguments));
	  }
	
	  _createClass(FrighteningScenes, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-frightening-scenes', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M12.803 3.197c-1.417-1.417-3.3-2.197-5.303-2.197s-3.887 0.78-5.303 2.197-2.197 3.3-2.197 5.303c0 0.276 0.224 0.5 0.5 0.5 1.93 0 3.5 1.57 3.5 3.5v2c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2c0-1.93 1.57-3.5 3.5-3.5 0.276 0 0.5-0.224 0.5-0.5 0-2.003-0.78-3.887-2.197-5.303zM6 7c0 0.55-0.45 1-1 1h-1c-0.55 0-1-0.45-1-1v-1c0-0.55 0.45-1 1-1h1c0.55 0 1 0.45 1 1v1zM12 7c0 0.55-0.45 1-1 1h-1c-0.55 0-1-0.45-1-1v-1c0-0.55 0.45-1 1-1h1c0.55 0 1 0.45 1 1v1z' })
	      );
	    }
	  }]);
	
	  return FrighteningScenes;
	}(_baseBcReactComponent2.default);
	
	exports.default = FrighteningScenes;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FrighteningScenes = __webpack_require__(186);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FrighteningScenes).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var GameController = function GameController(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-game-controller ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M19.5,5.56253442 C20.6645835,5.56253442 21.7479165,5.85368046 22.75,6.43597192 C23.7520835,7.01826338 24.544271,7.81045088 25.1265625,8.81253442 C25.708854,9.81461796 26,10.8979509 26,12.0625344 C26,13.227118 25.708854,14.3104509 25.1265625,15.3125344 C24.544271,16.314618 23.7520835,17.1068055 22.75,17.6890969 C21.7479165,18.2713884 20.6645835,18.5625344 19.5,18.5625344 C18.60625,18.5625344 17.759896,18.3932634 16.9609375,18.0547219 C16.161979,17.7161805 15.4645835,17.2354509 14.86875,16.6125344 L11.13125,16.6125344 C10.5354165,17.2354509 9.83802104,17.7161805 9.0390625,18.0547219 C8.24010396,18.3932634 7.39375,18.5625344 6.5,18.5625344 C5.33541646,18.5625344 4.25208354,18.2713884 3.25,17.6890969 C2.24791646,17.1068055 1.45572896,16.314618 0.8734375,15.3125344 C0.29114604,14.3104509 0,13.227118 0,12.0625344 C0,10.8979509 0.29114604,9.81461796 0.8734375,8.81253442 C1.45572896,7.81045088 2.24791646,7.01826338 3.25,6.43597192 C4.25208354,5.85368046 5.33541646,5.56253442 6.5,5.56253442 L19.5,5.56253442 Z M10.4,12.8750344 L10.4,11.2500344 C10.4,11.114618 10.352604,10.9995134 10.2578125,10.9047219 C10.163021,10.8099305 10.0479165,10.7625344 9.9125,10.7625344 L7.8,10.7625344 L7.8,8.65003442 C7.8,8.51461796 7.75260396,8.39951338 7.6578125,8.30472192 C7.56302104,8.20993046 7.44791646,8.16253442 7.3125,8.16253442 L5.6875,8.16253442 C5.55208354,8.16253442 5.43697896,8.20993046 5.3421875,8.30472192 C5.24739604,8.39951338 5.2,8.51461796 5.2,8.65003442 L5.2,10.7625344 L3.0875,10.7625344 C2.95208354,10.7625344 2.83697896,10.8099305 2.7421875,10.9047219 C2.64739604,10.9995134 2.6,11.114618 2.6,11.2500344 L2.6,12.8750344 C2.6,13.0104509 2.64739604,13.1255555 2.7421875,13.2203469 C2.83697896,13.3151384 2.95208354,13.3625344 3.0875,13.3625344 L5.2,13.3625344 L5.2,15.4750344 C5.2,15.6104509 5.24739604,15.7255555 5.3421875,15.8203469 C5.43697896,15.9151384 5.55208354,15.9625344 5.6875,15.9625344 L7.3125,15.9625344 C7.44791646,15.9625344 7.56302104,15.9151384 7.6578125,15.8203469 C7.75260396,15.7255555 7.8,15.6104509 7.8,15.4750344 L7.8,13.3625344 L9.9125,13.3625344 C10.0479165,13.3625344 10.163021,13.3151384 10.2578125,13.2203469 C10.352604,13.1255555 10.4,13.0104509 10.4,12.8750344 Z M17.875,15.6375344 C18.4166665,15.6375344 18.8770835,15.4479509 19.25625,15.0687844 C19.6354165,14.689618 19.825,14.2292009 19.825,13.6875344 C19.825,13.145868 19.6354165,12.6854509 19.25625,12.3062844 C18.8770835,11.927118 18.4166665,11.7375344 17.875,11.7375344 C17.3333335,11.7375344 16.8729165,11.927118 16.49375,12.3062844 C16.1145835,12.6854509 15.925,13.145868 15.925,13.6875344 C15.925,14.2292009 16.1145835,14.689618 16.49375,15.0687844 C16.8729165,15.4479509 17.3333335,15.6375344 17.875,15.6375344 Z M21.125,12.3875344 C21.6666665,12.3875344 22.1270835,12.1979509 22.50625,11.8187844 C22.8854165,11.439618 23.075,10.9792009 23.075,10.4375344 C23.075,9.89586796 22.8854165,9.43545088 22.50625,9.05628442 C22.1270835,8.67711796 21.6666665,8.48753442 21.125,8.48753442 C20.5833335,8.48753442 20.1229165,8.67711796 19.74375,9.05628442 C19.3645835,9.43545088 19.175,9.89586796 19.175,10.4375344 C19.175,10.9792009 19.3645835,11.439618 19.74375,11.8187844 C20.1229165,12.1979509 20.5833335,12.3875344 21.125,12.3875344 Z' })
	  );
	};
	
	GameController.propTypes = _bcPropTypes.iconShape;
	
	exports.default = GameController;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GameController = __webpack_require__(188);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GameController).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var GraphicViolence = function (_BcReactComponent) {
	  _inherits(GraphicViolence, _BcReactComponent);
	
	  function GraphicViolence() {
	    _classCallCheck(this, GraphicViolence);
	
	    return _possibleConstructorReturn(this, (GraphicViolence.__proto__ || Object.getPrototypeOf(GraphicViolence)).apply(this, arguments));
	  }
	
	  _createClass(GraphicViolence, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-graphic-violence', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M15.707 14.293l-3.146-3.146 2.293-2.293c0.195-0.195 0.195-0.512 0-0.707l-1-1c-0.195-0.195-0.512-0.195-0.707 0l-1.646 1.646-8.646-8.646c-0.094-0.094-0.221-0.146-0.354-0.146h-2c-0.276 0-0.5 0.224-0.5 0.5v2c0 0.133 0.053 0.26 0.146 0.354l8.646 8.646-1.646 1.646c-0.195 0.195-0.195 0.512 0 0.707l1 1c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2.293-2.293 3.146 3.146c0.39 0.391 1.024 0.391 1.414 0s0.39-1.024 0-1.414zM9.5 11l-8.75-8.75 0.5-0.5 8.75 8.75-0.5 0.5z' })
	      );
	    }
	  }]);
	
	  return GraphicViolence;
	}(_baseBcReactComponent2.default);
	
	exports.default = GraphicViolence;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GraphicViolence = __webpack_require__(190);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GraphicViolence).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupedView = function GroupedView() {
	  return _react2.default.createElement(
	    "svg",
	    { focusable: "false", "aria-hidden": true, className: "icon-svg-grouped-view", preserveAspectRatio: "xMinYMin meet", viewBox: "0 0 16 16" },
	    _react2.default.createElement(
	      "g",
	      { fillRule: "evenodd" },
	      _react2.default.createElement("rect", { width: "4", height: "4", y: "2", fillRule: "nonzero" }),
	      _react2.default.createElement("rect", { width: "10", height: "2", x: "6", y: "3" }),
	      _react2.default.createElement("rect", { width: "8", height: "2", x: "8", y: "8" }),
	      _react2.default.createElement("rect", { width: "8", height: "2", x: "8", y: "13" }),
	      _react2.default.createElement("rect", { width: "2", height: "10", x: "8", y: "5" })
	    )
	  );
	};
	
	exports.default = GroupedView;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupedView = __webpack_require__(192);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupedView).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Headphones = function Headphones(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-headphones ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M26,12.84375 C26,14.546875 25.6875,16.203125 25.0625,17.75 L24.75,18.515625 L21.859375,19.03125 C21.40625,20.734375 19.859375,22 18,22 L18,22.5 C18,22.78125 17.78125,23 17.5,23 L16.5,23 C16.21875,23 16,22.78125 16,22.5 L16,13.5 C16,13.21875 16.21875,13 16.5,13 L17.5,13 C17.78125,13 18,13.21875 18,13.5 L18,14 C19.5,14 20.796875,14.828125 21.484375,16.046875 L22.546875,15.859375 C22.84375,14.890625 23,13.890625 23,12.84375 C23,8.125 18.328125,4 13,4 C7.671875,4 3,8.125 3,12.84375 C3,13.890625 3.15625,14.890625 3.453125,15.859375 L4.515625,16.046875 C5.203125,14.828125 6.5,14 8,14 L8,13.5 C8,13.21875 8.21875,13 8.5,13 L9.5,13 C9.78125,13 10,13.21875 10,13.5 L10,22.5 C10,22.78125 9.78125,23 9.5,23 L8.5,23 C8.21875,23 8,22.78125 8,22.5 L8,22 C6.140625,22 4.59375,20.734375 4.140625,19.03125 L1.25,18.515625 L0.9375,17.75 C0.3125,16.203125 0,14.546875 0,12.84375 C0,6.421875 5.953125,1 13,1 C20.046875,1 26,6.421875 26,12.84375 Z' })
	  );
	};
	
	Headphones.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Headphones;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Headphones = __webpack_require__(194);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Headphones).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HoldsIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function HoldsIcon(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      xmlnsXlink: 'http://www.w3.org/1999/xlink',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-holds ' + className,
	      width: width, height: height,
	      viewBox: '0 0 48 48' },
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('polygon', { id: 'holds-a', points: '27.243 37.779 24.414 34.95 23 36.364 25.828 39.193 27.243 40.607 33.606 34.243 32.192 32.829' })
	    ),
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M8.8569,16.9219 C8.8569,16.8279 8.9029,16.7349 8.9959,16.6409 C9.0879,16.5469 9.1799,16.4999 9.2729,16.4999 L23.9419,16.4999 C24.0339,16.4999 24.1269,16.5469 24.2189,16.6409 C24.3109,16.7349 24.3569,16.8279 24.3569,16.9219 L24.3569,18.3279 C24.3569,18.4219 24.3109,18.5159 24.2189,18.6089 C24.1269,18.7029 24.0339,18.7499 23.9419,18.7499 L9.2729,18.7499 C9.1799,18.7499 9.0879,18.7029 8.9959,18.6089 C8.9029,18.5159 8.8569,18.4219 8.8569,18.3279 L8.8569,16.9219 Z M8.8569,12.4219 C8.8569,12.3279 8.9029,12.2349 8.9959,12.1409 C9.0879,12.0469 9.1799,11.9999 9.2729,11.9999 L23.9419,11.9999 C24.0339,11.9999 24.1269,12.0469 24.2189,12.1409 C24.3109,12.2349 24.3569,12.3279 24.3569,12.4219 L24.3569,13.8279 C24.3569,13.9219 24.3109,14.0159 24.2189,14.1089 C24.1269,14.2029 24.0339,14.2499 23.9419,14.2499 L9.2729,14.2499 C9.1799,14.2499 9.0879,14.2029 8.9959,14.1089 C8.9029,14.0159 8.8569,13.9219 8.8569,13.8279 L8.8569,12.4219 Z M13.4799,34.4999 L6.6429,34.4999 C6.0429,34.4999 5.5239,34.2769 5.0859,33.8319 C4.6479,33.3869 4.4289,32.8599 4.4289,32.2499 C4.4289,31.6409 4.6479,31.1129 5.0859,30.6679 C5.5239,30.2229 6.0429,29.9999 6.6429,29.9999 L14.5419,29.9999 L15.3589,26.5409 C15.5719,25.6379 16.3779,24.9999 17.3059,24.9999 L30.9999,24.9999 L30.9999,4.6879 C30.9999,4.2189 30.8379,3.8199 30.5159,3.4919 C30.1929,3.1639 29.8009,2.9999 29.3389,2.9999 L6.6429,2.9999 C4.7979,2.9999 3.2289,3.6559 1.9379,4.9689 C0.6459,6.2809 -0.0001,7.8749 -0.0001,9.7499 L-0.0001,32.2499 C-0.0001,34.1249 0.6459,35.7189 1.9379,37.0309 C3.2289,38.3439 4.7979,38.9999 6.6429,38.9999 L12.4169,38.9999 L13.4799,34.4999 Z' }),
	      _react2.default.createElement('path', { fill: color, d: 'M40.7334,42 L43.2474,31.316 L45.7394,42 L40.7334,42 Z M38.2084,44 L15.2624,44 L18.7914,29 L18.7924,29 L39.0004,29 L41.7374,29 L38.2084,44 Z M47.6874,41.546 L44.6544,28.546 C44.4414,27.636 43.6414,27 42.7064,27 L41.7374,27 L39.0004,27 L18.7924,27 C17.8594,27 17.0594,27.634 16.8444,28.542 L13.3154,43.543 C13.2804,43.693 13.2624,43.846 13.2624,44 C13.2624,45.103 14.1594,46 15.2624,46 L38.2084,46 C39.1404,46 39.9414,45.366 40.1554,44.458 L40.2634,44 L45.7394,44 C46.8424,44 47.7394,43.103 47.7394,42 C47.7394,41.849 47.7224,41.697 47.6874,41.546 Z' }),
	      _react2.default.createElement('polygon', { fill: color, points: '25.829 39.192 23 36.363 24.414 34.949 27.243 37.778 32.193 32.828 33.607 34.242 27.243 40.606' })
	    )
	  );
	}
	
	HoldsIcon.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsIcon = __webpack_require__(196);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = IconWithBackground;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IconWithBackground(_ref) {
	  var className = _ref.className,
	      bgColor = _ref.bgColor,
	      icon = _ref.icon,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cp-icon-with-background', className) },
	    _react2.default.createElement(
	      'div',
	      { className: 'icon-holder', style: { backgroundColor: bgColor } },
	      icon
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'content-holder' },
	      children
	    )
	  );
	}
	
	IconWithBackground.propTypes = {
	  className: _react.PropTypes.string,
	  bgColor: _react.PropTypes.string.isRequired,
	  icon: _react.PropTypes.node,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _IconWithBackground = __webpack_require__(198);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconWithBackground).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Info(_ref) {
	  var className = _ref.className,
	      fill = _ref.fill;
	
	  return _react2.default.createElement(
	    "svg",
	    { focusable: "false", "aria-hidden": true, className: "icon-svg-info " + className, preserveAspectRatio: "xMinYMin meet", viewBox: "0 0 16 16" },
	    _react2.default.createElement("path", { fill: fill, className: "path1", d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM7 3.75c0-0.413 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.337 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5zM10 13h-4v-1h1v-4h-1v-1h3v5h1v1z" })
	  );
	}
	
	Info.propTypes = {
	  className: _react.PropTypes.string,
	  fill: _react.PropTypes.string
	};
	
	exports.default = Info;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Info = __webpack_require__(200);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Info).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Institution;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Institution(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: 'icon-svg-institution ' + className,
	      focusable: 'false',
	      'aria-hidden': true,
	      width: width,
	      height: height,
	      viewBox: '0 0 2048 1792' },
	    _react2.default.createElement('path', { d: 'M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zm-704 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zm1595 960q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z' })
	  );
	}
	
	Institution.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Institution = __webpack_require__(202);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Institution).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = JacketView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function JacketView(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$hidden = _ref.hidden,
	      hidden = _ref$hidden === undefined ? true : _ref$hidden;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-jacket-view ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M0 0h4v4h-4zM6 1h10v2h-10zM0 6h4v4h-4zM6 7h10v2h-10zM0 12h4v4h-4zM6 13h10v2h-10z' })
	  );
	}
	
	JacketView.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _JacketView = __webpack_require__(204);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JacketView).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Laptop;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Laptop(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-laptop ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M14 11v-8c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v8h-2v3h16v-3h-2zM10 13h-4v-1h4v1zM13 11h-10v-7.998c0.001-0.001 0.001-0.001 0.002-0.002h9.996c0.001 0.001 0.001 0.001 0.002 0.002v7.998z' })
	  );
	}
	
	Laptop.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Laptop = __webpack_require__(206);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Laptop).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Link;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Link(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-link ' + className, width: width, height: height, viewBox: '0 0 1792 1792' },
	    _react2.default.createElement('path', { d: 'M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z' })
	  );
	}
	
	Link.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Link = __webpack_require__(208);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Link).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = List;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function List(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-list', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('rect', { fill: color, width: '10', height: '2', x: '5', y: '3' }),
	      _react2.default.createElement('rect', { fill: color, width: '2', height: '2', x: '1', y: '3' }),
	      _react2.default.createElement('rect', { fill: color, width: '10', height: '2', x: '5', y: '7' }),
	      _react2.default.createElement('rect', { fill: color, width: '2', height: '2', x: '1', y: '7' }),
	      _react2.default.createElement('rect', { fill: color, width: '10', height: '2', x: '5', y: '11' }),
	      _react2.default.createElement('rect', { fill: color, width: '2', height: '2', x: '1', y: '11' })
	    )
	  );
	}
	
	List.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(210);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ListView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ListView(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$hidden = _ref.hidden,
	      hidden = _ref$hidden === undefined ? true : _ref$hidden;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-list-view ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M1 3h14v2h-14v-2z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M1 7h14v2h-14v-2z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M1 11h14v2h-14v-2z' })
	  );
	}
	
	ListView.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ListView = __webpack_require__(212);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListView).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Location;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Location(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: (0, _classnames2.default)('icon-svg-location', className), width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', {
	      fill: color,
	      d: 'M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z' })
	  );
	}
	
	Location.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Location = __webpack_require__(214);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Location).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Lock = function Lock(_ref) {
	  var color = _ref.color,
	      title = _ref.title,
	      className = _ref.className,
	      width = _ref.width,
	      height = _ref.height;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-lock ' + className, width: width, height: height, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('path', { fill: color, className: 'path1', d: 'M9.25 7h-0.25v-3c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v7.5c0 0.412 0.338 0.75 0.75 0.75h8.5c0.412 0 0.75-0.338 0.75-0.75v-7.5c0-0.412-0.338-0.75-0.75-0.75zM3 4c0-0.551 0.449-1 1-1h2c0.551 0 1 0.449 1 1v3h-4v-3z' })
	  );
	};
	
	Lock.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Lock;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Lock = __webpack_require__(216);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Lock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MessagesIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function MessagesIcon(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-messages ' + className,
	      width: width, height: height,
	      viewBox: '0 0 48 48' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M24,7.44192479 C23.6427013,7.44192479 23.2854026,7.55217188 22.9814026,7.77266605 L8.17522078,18.4734629 C7.73205195,18.7934722 7.46753247,19.308609 7.46753247,19.8510637 L7.46753247,38.8535637 C7.46753247,39.7950543 8.24233766,40.5609301 9.19480519,40.5609301 L38.8051948,40.5609301 C39.7576623,40.5609301 40.5324675,39.7950543 40.5324675,38.8535637 L40.5324675,19.8510637 C40.5324675,19.308609 40.2679481,18.7934722 39.8247792,18.4734629 L25.0195844,7.77266605 C24.7145974,7.55217188 24.3572987,7.44192479 24,7.44192479 M38.8051948,43.000025 L9.19480519,43.000025 C6.88223377,43.000025 5,41.1404591 5,38.8535637 L5,19.8510637 C5,18.5329768 5.64254545,17.2812334 6.71937662,16.5036499 L21.5245714,5.8038287 C23.0041039,4.73257825 24.9939221,4.73160261 26.4764156,5.8038287 L41.2806234,16.5036499 C42.3574545,17.2812334 43,18.5329768 43,19.8510637 L43,38.8535637 C43,41.1404591 41.1177662,43.000025 38.8051948,43.000025' }),
	      _react2.default.createElement('path', { fill: color, d: 'M24.3276,33.0537 C23.5106,33.0537 22.6946,32.8077 21.9976,32.3147 L11.5286,24.9077 C10.9646,24.5097 10.8306,23.7297 11.2296,23.1657 C11.6286,22.6017 12.4076,22.4677 12.9716,22.8667 L23.4416,30.2737 C23.9716,30.6477 24.6826,30.6487 25.2126,30.2737 L35.5286,22.9767 C36.0916,22.5777 36.8716,22.7107 37.2706,23.2757 C37.6686,23.8387 37.5356,24.6187 36.9716,25.0177 L26.6566,32.3147 C25.9606,32.8067 25.1436,33.0537 24.3276,33.0537' })
	    )
	  );
	}
	
	MessagesIcon.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MessagesIcon = __webpack_require__(218);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessagesIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Minus;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Minus(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: (0, _classnames2.default)('icon-svg-minus', className), width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', {
	      fill: color,
	      d: 'M0 6.5v3c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-15c-0.276 0-0.5 0.224-0.5 0.5z' })
	  );
	}
	
	Minus.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Minus = __webpack_require__(220);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Minus).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MinusCircled;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MinusCircled(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-minus-circled', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', {
	      fill: color,
	      fillRule: 'evenodd',
	      d: 'M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M4,7 L4,9 L12,9 L12,7 L4,7 Z' })
	  );
	}
	
	MinusCircled.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MinusCircled = __webpack_require__(222);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MinusCircled).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var More = function More(_ref) {
	  var color = _ref.color,
	      title = _ref.title,
	      className = _ref.className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-more ' + className, width: width, height: height, viewBox: '0 0 16 16', version: '1.1' },
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('path', { fill: color, d: 'M6 1h4v4h-4zM6 6h4v4h-4zM6 11h4v4h-4z' })
	  );
	};
	
	More.propTypes = _bcPropTypes.iconShape;
	
	exports.default = More;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _More = __webpack_require__(224);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_More).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var MusicalNote = function MusicalNote(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-musical-note ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M23,2.30354989 L23,18.3452166 C23,20.3647478 19.9778646,21.0952166 18.4166667,21.0952166 C16.8554688,21.0952166 13.8333333,20.3647478 13.8333333,18.3452166 C13.8333333,16.3256853 16.8554688,15.5952166 18.4166667,15.5952166 C19.3619792,15.5952166 20.3072917,15.7670916 21.1666667,16.1538103 L21.1666667,8.46240405 L10.1666667,11.8569353 L10.1666667,22.0118832 C10.1666667,24.0314145 7.14453125,24.7618832 5.58333333,24.7618832 C4.02213542,24.7618832 1,24.0314145 1,22.0118832 C1,19.992352 4.02213542,19.2618832 5.58333333,19.2618832 C6.52864583,19.2618832 7.47395833,19.4337582 8.33333333,19.820477 L8.33333333,5.97021655 C8.33333333,5.36865405 8.734375,4.83870614 9.30729167,4.65250822 L21.2239583,0.985841552 C21.3528646,0.942872802 21.4817708,0.928549886 21.625,0.928549886 C22.3841146,0.928549886 23,1.5444353 23,2.30354989 Z' })
	  );
	};
	
	MusicalNote.propTypes = _bcPropTypes.iconShape;
	
	exports.default = MusicalNote;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MusicalNote = __webpack_require__(226);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MusicalNote).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NewTab = NewTab;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NewTab(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$hidden = _ref.hidden,
	      hidden = _ref$hidden === undefined ? false : _ref$hidden,
	      title = _ref.title,
	      intl = _ref.intl;
	
	  var ariaLabel = title || intl.formatMessage({ id: 'ada_opens_a_new_window' });
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-new-tab ' + className, width: width, height: height, viewBox: '0 0 16 16', 'aria-label': ariaLabel },
	    _react2.default.createElement('path', { fill: color, d: 'M11 13h-8v-8h4.5l2-2h-8.5v12h12v-8.5l-2 2v4.5z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M16 0h-6.5l2.5 2.5-7.5 7.5 1.5 1.5 7.5-7.5 2.5 2.5v-6.5z' })
	  );
	}
	
	NewTab.propTypes = _bcPropTypes.iconShape;
	
	exports.default = (0, _reactIntl.injectIntl)(NewTab);

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NewTab = __webpack_require__(228);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NewTab).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Newspaper = function Newspaper(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-newspaper ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13,8.80354989 L8.125,8.80354989 L8.125,13.6785499 L13,13.6785499 L13,8.80354989 Z M14.625,16.9285499 L14.625,18.5535499 L6.5,18.5535499 L6.5,16.9285499 L14.625,16.9285499 Z M14.625,7.17854989 L14.625,15.3035499 L6.5,15.3035499 L6.5,7.17854989 L14.625,7.17854989 Z M22.75,16.9285499 L22.75,18.5535499 L16.25,18.5535499 L16.25,16.9285499 L22.75,16.9285499 Z M22.75,13.6785499 L22.75,15.3035499 L16.25,15.3035499 L16.25,13.6785499 L22.75,13.6785499 Z M22.75,10.4285499 L22.75,12.0535499 L16.25,12.0535499 L16.25,10.4285499 L22.75,10.4285499 Z M22.75,7.17854989 L22.75,8.80354989 L16.25,8.80354989 L16.25,7.17854989 L22.75,7.17854989 Z M3.25,19.3660499 L3.25,7.17854989 L1.625,7.17854989 L1.625,19.3660499 C1.625,19.8103858 1.99316406,20.1785499 2.4375,20.1785499 C2.88183594,20.1785499 3.25,19.8103858 3.25,19.3660499 Z M24.375,19.3660499 L24.375,5.55354989 L4.875,5.55354989 L4.875,19.3660499 C4.875,19.6453468 4.82421875,19.9246436 4.73535156,20.1785499 L23.5625,20.1785499 C24.0068359,20.1785499 24.375,19.8103858 24.375,19.3660499 Z M26,3.92854989 L26,19.3660499 C26,20.711753 24.9082031,21.8035499 23.5625,21.8035499 L2.4375,21.8035499 C1.09179688,21.8035499 0,20.711753 0,19.3660499 L0,5.55354989 L3.25,5.55354989 L3.25,3.92854989 L26,3.92854989 Z' })
	  );
	};
	
	Newspaper.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Newspaper;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Newspaper = __webpack_require__(230);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Newspaper).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var OffensiveLanguage = function (_BcReactComponent) {
	  _inherits(OffensiveLanguage, _BcReactComponent);
	
	  function OffensiveLanguage() {
	    _classCallCheck(this, OffensiveLanguage);
	
	    return _possibleConstructorReturn(this, (OffensiveLanguage.__proto__ || Object.getPrototypeOf(OffensiveLanguage)).apply(this, arguments));
	  }
	
	  _createClass(OffensiveLanguage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-offensive-language', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM9 10h-2v-2h2v2zM9 6h-2v-4h2v4z' })
	      );
	    }
	  }]);
	
	  return OffensiveLanguage;
	}(_baseBcReactComponent2.default);
	
	exports.default = OffensiveLanguage;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OffensiveLanguage = __webpack_require__(232);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OffensiveLanguage).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PaperPlane;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function PaperPlane(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-paper-plane ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M7 11l6.151 2.195 2.849-12.459zM5 10.311l11-9.575-16 7.913zM7 12.062v3.938l2.902-2.902z' })
	  );
	}
	
	PaperPlane.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PaperPlane = __webpack_require__(234);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PaperPlane).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PauseCircled;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PauseCircled(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-pause-circled', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('rect', { fill: color, width: '2', height: '6', x: '5', y: '5' }),
	      _react2.default.createElement('rect', { fill: color, width: '2', height: '6', x: '9', y: '5' }),
	      _react2.default.createElement('circle', { stroke: color, cx: '8', cy: '8', r: '7.25', strokeWidth: '1.5' })
	    )
	  );
	}
	
	PauseCircled.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PauseCircled = __webpack_require__(236);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PauseCircled).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var Pencil = function (_BcReactComponent) {
	  _inherits(Pencil, _BcReactComponent);
	
	  function Pencil() {
	    _classCallCheck(this, Pencil);
	
	    return _possibleConstructorReturn(this, (Pencil.__proto__ || Object.getPrototypeOf(Pencil)).apply(this, arguments));
	  }
	
	  _createClass(Pencil, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-pencil', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M13.5 0c1.381 0 2.5 1.119 2.5 2.5 0 0.563-0.186 1.082-0.5 1.5l-1 1-3.5-3.5 1-1c0.418-0.314 0.937-0.5 1.5-0.5zM1 11.5l-1 4.5 4.5-1 9.25-9.25-3.5-3.5-9.25 9.25zM11.181 5.681l-7 7-0.862-0.862 7-7 0.862 0.862z' })
	      );
	    }
	  }]);
	
	  return Pencil;
	}(_baseBcReactComponent2.default);
	
	exports.default = Pencil;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Pencil = __webpack_require__(238);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pencil).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PencilEdit;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function PencilEdit(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-pencil-edit ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M12 8.5v5.5h-10v-10h5.5l2-2h-8c-0.825 0-1.5 0.675-1.5 1.5v11c0 0.825 0.675 1.5 1.5 1.5h11c0.825 0 1.5-0.675 1.5-1.5v-8l-2 2z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M13.5 0l-9.5 9.5v2.5h2.5l9.5-9.5c0-1.5-1-2.5-2.5-2.5z' })
	  );
	}
	
	PencilEdit.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PencilEdit = __webpack_require__(240);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PencilEdit).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var Plus = function (_BcReactComponent) {
	  _inherits(Plus, _BcReactComponent);
	
	  function Plus() {
	    _classCallCheck(this, Plus);
	
	    return _possibleConstructorReturn(this, (Plus.__proto__ || Object.getPrototypeOf(Plus)).apply(this, arguments));
	  }
	
	  _createClass(Plus, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-plus', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M15.5 6h-5.5v-5.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v5.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h5.5v5.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-5.5h5.5c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z' })
	      );
	    }
	  }]);
	
	  return Plus;
	}(_baseBcReactComponent2.default);
	
	Plus.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Plus;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Plus = __webpack_require__(242);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Plus).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Printer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Printer(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? 'Print' : _ref$title,
	      _ref$hidden = _ref.hidden,
	      hidden = _ref$hidden === undefined ? true : _ref$hidden;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-printer ' + className, width: width, height: height, viewBox: '0 0 16 16', 'aria-label': hidden ? null : title },
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('path', { fill: color, d: 'M9.5 11h-3c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M10.5 13h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M15.916 7.223l-2-3c-0.093-0.139-0.249-0.223-0.416-0.223h-1.5v-3.5c0-0.276-0.224-0.5-0.5-0.5h-7c-0.276 0-0.5 0.224-0.5 0.5v3.5h-1.5c-0.167 0-0.323 0.084-0.416 0.223l-2 3c-0.055 0.082-0.084 0.179-0.084 0.277v5c0 0.276 0.224 0.5 0.5 0.5h2.306l-0.781 2.342c-0.051 0.152-0.025 0.32 0.069 0.45s0.245 0.208 0.406 0.208h11c0.161 0 0.312-0.077 0.406-0.208s0.12-0.298 0.069-0.45l-0.781-2.342h2.306c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.099-0.029-0.195-0.084-0.277zM5 1h6v4h-6v-4zM3.194 15l1.667-5h6.279l1.667 5h-9.613z' })
	  );
	}
	
	Printer.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Printer = __webpack_require__(244);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Printer).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PushPin = function PushPin(_ref) {
	  var color = _ref.color,
	      title = _ref.title,
	      width = _ref.width,
	      height = _ref.height,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-push-pin ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('path', { fill: color, d: 'M8.5 0l-1.5 1.5 1.5 1.5-3.5 4h-3.5l2.75 2.75-4.25 5.635v0.615h0.615l5.635-4.25 2.75 2.75v-3.5l4-3.5 1.5 1.5 1.5-1.5-7.5-7.5zM7 8.5l-1-1 3.5-3.5 1 1-3.5 3.5z' })
	  );
	};
	
	PushPin.propTypes = _bcPropTypes.iconShape;
	
	exports.default = PushPin;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PushPin = __webpack_require__(246);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PushPin).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var Quotation = function (_BcReactComponent) {
	  _inherits(Quotation, _BcReactComponent);
	
	  function Quotation() {
	    _classCallCheck(this, Quotation);
	
	    return _possibleConstructorReturn(this, (Quotation.__proto__ || Object.getPrototypeOf(Quotation)).apply(this, arguments));
	  }
	
	  _createClass(Quotation, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-quotation ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M3.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.548-0.043zM12.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.549-0.043z' })
	      );
	    }
	  }]);
	
	  return Quotation;
	}(_baseBcReactComponent2.default);
	
	Quotation.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Quotation;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Quotation = __webpack_require__(248);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Quotation).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RSS;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function RSS(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-rss ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M2.13 11.733c-1.175 0-2.13 0.958-2.13 2.126 0 1.174 0.955 2.122 2.13 2.122 1.179 0 2.133-0.948 2.133-2.122-0-1.168-0.954-2.126-2.133-2.126zM0.002 5.436v3.067c1.997 0 3.874 0.781 5.288 2.196 1.412 1.411 2.192 3.297 2.192 5.302h3.080c-0-5.825-4.739-10.564-10.56-10.564zM0.006 0v3.068c7.122 0 12.918 5.802 12.918 12.932h3.076c0-8.82-7.176-16-15.994-16z' })
	  );
	}
	
	RSS.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RSS = __webpack_require__(250);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RSS).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Redo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Redo(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-redo ' + className, width: width, height: height, viewBox: '0 0 1792 1792', 'aria-hidden': 'true' },
	    _react2.default.createElement('path', { d: 'M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 15 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z' })
	  );
	}
	
	Redo.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Redo = __webpack_require__(252);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Redo).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Remove;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Remove(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-remove ' + className, width: width, height: height, viewBox: '0 0 512 512' },
	    _react2.default.createElement('path', { fill: color, d: 'M 400.00,64.00L 112.00,64.00 c-26.51,0.00-48.00,21.49-48.00,48.00l0.00,16.00 l 384.00,0.00 l0.00-16.00 C 448.00,85.49, 426.51,64.00, 400.00,64.00zM 316.16,32.00l 7.058,50.50L 188.782,82.50 l 7.057-50.50L 316.16,32.00 M 320.00,0.00L 192.00,0.00 c-13.20,0.00-25.495,10.696-27.321,23.769l-9.357,66.962 C 153.495,103.804, 162.80,114.50, 176.00,114.50l 160.00,0.00 c 13.20,0.00, 22.505-10.696, 20.679-23.769l-9.357-66.962C 345.495,10.696, 333.20,0.00, 320.00,0.00L 320.00,0.00z M 408.00,160.00L 104.00,160.00 c-17.60,0.00-30.696,14.341-29.103,31.869l 26.206,288.263C 102.696,497.659, 118.40,512.00, 136.00,512.00l 240.00,0.00 c 17.60,0.00, 33.304-14.341, 34.897-31.868l 26.205-288.263C 438.696,174.341, 425.60,160.00, 408.00,160.00z M 192.00,448.00l-48.00,0.00 l-16.00-224.00l 64.00,0.00 L 192.00,448.00 z M 288.00,448.00l-64.00,0.00 L 224.00,224.00 l 64.00,0.00 L 288.00,448.00 z M 368.00,448.00l-48.00,0.00 L 320.00,224.00 l 64.00,0.00 L 368.00,448.00z' })
	  );
	}
	
	Remove.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Remove = __webpack_require__(254);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Remove).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Resume;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Resume(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: (0, _classnames2.default)('icon-svg-resume-circled', className), width: width, height: height, viewBox: '0 0 1792 1792' },
	    _react2.default.createElement('path', {
	      fill: color,
	      d: 'M1312 896q0 37-32 55l-544 320q-15 9-32 9-16 0-32-8-32-19-32-56v-640q0-37 32-56 33-18 64 1l544 320q32 18 32 55zm128 0q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z' })
	  );
	}
	
	Resume.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Resume = __webpack_require__(256);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Resume).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var RightArrowCircled = function RightArrowCircled(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 12 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 12 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-video-camera ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 12 12' },
	    _react2.default.createElement(
	      'g',
	      { fillRule: 'evenodd' },
	      _react2.default.createElement('circle', { cx: '6', cy: '6', r: '6', fill: color }),
	      _react2.default.createElement('path', { fill: '#FFF', d: 'M6,7 L3,7 L3,5 L6,5 L6,3.15917967 C6,3.01732459 6.159,2.94747172 6.252,3.04741507 L8.896,5.88774058 C8.953,5.95007084 8.953,6.05001419 8.896,6.11234445 L6.252,8.95374462 C6.159,9.05261331 6,8.98276043 6,8.84090535 L6,7 Z' })
	    )
	  );
	};
	
	RightArrowCircled.propTypes = _bcPropTypes.iconShape;
	
	exports.default = RightArrowCircled;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RightArrowCircled = __webpack_require__(258);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RightArrowCircled).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SearchIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function SearchIcon(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', className: 'icon-svg-cog ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M16 13.5l-4.695-4.695c0.444-0.837 0.695-1.792 0.695-2.805 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.013 0 1.968-0.252 2.805-0.695l4.695 4.695 2.5-2.5zM2 6c0-2.209 1.791-4 4-4s4 1.791 4 4-1.791 4-4 4-4-1.791-4-4z' })
	  );
	}
	
	SearchIcon.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Search = __webpack_require__(260);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Search).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var SexualContent = function (_BcReactComponent) {
	  _inherits(SexualContent, _BcReactComponent);
	
	  function SexualContent() {
	    _classCallCheck(this, SexualContent);
	
	    return _possibleConstructorReturn(this, (SexualContent.__proto__ || Object.getPrototypeOf(SexualContent)).apply(this, arguments));
	  }
	
	  _createClass(SexualContent, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-sexual-content', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M16 6.877l-0.157-0.005c-1.935-0.112-3.646-2.091-5.593-2.091-2 0-2.25 0.75-2.25 0.75s-0.25-0.75-2.25-0.75c-1.948 0-3.658 1.979-5.593 2.091l-0.157 0.005c0 0 5 0.904 8 0.904s8-0.904 8-0.904zM8 9.219c-2.637 0-7-1.531-7.793-2.138 2.25 1.722 3.894 4.794 7.793 4.794s5.543-3.073 7.793-4.794c-0.793 0.607-5.156 2.138-7.793 2.138z' })
	      );
	    }
	  }]);
	
	  return SexualContent;
	}(_baseBcReactComponent2.default);
	
	exports.default = SexualContent;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SexualContent = __webpack_require__(262);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SexualContent).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShelfItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function ShelfItem(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 33 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 22 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#666' : _ref$color,
	      _ref$checkmarkBackgro = _ref.checkmarkBackgroundColor,
	      checkmarkBackgroundColor = _ref$checkmarkBackgro === undefined ? '#2F50B3' : _ref$checkmarkBackgro,
	      _ref$checkmarkStrokeC = _ref.checkmarkStrokeColor,
	      checkmarkStrokeColor = _ref$checkmarkStrokeC === undefined ? '#fff' : _ref$checkmarkStrokeC,
	      _ref$lockBackgroundCo = _ref.lockBackgroundColor,
	      lockBackgroundColor = _ref$lockBackgroundCo === undefined ? '#2F50B3' : _ref$lockBackgroundCo,
	      _ref$lockStrokeColor = _ref.lockStrokeColor,
	      lockStrokeColor = _ref$lockStrokeColor === undefined ? '#fff' : _ref$lockStrokeColor,
	      _ref$onShelf = _ref.onShelf,
	      onShelf = _ref$onShelf === undefined ? false : _ref$onShelf,
	      _ref$isPrivate = _ref.isPrivate,
	      isPrivate = _ref$isPrivate === undefined ? false : _ref$isPrivate;
	
	  var renderLockIcon = function renderLockIcon() {
	    return _react2.default.createElement(
	      'g',
	      { transform: 'translate(110.000000, 558.000000)' },
	      _react2.default.createElement('path', { d: 'M6.62249994,0 C4.41249994,0 2.62249994,1.79 2.62249994,4 L2.62249994,6 L0.622499943,6 L0.622499943,14 L12.6224999,14 L12.6224999,6 L10.6224999,6 L10.6224999,4 C10.6224999,1.79 8.83249994,0 6.62249994,0 Z M6.62249994,2 C7.81249994,2 8.62249994,2.81 8.62249994,4 L8.62249994,6 L4.62249994,6 L4.62249994,4 C4.62249994,2.81 5.43249994,2 6.62249994,2 Z', fill: lockBackgroundColor, fillRule: 'nonzero' }),
	      _react2.default.createElement(
	        'g',
	        { transform: 'translate(3.500000, 7.875000)', fill: lockStrokeColor },
	        _react2.default.createElement('polygon', { id: 'Checkmark', points: '2.79600174 2.66464878 1.33994949 1.20859653 0.35 2.19854602 2.76482323 4.61336925 3.75477272 3.62341976 6.37158225 0.989949494 5.38163276 1.33226763e-15' })
	      )
	    );
	  };
	
	  var renderCheckmark = function renderCheckmark() {
	    return _react2.default.createElement(
	      'g',
	      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', transform: 'translate(110.000000, 558.000000)' },
	      _react2.default.createElement('circle', { className: 'CheckBackground', fill: checkmarkBackgroundColor, cx: '6', cy: '6', r: '6' }),
	      _react2.default.createElement('polygon', { className: 'Checkmark', fill: checkmarkStrokeColor, points: '5.49428821 6.80664111 3.41421356 4.72656647 2 6.14078003 5.44974747 9.5905275 6.86396103 8.17631394 10.6022604 4.41421356 9.1880468 3' })
	    );
	  };
	
	  var renderOnShelfIcon = function renderOnShelfIcon() {
	    if (onShelf && isPrivate) {
	      return renderLockIcon();
	    } else if (onShelf) {
	      return renderCheckmark();
	    }
	
	    return null;
	  };
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-shelf-item ' + className, width: width, height: height, viewBox: '89 558 33 22', version: '1.1' },
	    _react2.default.createElement(
	      'g',
	      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', transform: 'translate(97.000000, 560.000000)' },
	      _react2.default.createElement(
	        'g',
	        { fill: color },
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(12.631579, 2.089245)' },
	          _react2.default.createElement('path', { d: 'M3.68421053,2.26544622 L3.36842105,0.926773455 C3.36842105,0.823798627 3.26315789,0.720823799 3.15789474,0.720823799 L0.315789474,1.23569794 C0.210526316,1.23569794 0.105263158,1.33867277 0.105263158,1.4416476 L0.421052632,2.78032037 L3.68421053,2.26544622 L3.68421053,2.26544622 Z' }),
	          _react2.default.createElement('polygon', { points: '3.79077895 3.16967849 5.92558947 13.5682002 2.72638947 14.1967483 0.591578947 3.79822654' }),
	          _react2.default.createElement('path', { d: 'M2.94736842,15.0343249 L3.26315789,16.3729977 C3.26315789,16.4759725 3.36842105,16.4759725 3.47368421,16.4759725 L6.31578947,15.9610984 C6.42105263,15.9610984 6.52631579,15.8581236 6.52631579,15.7551487 L6.10526316,14.416476 L2.94736842,15.0343249 L2.94736842,15.0343249 Z' })
	        ),
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(6.315789, 0.000000)' },
	          _react2.default.createElement('path', { d: 'M5.68421053,2.29519451 L5.68421053,0.338672769 C5.68421053,0.235697941 5.57894737,0.0297482838 5.36842105,0.0297482838 L1.15789474,0.0297482838 C0.947368421,0.0297482838 0.842105263,0.132723112 0.842105263,0.338672769 L0.842105263,2.29519451 L5.68421053,2.29519451 L5.68421053,2.29519451 Z' }),
	          _react2.default.createElement('rect', { x: '0.842105263', y: '3.11899314', width: '4.73684211', height: '12.9748284' }),
	          _react2.default.createElement('path', { d: 'M0.842105263,17.020595 L0.842105263,18.3592677 C0.842105263,18.4622426 0.947368421,18.5652174 1.05263158,18.5652174 L5.36842105,18.5652174 C5.47368421,18.5652174 5.68421053,18.4622426 5.68421053,18.3592677 L5.68421053,17.020595 L0.842105263,17.020595 L0.842105263,17.020595 Z' })
	        ),
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(0.000000, 1.059497)' },
	          _react2.default.createElement('path', { d: 'M5.68421053,2.78032037 L5.68421053,0.823798627 C5.68421053,0.720823799 5.57894737,0.61784897 5.47368421,0.61784897 L0.315789474,0.61784897 C0.210526316,0.61784897 0.105263158,0.720823799 0.105263158,0.823798627 L0.105263158,2.78032037 L5.68421053,2.78032037 L5.68421053,2.78032037 Z' }),
	          _react2.default.createElement('rect', { x: '0.105263158', y: '3.60411899', width: '5.57894737', height: '11.4302059' }),
	          _react2.default.createElement('path', { d: 'M0.105263158,15.9610984 L0.105263158,17.2997712 C0.105263158,17.402746 0.210526316,17.5057208 0.315789474,17.5057208 L5.36842105,17.5057208 C5.47368421,17.5057208 5.57894737,17.402746 5.57894737,17.2997712 L5.57894737,15.9610984 L0.105263158,15.9610984 L0.105263158,15.9610984 Z' })
	        )
	      )
	    ),
	    renderOnShelfIcon()
	  );
	}
	
	ShelfItem.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfItem = __webpack_require__(264);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfItem).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(307);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Spinner(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-spinner ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'title',
	      null,
	      'Loading'
	    ),
	    _react2.default.createElement('path', { fill: color, d: 'M16 8c-0.020-1.045-0.247-2.086-0.665-3.038-0.417-0.953-1.023-1.817-1.766-2.53s-1.624-1.278-2.578-1.651c-0.953-0.374-1.978-0.552-2.991-0.531-1.013 0.020-2.021 0.24-2.943 0.646-0.923 0.405-1.758 0.992-2.449 1.712s-1.237 1.574-1.597 2.497c-0.361 0.923-0.533 1.914-0.512 2.895 0.020 0.981 0.234 1.955 0.627 2.847 0.392 0.892 0.961 1.7 1.658 2.368s1.523 1.195 2.416 1.543c0.892 0.348 1.851 0.514 2.799 0.493 0.949-0.020 1.89-0.227 2.751-0.608 0.862-0.379 1.642-0.929 2.287-1.604s1.154-1.472 1.488-2.335c0.204-0.523 0.342-1.069 0.415-1.622 0.019 0.001 0.039 0.002 0.059 0.002 0.552 0 1-0.448 1-1 0-0.028-0.001-0.056-0.004-0.083h0.004zM14.411 10.655c-0.367 0.831-0.898 1.584-1.55 2.206s-1.422 1.112-2.254 1.434c-0.832 0.323-1.723 0.476-2.608 0.454-0.884-0.020-1.759-0.215-2.56-0.57-0.801-0.354-1.526-0.867-2.125-1.495s-1.071-1.371-1.38-2.173c-0.31-0.801-0.457-1.66-0.435-2.512s0.208-1.694 0.551-2.464c0.342-0.77 0.836-1.468 1.441-2.044s1.321-1.029 2.092-1.326c0.771-0.298 1.596-0.438 2.416-0.416s1.629 0.202 2.368 0.532c0.74 0.329 1.41 0.805 1.963 1.387s0.988 1.27 1.272 2.011c0.285 0.74 0.418 1.532 0.397 2.32h0.004c-0.002 0.027-0.004 0.055-0.004 0.083 0 0.516 0.39 0.94 0.892 0.994-0.097 0.544-0.258 1.075-0.481 1.578z' })
	  );
	}
	
	Spinner.propTypes = {
	  color: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number
	};
	
	Spinner.displayName = 'Spinner';
	
	exports.default = Spinner;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(266);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Spinner).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StarEmpty;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function StarEmpty(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-star-empty ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { className: 'path1', fill: color, d: 'M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-3.492 1.836 0.667-3.888-2.825-2.753 3.904-0.567 1.746-3.537 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z' })
	  );
	}
	
	StarEmpty.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StarEmpty = __webpack_require__(268);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarEmpty).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StarFull;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function StarFull(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-star-full ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { className: 'path1', fill: color, d: 'M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899z' })
	  );
	}
	
	StarFull.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StarFull = __webpack_require__(270);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarFull).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StarHalf;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function StarHalf(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-star-half ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { className: 'path1', fill: color, d: 'M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-0.015 0.008 0.015-8.918 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z' })
	  );
	}
	
	StarHalf.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StarHalf = __webpack_require__(272);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarHalf).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Summary = function (_BcReactComponent) {
	  _inherits(Summary, _BcReactComponent);
	
	  function Summary() {
	    _classCallCheck(this, Summary);
	
	    return _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).apply(this, arguments));
	  }
	
	  _createClass(Summary, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-summary ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M11.445 0.055l-8.945 8.945-2.5 7 6.995-2.5 8.95-8.945c0.5-2-2.5-5-4.5-4.5zM4.5 11l-1-1 8.5-8.5 1 1-8.5 8.5z' })
	      );
	    }
	  }]);
	
	  return Summary;
	}(_baseBcReactComponent2.default);
	
	Summary.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Summary;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Summary = __webpack_require__(274);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Summary).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Tag;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Tag(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-tag ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { className: 'path1', fill: color, d: 'M15.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.338-0.75-0.75-0.75zM11.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z' })
	  );
	}
	
	Tag.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tag = __webpack_require__(276);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tag).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TextFile;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function TextFile(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-text-file ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M11.5 13h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M11.5 11h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M11.5 9h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z' })
	  );
	}
	
	TextFile.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TextFile = __webpack_require__(278);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextFile).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Truck;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Truck(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-truck', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', {
	      fill: color,
	      fillRule: 'evenodd',
	      d: 'M14.8,1.75002921 C15.1333332,1.75002921 15.4166668,1.86669572 15.65,2.10002837 C15.8833332,2.33336102 16,2.61669393 16,2.95002635 L16,11.5500058 C16,11.7166722 15.9416668,11.8583383 15.825,11.9750048 C15.7083332,12.0916713 15.5666668,12.1500044 15.4,12.1500044 L14.4,12.1500044 C14.4,12.8166696 14.1666668,13.3833347 13.7,13.8500004 C13.2333332,14.316666 12.6666668,14.5499987 12,14.5499987 C11.3333332,14.5499987 10.7666668,14.316666 10.3,13.8500004 C9.83333321,13.3833347 9.6,12.8166696 9.6,12.1500044 L6.4,12.1500044 C6.4,12.8166696 6.16666679,13.3833347 5.7,13.8500004 C5.23333321,14.316666 4.66666679,14.5499987 4,14.5499987 C3.33333321,14.5499987 2.76666679,14.316666 2.3,13.8500004 C1.83333321,13.3833347 1.6,12.8166696 1.6,12.1500044 L0.6,12.1500044 C0.433333206,12.1500044 0.291666794,12.0916713 0.175,11.9750048 C0.0583332062,11.8583383 0,11.7166722 0,11.5500058 L0,11.1500068 C0,10.9833404 0.0583332062,10.8416743 0.175,10.7250078 C0.291666794,10.6083413 0.433333206,10.5500082 0.6,10.5500082 L0.8,10.5500082 L0.8,7.85001466 C0.8,7.51668225 0.916666794,7.23334934 1.15,7.00001669 L3.65,4.50002265 C3.88333321,4.26669 4.16666679,4.15002348 4.5,4.15002348 L5.6,4.15002348 L5.6,2.95002635 C5.6,2.61669393 5.71666679,2.33336102 5.95,2.10002837 C6.18333321,1.86669572 6.46666679,1.75002921 6.8,1.75002921 L14.8,1.75002921 Z M3.99999046,13.3500015 C4.33332287,13.3500015 4.61665579,13.233335 4.84998844,13.0000024 C5.08332109,12.7666697 5.1999876,12.4833368 5.1999876,12.1500044 C5.1999876,11.816672 5.08332109,11.5333391 4.84998844,11.3000064 C4.61665579,11.0666738 4.33332287,10.9500073 3.99999046,10.9500073 C3.66665805,10.9500073 3.38332514,11.0666738 3.14999249,11.3000064 C2.91665984,11.5333391 2.79999332,11.816672 2.79999332,12.1500044 C2.79999332,12.4833368 2.91665984,12.7666697 3.14999249,13.0000024 C3.38332514,13.233335 3.66665805,13.3500015 3.99999046,13.3500015 Z M5.59998665,8.15001395 L5.59998665,5.35002062 L4.49998927,5.35002062 L1.99999523,7.85001466 L1.99999523,8.15001395 L5.59998665,8.15001395 Z M11.9999714,13.3500015 C12.3333038,13.3500015 12.6166367,13.233335 12.8499694,13.0000024 C13.083302,12.7666697 13.1999685,12.4833368 13.1999685,12.1500044 C13.1999685,11.816672 13.083302,11.5333391 12.8499694,11.3000064 C12.6166367,11.0666738 12.3333038,10.9500073 11.9999714,10.9500073 C11.666639,10.9500073 11.3833061,11.0666738 11.1499734,11.3000064 C10.9166408,11.5333391 10.7999743,11.816672 10.7999743,12.1500044 C10.7999743,12.4833368 10.9166408,12.7666697 11.1499734,13.0000024 C11.3833061,13.233335 11.666639,13.3500015 11.9999714,13.3500015 Z' })
	  );
	}
	
	Truck.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Truck = __webpack_require__(280);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Truck).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Unlock = function Unlock(_ref) {
	  var color = _ref.color,
	      className = _ref.className,
	      width = _ref.width,
	      height = _ref.height,
	      title = _ref.title;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-unlock ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('path', { fill: color, className: 'path1', d: 'M12 1c1.654 0 3 1.346 3 3v3h-2v-3c0-0.551-0.449-1-1-1h-2c-0.551 0-1 0.449-1 1v3h0.25c0.412 0 0.75 0.338 0.75 0.75v7.5c0 0.412-0.338 0.75-0.75 0.75h-8.5c-0.412 0-0.75-0.338-0.75-0.75v-7.5c0-0.412 0.338-0.75 0.75-0.75h6.25v-3c0-1.654 1.346-3 3-3h2z' })
	  );
	};
	
	Unlock.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Unlock;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Unlock = __webpack_require__(282);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Unlock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var Video = function (_BcReactComponent) {
	  _inherits(Video, _BcReactComponent);
	
	  function Video() {
	    _classCallCheck(this, Video);
	
	    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	  }
	
	  _createClass(Video, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-video ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M15.294 4.004c-0.165 0-0.335 0.058-0.491 0.168l-2.803 1.978v-1.651c0-0.825-0.675-1.5-1.5-1.5h-9c-0.825 0-1.5 0.675-1.5 1.5v7c0 0.825 0.675 1.5 1.5 1.5h9c0.825 0 1.5-0.675 1.5-1.5v-1.65l2.803 1.978c0.156 0.11 0.326 0.168 0.491 0.168 0 0 0 0 0 0 0.22 0 0.421-0.101 0.551-0.278 0.101-0.137 0.154-0.313 0.154-0.51v-6.415c-0-0.518-0.355-0.788-0.706-0.788z' })
	      );
	    }
	  }]);
	
	  return Video;
	}(_baseBcReactComponent2.default);
	
	Video.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Video;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Video = __webpack_require__(284);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Video).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var VideoCamera = function VideoCamera(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-video-camera ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M26,5.53571429 L26,21.3214286 C26,21.6986607 25.7678571,22.0323661 25.4341518,22.1774554 C25.3180804,22.2209821 25.1875,22.25 25.0714286,22.25 C24.8247768,22.25 24.5926339,22.1629464 24.4185268,21.9743304 L18.5714286,16.1272321 L18.5714286,18.5357143 C18.5714286,20.8426339 16.6997768,22.7142857 14.3928571,22.7142857 L4.17857143,22.7142857 C1.87165179,22.7142857 0,20.8426339 0,18.5357143 L0,8.32142857 C0,6.01450893 1.87165179,4.14285714 4.17857143,4.14285714 L14.3928571,4.14285714 C16.6997768,4.14285714 18.5714286,6.01450893 18.5714286,8.32142857 L18.5714286,10.7154018 L24.4185268,4.8828125 C24.5926339,4.69419643 24.8247768,4.60714286 25.0714286,4.60714286 C25.1875,4.60714286 25.3180804,4.63616071 25.4341518,4.6796875 C25.7678571,4.82477679 26,5.15848214 26,5.53571429 Z' })
	  );
	};
	
	VideoCamera.propTypes = _bcPropTypes.iconShape;
	
	exports.default = VideoCamera;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideoCamera = __webpack_require__(286);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoCamera).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Warning = function (_BcReactComponent) {
	  _inherits(Warning, _BcReactComponent);
	
	  function Warning() {
	    _classCallCheck(this, Warning);
	
	    return _possibleConstructorReturn(this, (Warning.__proto__ || Object.getPrototypeOf(Warning)).apply(this, arguments));
	  }
	
	  _createClass(Warning, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-warning ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9 13h-2v-2h2v2zM9 9h-2v-6h2v6z' })
	      );
	    }
	  }]);
	
	  return Warning;
	}(_baseBcReactComponent2.default);
	
	Warning.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Warning;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Warning = __webpack_require__(288);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Warning).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	exports.default = _react.PropTypes.shape({
	  buttonBackgroundColor: _react.PropTypes.string,
	  breakpointSettings: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    gutterSize: _react.PropTypes.string.isRequired,
	    itemsPerPage: _react.PropTypes.number.isRequired,
	    partiallyShowOffscreenItems: _react.PropTypes.bool.isRequired,
	    showDots: _react.PropTypes.bool.isRequired,
	    useTouchArrows: _react.PropTypes.bool.isRequired
	  })).isRequired
	}).isRequired;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	exports.default = {
	  className: _react.PropTypes.string,
	  width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  color: _react.PropTypes.string,
	  title: _react.PropTypes.string
	};

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _singleClickHoldsSettingsShape = __webpack_require__(43);
	
	var _singleClickHoldsSettingsShape2 = _interopRequireDefault(_singleClickHoldsSettingsShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accountShape = _reactImmutableProptypes2.default.contains({
	  id: _react.PropTypes.number,
	  libId: _react.PropTypes.number,
	  digitalNotificationEmail: _react.PropTypes.string,
	  expiryDate: _react.PropTypes.string,
	  importedILSShelves: _react.PropTypes.bool,
	  borrowingHistoryEnabled: _react.PropTypes.bool,
	  singleClickHoldsSettings: _singleClickHoldsSettingsShape2.default,
	  preferredLocations: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string)
	});
	
	exports.default = accountShape;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var availabilityShape = _reactImmutableProptypes2.default.contains({
	  circulationType: _react.PropTypes.string,
	  localisedStatus: _react.PropTypes.string,
	  heldCopies: _react.PropTypes.number,
	  eresourceDescription: _react.PropTypes.string,
	  singleBranch: _react.PropTypes.bool,
	  metadataId: _react.PropTypes.string,
	  availabilityLocationType: _react.PropTypes.string,
	  status: _react.PropTypes.string,
	  bibType: _react.PropTypes.string,
	  totalCopies: _react.PropTypes.number,
	  libraryUseOnly: _react.PropTypes.bool,
	  eresourceUrl: _react.PropTypes.string,
	  availableCopies: _react.PropTypes.number
	});
	
	exports.default = availabilityShape;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  remaining: _react.PropTypes.number,
	  total: _react.PropTypes.number,
	  type: _react.PropTypes.string
	});

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bibShape = __webpack_require__(30);
	
	var _bibShape2 = _interopRequireDefault(_bibShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  actions: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  bib: _bibShape2.default,
	  checkInEnabled: _react.PropTypes.bool,
	  checkoutId: _react.PropTypes.string,
	  digitalId: _react.PropTypes.string,
	  downloadUrl: _react.PropTypes.string,
	  downloadable: _react.PropTypes.bool,
	  dueDate: _react.PropTypes.string,
	  fines: _react.PropTypes.number,
	  format: _react.PropTypes.string,
	  materialType: _react.PropTypes.string,
	  metadataId: _react.PropTypes.string,
	  status: _react.PropTypes.string,
	  thirdPartyReaderUrl: _react.PropTypes.string,
	  timesRenewed: _react.PropTypes.number
	});

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	exports.default = _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.string])), _react.PropTypes.node, _react.PropTypes.string]);

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	exports.default = _react.PropTypes.shape({
	  id: _react.PropTypes.number.isRequired,
	  title: _react.PropTypes.string.isRequired,
	  content: _react.PropTypes.string.isRequired,
	  url: _react.PropTypes.string.isRequired,
	  contentType: _react.PropTypes.string.isRequired,
	  metadataId: _react.PropTypes.string
	});

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bibShape = __webpack_require__(30);
	
	var _bibShape2 = _interopRequireDefault(_bibShape);
	
	var _branchShape = __webpack_require__(41);
	
	var _branchShape2 = _interopRequireDefault(_branchShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  actions: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  bib: _bibShape2.default,
	  expiryDate: _react.PropTypes.string,
	  holdPlacedDate: _react.PropTypes.string,
	  holdsId: _react.PropTypes.string,
	  holdsPosition: _react.PropTypes.number,
	  itemId: _react.PropTypes.string,
	  materialType: _react.PropTypes.string,
	  metadataId: _react.PropTypes.string,
	  pickupLocation: _branchShape2.default,
	  status: _react.PropTypes.string
	});

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _siteShape = __webpack_require__(44);
	
	var _siteShape2 = _interopRequireDefault(_siteShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var libraryShape = _reactImmutableProptypes2.default.contains({
	  getCardLink: _react.PropTypes.bool,
	  showHoldCountInSearch: _react.PropTypes.bool,
	  showDueDateInCirc: _react.PropTypes.bool,
	  siteId: _react.PropTypes.string,
	  domain: _react.PropTypes.string,
	  showCallNumber: _react.PropTypes.bool,
	  numericPasswordRequired: _react.PropTypes.bool,
	  shortName: _react.PropTypes.string,
	  longName: _react.PropTypes.string,
	  showVolumeSelectorStatus: _react.PropTypes.bool,
	  singleBranch: _react.PropTypes.bool,
	  showExternalSearchLink: _react.PropTypes.bool,
	  logo: _react.PropTypes.string,
	  featuredContentBlockPosition: _react.PropTypes.number,
	  showVolumeSelectorDueDate: _react.PropTypes.bool,
	  showInactiveHolds: _react.PropTypes.bool,
	  featuredListTypes: _react.PropTypes.bool,
	  showCallNumberForDigital: _react.PropTypes.bool,
	  showVolumeSelectorCollection: _react.PropTypes.bool,
	  pickupLocationEditable: _react.PropTypes.bool,
	  libraryId: _react.PropTypes.number,
	  showCollectionInCirc: _react.PropTypes.bool,
	  recentlyReturned: _react.PropTypes.bool,
	  cmsEnabled: _react.PropTypes.bool,
	  holdInfoMessages: _reactImmutableProptypes2.default.list,
	  onlyShowEditionsForCDROMAndVideoGames: _react.PropTypes.bool,
	  fullName: _react.PropTypes.string,
	  type: _react.PropTypes.string,
	  id: _react.PropTypes.number,
	  hideCallNumberForHigherSearchScope: _react.PropTypes.bool,
	  linkableLibraries: _reactImmutableProptypes2.default.listOf(_siteShape2.default)
	});
	
	exports.default = libraryShape;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var jacketCoverShape = _react.PropTypes.shape({
	  type: _react.PropTypes.string,
	  smallCover: _react.PropTypes.string,
	  mediumCover: _react.PropTypes.string,
	  largeCover: _react.PropTypes.string,
	  localUrl: _react.PropTypes.string
	});
	
	var bibListItemShape = _react.PropTypes.shape({
	  id: _react.PropTypes.string,
	  title: _react.PropTypes.string,
	  authors: _react.PropTypes.arrayOf(_react.PropTypes.string),
	  format: _react.PropTypes.string,
	  pubYear: _react.PropTypes.string
	});
	
	var urlListItemShape = _react.PropTypes.shape({
	  url: {
	    title: _react.PropTypes.string,
	    url: _react.PropTypes.string
	  }
	});
	
	var listItemShape = _react.PropTypes.oneOfType([_react.PropTypes.shape({
	  id: _react.PropTypes.number,
	  type: _react.PropTypes.string.isRequired,
	  bibListItem: bibListItemShape.isRequired,
	  annotation: _react.PropTypes.string,
	  jacketCover: jacketCoverShape
	}), _react.PropTypes.shape({
	  id: _react.PropTypes.number,
	  type: _react.PropTypes.string.isRequired,
	  urlListItem: urlListItemShape.isRequired,
	  annotation: _react.PropTypes.string,
	  jacketCover: jacketCoverShape
	})]);
	
	exports.default = listItemShape;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _userIdentityShape = __webpack_require__(45);
	
	var _userIdentityShape2 = _interopRequireDefault(_userIdentityShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listShape = _react.PropTypes.shape({
	  agencyScope: _react.PropTypes.string,
	  created: _react.PropTypes.string,
	  updated: _react.PropTypes.string,
	  id: _react.PropTypes.number,
	  intendedLocale: _react.PropTypes.string,
	  isPrivate: _react.PropTypes.bool,
	  itemCount: _react.PropTypes.number,
	  language: _react.PropTypes.string,
	  listType: _react.PropTypes.string,
	  name: _react.PropTypes.string,
	  owner: _userIdentityShape2.default
	});
	
	exports.default = listShape;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messagingShape = _reactImmutableProptypes2.default.contains({
	  message: _reactImmutableProptypes2.default.mapContains({
	    type: _react.PropTypes.string,
	    id: _react.PropTypes.string,
	    defaultMessage: _react.PropTypes.string
	  }),
	  values: _reactImmutableProptypes2.default.map,
	  duration: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
	  fieldErrors: _reactImmutableProptypes2.default.contains({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  }),
	  failureDuration: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool])
	});
	
	exports.default = messagingShape;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _filterShape = __webpack_require__(42);
	
	var _filterShape2 = _interopRequireDefault(_filterShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var searchFieldShape = _react.PropTypes.shape({
	  id: _react.PropTypes.string,
	  hasMore: _react.PropTypes.bool,
	  fieldFilters: _react.PropTypes.arrayOf(_filterShape2.default)
	});
	
	exports.default = searchFieldShape;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var shelfItemShape = _react.PropTypes.shape({
	  id: _react.PropTypes.number,
	  metadataId: _react.PropTypes.string,
	  shelf: _react.PropTypes.string,
	  privateItem: _react.PropTypes.bool
	});
	
	exports.default = shelfItemShape;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shelfShape = _reactImmutableProptypes2.default.contains({
	  userId: _react.PropTypes.number.isRequired,
	  name: _react.PropTypes.string.isRequired,
	  privateByDefault: _react.PropTypes.bool,
	  items: _reactImmutableProptypes2.default.list.isRequired,
	  pagination: _reactImmutableProptypes2.default.map.isRequired,
	  sort: _reactImmutableProptypes2.default.map.isRequired,
	  facets: _reactImmutableProptypes2.default.list.isRequired
	});
	
	exports.default = shelfShape;

/***/ },
/* 306 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 307 */
306,
/* 308 */
306,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseIcons = __webpack_require__(14);
	
	var _button = __webpack_require__(13);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function BlueCaretArrowButton(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? '' : _ref$children,
	      props = _objectWithoutProperties(_ref, ['className', 'children']);
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({}, props, { className: 'cp-blue-caret-arrow-button ' + className }),
	    children,
	    _react2.default.createElement(_baseIcons.Carets.Down, null)
	  );
	}
	
	BlueCaretArrowButton.propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
	};
	
	exports.default = BlueCaretArrowButton;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BlueCaretArrowButton = __webpack_require__(341);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlueCaretArrowButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.BlueTextButton = BlueTextButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(13);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(364);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function BlueTextButton(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? '' : _ref$children,
	      props = _objectWithoutProperties(_ref, ['className', 'children']);
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({}, props, { className: 'cp-blue-text-button ' + className }),
	    children
	  );
	}
	
	BlueTextButton.propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
	};
	
	exports.default = BlueTextButton;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BlueTextButton = __webpack_require__(343);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlueTextButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(14);
	
	var _bcPropTypes = __webpack_require__(2);
	
	__webpack_require__(365);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  handleClick: _react2.default.PropTypes.func,
	  disabled: _react2.default.PropTypes.bool,
	  children: _bcPropTypes.childrenShape.isRequired,
	  isLoading: _react2.default.PropTypes.bool,
	  tagName: _react2.default.PropTypes.string,
	  spinnerColor: _react2.default.PropTypes.string,
	  block: _react2.default.PropTypes.bool,
	  flat: _react2.default.PropTypes.bool,
	  dataKey: _react2.default.PropTypes.string
	};
	
	var Button = function (_BcReactComponent) {
	  _inherits(Button, _BcReactComponent);
	
	  function Button(props) {
	    _classCallCheck(this, Button);
	
	    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      if (this.props.isLoading) {
	        e.preventDefault();
	        return;
	      }
	      if (this.props.handleClick) {
	        e.preventDefault();
	        this.props.handleClick(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          spinnerColor = _props.spinnerColor,
	          block = _props.block,
	          flat = _props.flat,
	          isLoading = _props.isLoading,
	          Tag = _props.tagName,
	          props = _objectWithoutProperties(_props, ['className', 'children', 'spinnerColor', 'block', 'flat', 'isLoading', 'tagName']);
	
	      delete props.handleClick;
	      delete props.currentPage;
	
	      return _react2.default.createElement(
	        Tag,
	        _extends({}, props, { onClick: this.handleClick, className: Button.getButtonClassName(className, block, flat), 'data-key': this.props.dataKey }),
	        isLoading ? _react2.default.createElement(_baseIcons.Spinner, { color: spinnerColor }) : children
	      );
	    }
	  }], [{
	    key: 'getButtonClassName',
	    value: function getButtonClassName() {
	      var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var isBlock = arguments[1];
	      var isFlat = arguments[2];
	
	      var block = isBlock ? 'btn-block' : '';
	      var flat = isFlat ? 'btn-flat' : '';
	      return 'cp-btn btn ' + block + ' ' + flat + ' ' + classes;
	    }
	  }]);
	
	  return Button;
	}(_baseBcReactComponent2.default);
	
	Button.propTypes = propTypes;
	Button.defaultProps = {
	  tagName: 'button'
	};
	Button.displayName = 'Button';
	
	exports.default = Button;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DefaultButton = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(13);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(366);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prefer-stateless-function */
	var DefaultButton = exports.DefaultButton = function (_React$Component) {
	  _inherits(DefaultButton, _React$Component);
	
	  function DefaultButton() {
	    _classCallCheck(this, DefaultButton);
	
	    return _possibleConstructorReturn(this, (DefaultButton.__proto__ || Object.getPrototypeOf(DefaultButton)).apply(this, arguments));
	  }
	
	  _createClass(DefaultButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          _props$children = _props.children,
	          children = _props$children === undefined ? '' : _props$children,
	          _props$spinnerColor = _props.spinnerColor,
	          spinnerColor = _props$spinnerColor === undefined ? '' : _props$spinnerColor,
	          props = _objectWithoutProperties(_props, ['className', 'children', 'spinnerColor']);
	
	      var classNames = 'cp-default-btn btn-default ' + className;
	
	      return _react2.default.createElement(
	        _button2.default,
	        _extends({ className: classNames, spinnerColor: spinnerColor }, props),
	        children
	      );
	    }
	  }]);
	
	  return DefaultButton;
	}(_react2.default.Component);
	
	DefaultButton.propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  spinnerColor: _react2.default.PropTypes.string,
	  dataKey: _react2.default.PropTypes.string
	};
	DefaultButton.displayName = 'DefaultButton';
	
	exports.default = DefaultButton;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DefaultButton = __webpack_require__(346);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DefaultButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.GhostButton = GhostButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(13);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(367);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function GhostButton(_ref) {
	  var children = _ref.children,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$spinnerColor = _ref.spinnerColor,
	      spinnerColor = _ref$spinnerColor === undefined ? '#FFF' : _ref$spinnerColor,
	      props = _objectWithoutProperties(_ref, ['children', 'className', 'spinnerColor']);
	
	  var classNames = 'cp-ghost-btn ' + className;
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({ className: classNames, spinnerColor: spinnerColor }, props),
	    children
	  );
	}
	
	GhostButton.propTypes = {
	  className: _react.PropTypes.string,
	  isLoading: _react.PropTypes.bool,
	  handleClick: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired,
	  spinnerColor: _react.PropTypes.string
	};
	
	exports.default = GhostButton;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(13);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(368);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function HighlightButton(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? '' : _ref$children,
	      props = _objectWithoutProperties(_ref, ['className', 'children']);
	
	  var classNames = 'btn-highlight ' + className;
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({ className: classNames }, props),
	    children
	  );
	}
	
	HighlightButton.propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
	};
	
	HighlightButton.displayName = 'HighlightButton';
	
	exports.default = HighlightButton;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HighlightButton = __webpack_require__(349);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HighlightButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrimaryGhostButton = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ghost = __webpack_require__(72);
	
	var _ghost2 = _interopRequireDefault(_ghost);
	
	__webpack_require__(369);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prefer-stateless-function */
	var PrimaryGhostButton = exports.PrimaryGhostButton = function (_React$Component) {
	  _inherits(PrimaryGhostButton, _React$Component);
	
	  function PrimaryGhostButton() {
	    _classCallCheck(this, PrimaryGhostButton);
	
	    return _possibleConstructorReturn(this, (PrimaryGhostButton.__proto__ || Object.getPrototypeOf(PrimaryGhostButton)).apply(this, arguments));
	  }
	
	  _createClass(PrimaryGhostButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['className', 'children']);
	
	      var classNames = 'cp-primary-ghost-btn primary-ghost-btn ' + className;
	
	      return _react2.default.createElement(
	        _ghost2.default,
	        _extends({ className: classNames }, props),
	        children
	      );
	    }
	  }]);
	
	  return PrimaryGhostButton;
	}(_react2.default.Component);
	
	PrimaryGhostButton.propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
	};
	
	exports.default = PrimaryGhostButton;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrimaryGhostButton = __webpack_require__(351);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrimaryGhostButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(13);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(370);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  spinnerColor: _react2.default.PropTypes.string
	};
	
	/* eslint-disable react/prefer-stateless-function */
	
	var PrimaryButton = function (_React$Component) {
	  _inherits(PrimaryButton, _React$Component);
	
	  function PrimaryButton() {
	    _classCallCheck(this, PrimaryButton);
	
	    return _possibleConstructorReturn(this, (PrimaryButton.__proto__ || Object.getPrototypeOf(PrimaryButton)).apply(this, arguments));
	  }
	
	  _createClass(PrimaryButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          _props$children = _props.children,
	          children = _props$children === undefined ? '' : _props$children,
	          _props$spinnerColor = _props.spinnerColor,
	          spinnerColor = _props$spinnerColor === undefined ? '#FFF' : _props$spinnerColor,
	          props = _objectWithoutProperties(_props, ['className', 'children', 'spinnerColor']);
	
	      var classNames = 'cp-primary-btn btn-primary ' + className;
	
	      return _react2.default.createElement(
	        _button2.default,
	        _extends({ className: classNames, spinnerColor: spinnerColor }, props),
	        children
	      );
	    }
	  }]);
	
	  return PrimaryButton;
	}(_react2.default.Component);
	
	PrimaryButton.propTypes = propTypes;
	
	exports.default = PrimaryButton;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrimaryButton = __webpack_require__(353);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrimaryButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseIcons = __webpack_require__(14);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(371);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  handleClick: _react2.default.PropTypes.func,
	  tagName: _react2.default.PropTypes.string,
	  isLoading: _react2.default.PropTypes.bool
	};
	
	var RemoveButton = function (_BcReactComponent) {
	  _inherits(RemoveButton, _BcReactComponent);
	
	  function RemoveButton(props) {
	    _classCallCheck(this, RemoveButton);
	
	    var _this = _possibleConstructorReturn(this, (RemoveButton.__proto__ || Object.getPrototypeOf(RemoveButton)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(RemoveButton, [{
	    key: 'getButtonClassName',
	    value: function getButtonClassName() {
	      return 'cp-remove-btn btn btn-remove ' + this.props.className;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      if (this.props.handleClick && !this.props.isLoading) {
	        e.preventDefault();
	        this.props.handleClick();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Tag = this.props.tagName;
	      return _react2.default.createElement(
	        Tag,
	        { onClick: this.handleClick, className: this.getButtonClassName() },
	        this.props.isLoading ? _react2.default.createElement(_baseIcons.Spinner, { color: '#FFF' }) : _react2.default.createElement(_baseIcons.Remove, { className: 'icon-svg-remove small', width: '12', height: '12' })
	      );
	    }
	  }]);
	
	  return RemoveButton;
	}(_baseBcReactComponent2.default);
	
	RemoveButton.propTypes = propTypes;
	RemoveButton.defaultProps = {
	  tagName: 'button',
	  isLoading: false
	};
	
	exports.default = RemoveButton;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RemoveButton = __webpack_require__(355);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RemoveButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(13);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(372);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  spinnerColor: _react2.default.PropTypes.string
	};
	
	function SecondaryButton(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? '' : _ref$children,
	      _ref$spinnerColor = _ref.spinnerColor,
	      spinnerColor = _ref$spinnerColor === undefined ? '#FFF' : _ref$spinnerColor,
	      props = _objectWithoutProperties(_ref, ['className', 'children', 'spinnerColor']);
	
	  var classNames = 'btn-secondary ' + className;
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({ className: classNames, spinnerColor: spinnerColor }, props),
	    children
	  );
	}
	
	SecondaryButton.propTypes = propTypes;
	SecondaryButton.displayName = 'SecondaryButton';
	
	exports.default = SecondaryButton;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SecondaryButton = __webpack_require__(357);
	
	var _SecondaryButton2 = _interopRequireDefault(_SecondaryButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SecondaryButton2.default; /*
	                                              * Exports
	                                              */

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(2);
	
	var _button = __webpack_require__(13);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(373);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prefer-stateless-function */
	var TextButton = function (_React$Component) {
	  _inherits(TextButton, _React$Component);
	
	  function TextButton() {
	    _classCallCheck(this, TextButton);
	
	    return _possibleConstructorReturn(this, (TextButton.__proto__ || Object.getPrototypeOf(TextButton)).apply(this, arguments));
	  }
	
	  _createClass(TextButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          _props$children = _props.children,
	          children = _props$children === undefined ? '' : _props$children,
	          buttonProps = _objectWithoutProperties(_props, ['className', 'children']);
	
	      return _react2.default.createElement(
	        _button2.default,
	        _extends({ className: 'cp-text-button ' + className }, buttonProps),
	        children
	      );
	    }
	  }]);
	
	  return TextButton;
	}(_react2.default.Component);
	
	TextButton.propTypes = _extends({}, _button2.default.propTypes, {
	  children: _bcPropTypes.childrenShape.isRequired,
	  className: _react2.default.PropTypes.string
	});
	TextButton.displayName = 'TextButton';
	
	exports.default = TextButton;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TextButton = __webpack_require__(359);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(13);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(374);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  spinnerColor: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  dataKey: _react2.default.PropTypes.string
	};
	
	function TransactionalButton(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? '' : _ref$children,
	      _ref$spinnerColor = _ref.spinnerColor,
	      spinnerColor = _ref$spinnerColor === undefined ? '#FFF' : _ref$spinnerColor,
	      props = _objectWithoutProperties(_ref, ['className', 'children', 'spinnerColor']);
	
	  var classNames = 'btn-transactional ' + className;
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({ className: classNames, spinnerColor: spinnerColor }, props),
	    children
	  );
	}
	
	TransactionalButton.propTypes = propTypes;
	
	exports.default = TransactionalButton;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TransactionalButton = __webpack_require__(361);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransactionalButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 363 */
306,
/* 364 */
306,
/* 365 */
306,
/* 366 */
306,
/* 367 */
306,
/* 368 */
306,
/* 369 */
306,
/* 370 */
306,
/* 371 */
306,
/* 372 */
306,
/* 373 */
306,
/* 374 */
306,
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScreenReaderMessage = function (_BcReactComponent) {
	  _inherits(ScreenReaderMessage, _BcReactComponent);
	
	  function ScreenReaderMessage() {
	    _classCallCheck(this, ScreenReaderMessage);
	
	    return _possibleConstructorReturn(this, (ScreenReaderMessage.__proto__ || Object.getPrototypeOf(ScreenReaderMessage)).apply(this, arguments));
	  }
	
	  _createClass(ScreenReaderMessage, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          props = _objectWithoutProperties(_props, ['id', 'className']);
	
	      return _react2.default.createElement(
	        'span',
	        _extends({ className: 'sr-only ' + className, id: id }, props),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ScreenReaderMessage;
	}(_baseBcReactComponent2.default);
	
	ScreenReaderMessage.propTypes = {
	  id: _react.PropTypes.string,
	  localeKey: _react.PropTypes.string,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};
	
	exports.default = ScreenReaderMessage;

/***/ },
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _JacketCover = __webpack_require__(548);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JacketCover).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 486 */,
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthorLink = exports.metadataIdFixer = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadataIdFixer = exports.metadataIdFixer = function metadataIdFixer(id) {
	  if (!id) {
	    throw new Error('metadataIdFixer requires a metadataId');
	  }
	
	  // Support Legacy Bib IDs
	  if (id.match(/^\d+$/)) {
	    return id;
	  }
	
	  var _id$split = id.split(/[SC]/g),
	      _id$split2 = _slicedToArray(_id$split, 3),
	      _blank = _id$split2[0],
	      sourceLibId = _id$split2[1],
	      bibId = _id$split2[2]; // eslint-disable-line no-unused-vars
	
	
	  var paddedSourceLibId = _lodash2.default.padStart(sourceLibId, 3, '0');
	
	  return '' + bibId + paddedSourceLibId;
	};
	
	var getAuthorLink = exports.getAuthorLink = function getAuthorLink(author) {
	  return '/search?q=' + encodeURIComponent(author) + '&search_category=author&t=author';
	};
	
	// TODO: get rid of the default export.  named exports only in utils/helper files
	exports.default = {
	  metadataIdFixer: metadataIdFixer,
	  getAuthorLink: getAuthorLink
	};

/***/ },
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseScreenReaderMessage = __webpack_require__(51);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _reactIntl = __webpack_require__(11);
	
	__webpack_require__(596);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BibTextSlide = function BibTextSlide(_ref) {
	  var item = _ref.item;
	
	  var renderAuthorLinks = function renderAuthorLinks(bib) {
	    if (bib.authors && bib.authors.length > 0) {
	      var authorLinks = bib.authors.join(', ');
	      return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'by_authors', values: { authorLinks: authorLinks } },
	        function (message) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'authors' },
	            message
	          );
	        }
	      );
	    }
	    return null;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-bib-text-slide' },
	    _react2.default.createElement(
	      'div',
	      { className: 'inner-box' },
	      _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FORMAT.' + item.format.toLowerCase() })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'title' },
	        item.title
	      ),
	      item.subTitle && _react2.default.createElement(
	        'div',
	        { className: 'subtitle' },
	        item.subTitle
	      ),
	      renderAuthorLinks(item)
	    )
	  );
	};
	
	BibTextSlide.propTypes = {
	  item: _react.PropTypes.shape({
	    format: _react.PropTypes.string,
	    subTitle: _react.PropTypes.string,
	    title: _react.PropTypes.string.isRequired,
	    authors: _react.PropTypes.arrayOf(_react.PropTypes.string)
	  }).isRequired
	};
	
	exports.default = BibTextSlide;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIconForFormat = getIconForFormat;
	exports.getDigitalFormatTypeString = getDigitalFormatTypeString;
	exports.getDefaultImage = getDefaultImage;
	var iconMap = {
	  AB: 'icon icon-headphones',
	  ACCESSIBLE_FORMATS: 'icon icon-font',
	  AUDIOBOOKS_SPOKEN_WORD: 'icon icon-headphones',
	  BK: 'icon icon-book-open',
	  BLURAY: 'icon icon-cd',
	  BOARD_BK: 'icon icon-book-open',
	  BOOK_CD: 'icon icon-headphones',
	  BOOK_PCD: 'icon icon-book-open',
	  BOOKS: 'icon icon-book-open',
	  CDROM: 'icon icon-cd',
	  CS: 'icon icon-headphones',
	  DVD: 'icon icon-cd',
	  EBOOK: 'icon icon-tablet',
	  DEVICE: 'icon icon-tablet',
	  FILM: 'icon icon-videocam',
	  GAMES_INTERACTIVE_MEDIA: 'icon icon-gamepad',
	  GRAPHIC_NOVEL: 'icon icon-book-open',
	  JOURNALS_MAGAZINES: 'icon icon-newspaper',
	  LPRINT: 'icon icon-font',
	  MN: 'icon icon-music',
	  MOVIES_TV_VIDEO: 'icon icon-videocam',
	  MP3_CD: 'icon icon-headphones',
	  MUSIC_CD: 'icon icon-music',
	  MUSIC_CS: 'icon icon-music',
	  MUSIC_MP3_CD: 'icon icon-music',
	  MUSIC_SOUND: 'icon icon-music',
	  MUSIC_DOWNLOAD: 'icon icon-music',
	  MUSIC_ONLINE: 'icon icon-music',
	  LP: 'icon icon-music',
	  NEWSPAPER: 'icon icon-newspaper',
	  MAG: 'icon icon-newspaper',
	  EJ: 'icon icon-newspaper',
	  OTHER: 'icon icon-plus',
	  PAPERBACK: 'icon icon-book-open',
	  PLAYAWAY_AUDIOBOOK: 'icon icon-headphones',
	  PLAYAWAY_MUSIC: 'icon icon-music',
	  VC: 'icon icon-videocam',
	  VIDEO_GAME: 'icon icon-gamepad',
	  VIDEO_ONLINE: 'icon icon-videocam',
	  BR: 'icon icon-font',
	  ATLAS: 'icon icon-book-open',
	  PASS: 'icon icon-book-open',
	  SPOKEN_CD: 'icon icon-headphones',
	  VIDEO_DOWNLOAD: 'icon icon-videocam'
	};
	
	function getIconForFormat(format) {
	  if (iconMap[format]) {
	    return iconMap[format];
	  }
	  return 'icon icon-plus';
	}
	
	function getDigitalFormatTypeString(formatName) {
	  switch (formatName) {
	    case 'VIDEO':
	    case 'STREAMING_VIDEO':
	      return 'video';
	    case 'MUSIC':
	    case 'MUSIC_ONLINE':
	      return 'music';
	    case 'OVERDRIVE_MP3_AUDIOBOOK':
	    case 'OVERDRIVE_WMA_AUDIOBOOK':
	      return 'audiobook';
	    case 'OVERDRIVE_MEDIA_DO':
	      return 'media_do';
	    default:
	      return 'ebook';
	  }
	}
	
	/* istanbul ignore next */
	/* eslint-disable global-require */
	function getDefaultImage(format) {
	  // Dynamic requires are to be avoided in webpack because webpack will
	  // include the whole directory recursively since it can't figure out what needs
	  // to be included at compile time.
	  //
	  // The fix for this is to create a context for the require and pass the regex
	  // for the files to require.
	
	  // However require.context doesn't work on server side need to upgrade WebpackIsomorphicTools.
	  // For now we will hardcode the URLs and created CORE-34581.
	  // TODO: CORE-34581 - Upgrade WebpackIsomorphicTools so we don't have to hardcode image URLs
	
	  switch (format) {
	    case 'AB':
	      return __webpack_require__(518);
	    case 'BK':
	    case 'BOARD_BK':
	    case 'BOOK_CLUB_KIT':
	    case 'BOOK_PCD':
	    case 'GRAPHIC_NOVEL':
	    case 'PAPERBACK':
	      return __webpack_require__(521);
	    case 'RESTRICTED_BOOK_CD':
	    case 'SPOKEN_CD':
	    case 'TB':
	    case 'DAISY':
	      return __webpack_require__(475);
	    case 'RESTRICTED_BOOK_CS':
	    case 'CS':
	      return __webpack_require__(517);
	    case 'EBOOK':
	      return __webpack_require__(519);
	    case 'LPRINT':
	      return __webpack_require__(520);
	    case 'FILM':
	    case 'NONSTANDARD_VIDEO':
	      return __webpack_require__(529);
	    case 'BLURAY':
	    case 'DVD':
	      return __webpack_require__(526);
	    case 'VC':
	      return __webpack_require__(527);
	    case 'VIDEO_DOWNLOAD':
	    case 'VIDEO_ONLINE':
	      return __webpack_require__(528);
	    case 'MP3_CD':
	    case 'BOOK_CD':
	      return __webpack_require__(475);
	    case 'CDROM':
	    case 'VIDEO_GAME':
	      return __webpack_require__(523);
	    case 'COMIC_BK':
	    case 'MAG':
	    case 'NEWSPAPER':
	      return __webpack_require__(525);
	    case 'EJ':
	      return __webpack_require__(524);
	    case 'WEBSITE':
	      return __webpack_require__(536);
	    case 'LP':
	      return __webpack_require__(533);
	    case 'MN':
	    case 'MANUSCRIPT_MUSIC':
	      return __webpack_require__(532);
	    case 'MUSIC_CD':
	      return __webpack_require__(530);
	    case 'MUSIC_ONLINE':
	    case 'MUSIC_DOWNLOAD':
	      return __webpack_require__(531);
	    case 'DEVICE':
	    case 'PLAYAWAY_AUDIOBOOK':
	    case 'PLAYAWAY_MUSIC':
	    case 'PRELOADED_EBOOK':
	    case 'PRELOADED_VIDEO_PLAYER':
	      return __webpack_require__(522);
	    case 'ONLINE_IMAGE':
	      return __webpack_require__(535);
	    default:
	      return __webpack_require__(534);
	  }
	}
	/* eslint-enable global-require */
	
	exports.default = {
	  getIconForFormat: getIconForFormat,
	  getDigitalFormatTypeString: getDigitalFormatTypeString,
	  getDefaultImage: getDefaultImage
	};

/***/ },
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 518 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 519 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 520 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 521 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 522 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 523 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAADZCAIAAAC4k9W8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAG25JREFUeNrsnWl7E8cShYUjIJjF2MIxeAPFgM2T5P//CT4HA14AG2FksFlCSEhC7nvn3FT6jraenkUjueuDH2OkUatP1amq7urqcw8fPmxEmSKZiVMQEY0SEY0SEY0SEY0SEY2IRomIRomIRomIRomIRkSjRESjRESjRESjREQjolEiolFqIM0KPuPcuXPffPPN+fPnL1682Gw2//rrr7///vuPRP7888+vX79GGCYJUYC8du3a7OwsP8EVdIFwZmYGXH///ffffvvtQyJgHMGYAEQvXLhw69atVqsFkOkPbjYxWWBeWFg4Pj4+PT39/PlzxKO+iALh9evXQYufI0bQbC4tLV25cqXb7WKskYTriChwLi4ughM22vcF4lgzXEj46tWrvLjT6WCswQzMA7F7uB0yh9UjooXBiWlCthif/RHLIwj6mAi/A96lS5ewSwCw1/D7ysrKly9ffvnll7DPRS1u3LgBK3z69Gl3d5dPjIgWACdB0PLysgsn5gJI2B+mYwaKXV6+fBk7xpWm/O6zZ88IgzN/k4S99TSeDLTQ+Bnk8ILzURgPy3PJFhRfv369t7f366+/fk3k70SAGa+5v7///Plzl2aBBGB6IykfZTI14neGgdLEFYa8AnNCufZPTI049tWrV4NsBWLEcfIC94/4YPchnqJ0yDXZiGgBgnd0XSNWCGAjkXj79q37MpC4efMmzJmVHlzLhidc5o+IBsq3335rloGBvnv3zscjEg0dHR25+SjPwaEOCpUH+VF7PTROcHQ2I6PiWdcMhWgI3+n5Rl5J6ORiIIeK5fn7UffFPOpsJjAFI+oSnZZt/d/7/v17LNVgACHi1fn5ec8oiRg7BX9AeBURTXsyd04zcaao8s2bNxC161DhXrJMH/9NMGX6hCbxnGijBSDqTmIqVPGMV4l7XYeKWqyurgLYcOdNeOy+hpSJh5zN1f8iEWUG3fzh/PnzAdEmTzg8PHSzHaBaW1vjaX1GPzMzNzfXbrdbrZbRA2qBrQesUcQ1oz7JJQEOnk/hLlESv79+/TqrrRBSYakrKyv2F4j3hx9+ODk54b8IYi2c5jW4TxdsPotPzLM4HBH9PxslASWcEQEqtCHXzGouGCjvkmt0OVxrtuJkHs4LejmA8Or4+Pgs77YWnIOTWQIq1mlmCiqkJf5JiMXJcC8WSWRkJgiK5xMZpE+YJtHy2UxDy8peMK/UzglxDa4u4FFaQdzb24NmRy64K6RCdeK2efErn9hoivc2Nzez2qjrUw8ODkDLjblkkVr053c+bnd3t9vtpl4TWbcwM2VycXLuNtn9+/e3t7fD3NunRMgvL1++DJmrnEX1SgRiGCVADnfVyqOULkPapg3aAuK/ePvUJK+lrGXjTbEqUkkyRctAiEvzODlSTJA7lwi4AoYexT+HKIp2DviJNmjFA1CNw3kvD+EnmgG1MOwpKE8sa3cCqwI/nKjCUdWpMPXuOl9ALC3w3CcMgpOs5rvvvsMih2+UaqcIzYNRwBKLh+c/fvw4uQReFqKKPJkpplUTyk9AxdRIK8vLLvgULJL8tdVqGUP4vOtCIkqZwPUkkUlcpihxBxHuImZhWq0cEMa7efMm5IYRlPGJPH9+fv727dsqCQ54gpYtsW+GjXHjvElwJysdKndP2Bwqc6S/MFMCtVhaAwmpDvmrbC6/rfM0QGXkfIUJArX0ug2CjtSM4LGg4uB8pu/sY5p3795dXl4udgeNIAD2Rkvcwoyzjmjjn5U59y84VDDoi01W82LSMXpCsKybd/5Mjv7B5CU9f8JY16IkEIW+bPEIS8KeiJLcBSbsgBconCGqGrlUJKblObyr7M1tkp/19fWDg4P6x8AV1VYRNHY6HezJ6sHIKwDj+fPnyjKJTpeWlvip/JJf4OohWygqw19bW6uGD7Vtx1BfvnxZ82y1uvpHUgJAcvMBlcDDZsQg0Cb+VaYm4+O/Bm2v8hZ4G8dZsXtjSAFlp9Npo+JekpZut0ugYc4SYGBjd3XJNQt8WG9GyCuxZiZ3DOqfVMkwJCKDiOj/MtQ3b94Aie2Kg5m7/JsKklM5A7arAkGfyiNTI+3GYO7wfH53i/IRKOH+a7sOXHWNMiDBvYA6vMCa16RKv8AexgPOTEyL8+Y5aBJwXrp0ibf7LyQNEpJU3MTbt28jov+CShwL2Q6ymGfPnikmskOJ4AHdMY/+hUu8l0m3mpgvX75grBAmeUjfPXMt6vJirNCtOu7LvXA+HoRnRkT/mwZAuX1PfTeSDZa9vT1311rrtMCAbWXiTLDBOt1QGUv98OEDVkseknoUCsSLddYKvBkefDBkDURrhCcnJ2caUSaRBGDQgRamngki4XOZFovkLcAZ4P94Tu/SnfYPUBF8of0RO8a76ySkrJnftUQ86HMZGB4dM63hUn51iOooiy3wusIkMq2pygelKGhAnuWevkjzWQwDI+P3Fy9eYLgp7Pk7wBN/DappkjdlhGcXUVXy9S2khuswTXfxSMeKMaM8yZ+iaMyod40CBYJ7GQ+myef2XcQYuTSvs2/D99unGVGB1EtizOnR0ZG7tKZND4LSvtacKXdEIbC/vqDyRzRpUAaiEpaRK8woaA0T04rWjIg4egkKQzk8PDQ4dUgbZl5dXc0Jp0QLjYPSlSEJJViOPCKuY+QF7iBNmI1qbQGlZn5VIrS/v+8yntqcrK2tFXvaXq0eXr586enwlCm1EhkZjqniqW5LDdVFRqrTJNxQ3OEyLZrO1Je0YwX3KvIaOfWq04ckcMA+WqXKwroFR9UhqnQQ6c0ECFLcUy6Fu3AcM6nRcEQZBvSQqVtAqTERqo/GuGcv67tmlEppyl52//TpEw57+L4mc6eWWln9Ykk7a7cS4eHb29uWKNcdUUUfjJuf5bECppmKpQfZMaaZFU58ROGIQhXtdlu7F4yHwOLp06cTgKjSUzLO8ko9UO3j42MQ9Sn6gpABHsLItA3QN4DPIyj3999/b8saRB7Pnj2rO+sqRSE/wbeV129I5Woki56ujpcxfYTEd+7c8R8VSlOgK8WFu5VvaBjOIuD5zYrhJNFk1vJvaQ2Hh/hr0GLQEFFrDxyBzzIyDy9q7wXGYk6sqhlSwTSD1y6qQ5Rxa9m9glZgQ3p3Mgy0ihf0EqaSZhyq5/HIQpwog4Fpje2J4/b29vLoSkWI4htgFXfHo1QmUOP0vnFHq9UipiUhhtN6Udeh1VQngL7CpDP7OYfKhOCAjBJImmH+nEzerGB+dTBtUPVJGdI3wNEm2sLCAiShypK+He5kviMRVTuWPKE+TGtFy+gWTBuQfVaNqIoigbPioj18ErODGZm+M3eYprt6gHGQ1fR2RVPF2siPyHPkNMW0jAGmLaoSuEREVe2ONVTf+wvkyOR0uIxAA3pgJKmKFhInFQy7DlWFpSNzKjwokUsYoqRtjM2CCTz3ixcvCoyZy0KUeWHcVTJtiurnEtER7saAs00Mj8jWjvvzGuxmpAoq1QmIpXk+gaFt+qIW6FPhpS2ldDVnpnASdWiGOpw/GSqBEhapMgadbhve36zxT/vYrKfVePjGxoalbbjh3d3drCt8Y0CUgIJJwTr9mVYqr+P4ujegSpaWp1cBsMYw8i0fP37M2kkfu3TTNhQCpi1pTbhZoGkyL1CWzq54vosEANqRiahzvY5OVOx6/VNk+Jn0xj9f5Mnot21FgCJYllrr2ywKTnXvy7QYRPRP+uWe9yZIAWOstprMNUCOjo7801Aoh5jW6jHKY9qCEdXGBSlKJjgJ2Zmd1PF9La2RaKuCvm4NchmzKvR9Xky+5K4SQ0XEQRWcaysAUSILcoOsm2JD7nURqKnbYMYu2gnxCYhQRJJdoxnUFKYlS6lmnM38Booy+h8tch3SEIVl4mCn+iAKl7hFbv5My1t0M0plQ82LKHy7uLgYsPiOyxySz9WqDhbHCZw+qBDnw7SWMkHRmHXFpWW5ECVXCW6AgCqkmjOkQsSRK6spB4zFF15ryTPVamvkEq76ENgJAMZD0IfvqF7/whFVWcnIfHyQQNQq6Bq0RpEpzoIVmXd1ixt+usFfTk9PeSyZ1Uiy5eNgWoskiAPUcnQsjNLMY6B56hB0zRnhRm9uR8qPvvsb3Pv37zEINYCD6HQ+Qj3HAqJl9Wbnmd1u1yfv5LPa7bYtkPFGzwCqdoiikgEBkSva3oJ7/0qEqVQDOPJxTzh5C+4NJ2d37AkDIAFdnjObiCfBqpUnkBCX8gSf+l4V7dlgOp0OVDFerx+IqOpLcq7c8hDMlLwTw5KjIsjKel8ByPXm7PJ//B0fj8XryD6/6zQL/5TGSAN0+TRv4aducvKxMB6IaZpOE+jBtGH3bNYCUR27L2QFgKkBSMGQlcNtX6VvIoSRoSjgpC3PZiIqXeOfGDc/xbHgkSn3B0jgNG+Nu93f369JcX04ooUcNkqFWmEK4bbM7cvMYvWUU5Q2BORIYlrT5leJ1CfXaoaxpZS9Dl9ANUEB9hFSONlskm5aXZnOY/We+5g8ROWKCvl4a58RHDPbBlzZVoKXIUWx5BuXieOckjPeWdP/QbGltZoGDKW2AbjqfGDZ00QEt7Kykr88ejptFH/29u1btaVQcRei6p75+XnV6mWycl0mUNIEFVseXVNE3btbs4rtiaZiGV0sQPIAxsvLy5lsvbyS7sLLo2uKqJVjZRUwg6wIJfqalILS4+Nj6Ldv992KJVUe3e12Dw8P639/VwiidnVO1iDo5OSkb58LV6A1UIcDPE/m2opBgVscqfJovq/aoDUmQQIRDYjxtFjqk8jDwBiE/wmZYmkQj+72eS22PLq+KwwB1RVq0+Zp3HgslMZnx5sHZl3xGSKtVmt9fd0tjz44OJisC31CENUkZnW9qLk/V39NxHMwhWx0gCJYgqgNoIzy6PqyrmpK/INMLTNlyhk8gy/bt8nJtNWUR9fXRnXFmH8dkNbKBy2p9329zysZCfyc08lVWR5dXz+qI3mZKrsyIcqTfVaCsE6C52DW7S2PxmtWVrRXL0R1HjbThtq1a9c8j4uop64PS/O0YAMde9FevRBVP2IyNv/FI2aQuOPz588jzVR3l3oeQQk7lnv9+vV2u21MS65JxjnRl1T+aw/B72Qqs15oB7+NLGQB+MXFRc/lhd7WuD4x2urqKnGQ4EQ1YVqsczrgbOSpM8KHEdyr5sN/Nu/cucMMDjpOi+lgx56NLfj0rIc4YRSY1tRlapi2GEQbyR4h05rp1BHwq0GnCBMLAxKdSkNA1LOoUz2lMhkoiuKeah1LeXTdEVWbNog0U9UucwqvAh7GQYSle7m1Nuuf4IKHf75Yn/LouiPa+KePIvlc1h1TkhNPdu2rRhioJ9/Wqjx6AhBtJDXHpCVLS0vVjBiuVj2tZ8rklkcTSe3v70/Wnb9jQBRbgcEwHatFLklUifnq1SufWKa3PFpFe41pl2IKwP74449ut8vP9fX18sYKnLp1YiTfuj1NNTxMs6TLw6cTUS3fwL1MpdqNFF77CdnqTPhIOFM9TWtVHj1JiCpm0UU8WGqBZSVqpgKcPpWxqZ6mOcujib3JplJ1VbovUfuDU45o4599zefPnzeSRgT5H4jLREX6Hm7pZdr85dHq+HIlEbAcuVvA8HQmjg+qSUXZuYcPH5bxXJJLnRC9fPkyCp61XE+3npGl6JDTSCPLWR7NaHX7nf+1A33dPAyvWqrpsVEXEtQWFZ6dnSVCAV1sCFxHdoHCFlF23ToxvFeDSao8OlNPU8YGSw8CUgfW0C3X/tTqByVIbSZeTOTGjRu8+DiRsSxIlWWjriuCu1Qyzy/a+FQLXB0NU9aPPTF3KkTSkT9P23LLozP1NFVT0dRql3y2uor17aqcEvRVO0W9B8t5FL4fXCsOykpHtNfbwY0CVWxsxzf73i85fDbDepoy+2tray6WaoROrO5ZrdhX8LvwthoNuk+usvXNGBAdFI9kDUdTPU09y6PVKsC9ARM16iZS4EIS1n/r1i2XyVFZhlfN2YpaIJqVxlM9TT3Lo9VR1LhRF5GCZUneDiaA1V1cyaM6nU5ENM1sbtGeP9Nimqurq/ZPIlKMpgIPBwnzubawzIAh4VL3CSYJ0eDyaEzTCnFBEZuu8hgv4RukYtk5rmFnZ6e8AUwGor3l0f49Te/fv2+lMGPce0k5/t3d3ULuGaguHy2Paf3Lo4lmsU6r9sNrwrTj+hYwCpR79+5dOXK+EbpVRs3+TM3hhKwePHhgcDIFjx498qxegOsMTvh5jHCaE93e3jav3263LZM+E4iS0kBTZJxiKi0Xo9ee+SLzpTgTv4XjJKatw5f68uULoFpFKpaas8vXxCB68eLFra0tq0lDrx8/fuyfp6vxlVlnqV3Eswpe/MmTJ2aphV/RUEdE4SKY1giTXPPnn3/2r8Ek77RERetwdfuCgPr06VMFaBcuXICKphZRK4+2Lm9Zy6PV3M0i25cvX9aThLBRPIh+h04KvCW5RoiirZubm1aBJpeT1f9B1CIxVaLUOehD4azuidwsuK9tTRGdm5uDaW3N7P3798S0WavdiTJszXYiav5AVOtHkBOR+ZQgypdZWVkhUZNtqTx6Z2cnAA9zn2PfdvYU7cxogwFtLuRSsjEjitu7d++eGRZUSRwY1qKWeErBFE537KlnpiTVYnh35Xki14xSPU1zLtFZXyuobLIq/zqdDsERwaA2z3Mu+Y4NUbenaf7yaCZCkYX2OwvO2ZOKQIRfVAjo0yE7UzJDiiWiwgFNHqJllEebgQJnUSdBMZrFxcX5+fm+nYTB9d27d0UVnbx+/ZooHY1RmUue24erRrSM8mieZgt+hRioTs8Nb094KRFoRiXKOWt3Vb+uXuDkpmThk4Foqjy6qJ6mtuCH0eTPWMijSCTcMjBVBKoYSoWAauqr/yWBBon8beaIj4QoX2cCEO0tjy6wp6khmn9zijl1j+5AIZhg33ES1omT5WghnpxFJwS9KI1K+GGy4EsMqkAU37CxsWEVcsX2NMVWLGnJGVNAdwYnLEqmOOSBHxOB7dFUbfbBwArxggcAxyg+QvWDES09H8Xhb21tGZyo/OPHjws8UGC7Ub09ewPI1h61vb3tox9o56NHj4xv8Sl5zoYYGeRZaigRUXGR3QBNuL+7u1t4i1o7vJ0zWjbrBCTbGPER1AjKsRIT1CK4nTQfLaWEdcIvuyqPacPKowM+yD4ij/sUDJDHzs5OSueggVarRUDEa3gBqYW6sruvIWJXrYVynrA9HyW7itv5uLCSwVIQDSuPDhPbssiTw9nyG0i41pkK6PQXdAiAU61WVGKxubmpkB5vGuYC8iNaMOuCYrvdtsaJYiRi8ZLg1DVLCp6D8xbg0WixcjdaxtpAaFD7j+vXr/O/7v1uOnNoOh02GCuhynS1Y1mIMgiYx3IJBudGDWWIsXoePrfyrVS1A3o5fFp1GX0qpzQtCRuMfZHg+5ELY91UeXQ1PU2tQifPwoLFVm4BLdTqE7XyrY+OjsywdBBKi3n+jUpTi0eprzYGG9VBFLtXXgdRqmmcaKQXvG5OsKO5I+Rx1cI/CXHNka9s7jysJsG+SPB9x3ltNNXTtOLu0UYJwdpjmUYqRfa/5y/FzDxHoQ1PDght7IuMJ3tBkc00tQhHvFdlE0xbIs7TO6OvTvibSOqVNpKwbjE5397Ic6MsEb/V046re3R+jR7Ecv7bQSkXnpM28rNOuB81P5G1PLpAye91BsWW/oSZWmrIGX7njwwCEYUcVEFCfBhQtFcfG+UryOsTH7kekVjdx0p4jRshuw8JCybGaaPwElgSB42xRW3+7E0rA73xLd/Op4Ct0+m4/Dw3Nyf/h4mHufb8GXau7GXsPZlsAASWwaGErYEsLi66tv7q1avhrqTb7bpNehmABRbBPiiniTfqf9pwJPnrmzObwWaqxkmNpLol1c+b0B0S6o2S+MvTp09TlQYLCwu2UxuMaH4bbTYmXOA36TVZYLBeHx4ebmxsNJJd61R3bf5J7HMtEdMAJOVr0AZb7s9TU2KnCoJ7NUw8onhBrdpcvXo1+FShbunT0t3du3cJ3V27BLzTRAZOYrNpZwLQhjyUq/omDDS4mm5m0hG15CHn0doXL14Y77kncHx4cmtry9aY7DkB4tZjBD9k4hFFnRUfERzlOd4Fy+EyjULv37+/tLQ0Mtq6ceMG8Jvzy1l4bDt3ZxrRhlOeE7yHZdxLvKNEEPrFL/7000/Ly8u9a7xAePPmzR9//PH27du2JoBC5ClGhLTNVeepkmxOAaJWu0y06d+1c1Dc++TJk/X1daGIsVqze52M0ImJ1Ls+f/4M2QZX71mobLlsnhR/GhDVhZXqCoqa5ywDVnnf/Pz8ysqKmxH1zY6IX9ChQvo8WNlDzotopgFRZfQA0EhqfAop7FZwq6bPV65cSREvCoRF8oKiisjV3N/i6ojofwtKhCizDwxFHQdWmbXZKC5TJyYKH7+doM1/f8nMdCCKattcDD+BlCeo1kGGwp9MiGsnsfJ3dpkSRBtO3RdmatVr9Rc14tLvnU4nf73A9CBKkGLZvdsAteYCoyjmYvyFtF6aHkRlprbmXkhPg7IFsrVuPwcHB4XsS04Vog1nEa7VahXY9qkMIc5qt9uWgxZV2DxtiH748MF2qlPXC9RN7ty5I75Vu+CiHjttiDaSsyuqkpmZmbl3717wSbFSBW2zWv5ib56eQkRd7tWae92iJLJP21onvi32jonpRFRnQG1lAFBH3oBWmegGKQvlCr8SdToRlUO13TG86dbWVp7qsgLJ1oJwTLNA9zn9iDaS3TFr34k3BdRCGu8FR7YbGxtGtsC5s7NTxgdNM6KN5OCGTRzelEDJbb9TmczOzj548MBCoTdv3pQE5/QjKmtw64Zu3bq1ubnpf1Ap7/zOzKBDLucTCul+1pJk8m7ZChMM1L25WGviTG6p5eNzc3M4TsOSD8W1l3172llBVKKORca6ZVyDJ4FgSVHc8jPCb+KgCo6TnC1EFffevn3bneuvX7+enp4SRhEe59z64OFgubCw4FauaAuhpBuYIqL/8mHvdbLqWsbUQ4yZrPbq1as8EEpPrU9BsxB7xZcFNxtnUt4nQjIDrhYlEcVcT6SR9E3R/rZVjwpyHYxRv0e1fMTce9ekUAhdTFLl+egzjaitQiCgIqp0A+DZRLI+EOxRFBH42GLAxpkXrPB1Ipga0MKf2G6mA6mYsqrISr1YNCKaWaDKN4mYjRLgYMHmHa2hjdq9qb25/z3yEdFxivzoJI58JoI3ZRIRjYhGiYhGiYhGiYhGiYhGRKNERKNERKNERKNERCOiUSKiUSKiUSKiUSKiEdEoEdEoEdEoEdEoEdGIaJSIaJSIaJSIaJSIaEQ0ynTIfwQYAEoaEDEJxvyAAAAAAElFTkSuQmCC"

/***/ },
/* 524 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 525 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAADZCAIAAAC4k9W8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABElJREFUeNrs3V1LKlsYwPHjSw5IQpQEicG+CKGLIOg79WkruurCW6Fu2hAGmYbtMxiIZ5+tTDrOnrX8/S+66Emt9W89LzPOWLm5ufkHEVG1BIyCUTAKRsEoo2AUjIJRMMooGAWjYBSMMgpGwSgYBaOMglEwCkbBKKNgFIyCUTDKKBgFo2AUjIJRRsEoGAWjYJRRMApGwSgYZRSMglEwCkYZBaML/JjxrVCtVjs/P18vdHR09K1Qs9m8vLxcI3RxcZF+Lb/R2vX1db460xVJ//IkSV5eXrKE0tXv9XrNGWuEDg4OJpPJaDTKEkq/mYbSH1gjtLe3d3h4OBwOPz4+dsXol7P5Kiw6WBaar/4moUUHK0JzZ2uHqtVq+aXmZnTR2W8OloVeX18XV3+T0JeDlGWhSqWy6GztUPmlVnL5TKbj4+PT09M/htJ1aTQafwxNp9Pf1nHDUGGvlX7//v4+5s6oXq8vCy1b4q8MmW+osNda8RDTCxgFoztFfRtPOhgMFue5OOh2u0EcYdiK0VRnOmNEZjTtb2VdMIpyZt3/j4lJkgS3NIEWjiKMttvtk5OT4Jbm9vZW1gWjYBR/v46Ox+P4xtOdNvpzhrWWdcEoism6nU4nxHl0NVdXV7k/59PT0+Pjoz2Kwvfo44zS7gx1FIxCZwR7FLF0RtPp9O3tLbh1r9VqW3rXUj30f8lUZ7/fD+7XbrVavV5P1oXOSGcEe/Qvd0YF9Bo5Mh6PJ5NJ8EaL4evS3ZL/krkci5d11VGoo1vtdeeZyomX2Paot5/FZjTEY0NxZt1imE6n5d/E6fTCaFYCPcCr10VERst/AIFR7HYdTcvkipG00Wi02+2M7cn8qo3sj8prANt2+xZPZ5QkScbjGOmazo1mf1QoU7Wsq45CHc2LTqezOpsFeueE3d2j3toSm1FbUB1VR0Om2Wx2u90sPzkajQaDAaNlp1artVotezSkrLu610V4e3R1r5v9/Gh89/4t2ujz8/Mmh77mZ4n7/f6K0y/OjxZn9OuTWDZ/Hu8zMr0wClnXPLoTRtOVLf4+/ebRLRoN4lM0GC075tHYjJpH9br26HJyvIp7NS5Ps0ftUfMooyXBPCrr2qMxzqMFX3Xq+tGtz6PxTbGyrjoKdbSwXrfITzl9f3///PxkdIvs7++fnZ0V9nIPDw/zDqs1I8ujXD8aBqnO7NfkuH4UjOqMsCGFnXqyR2VdMAp1NM7pxTxqHpV1wag6CvMoZF0wCnXUPArzKNTR7fNrRmGvVa2WdOniybrD4fDu7s48KuvKumAU6ug3SJIkxHt6NhoNRpcujfvXy7qMglEwCkYRQa8b933icrlLQ2BG3dhc1mUUjIJRMApGGQWjYBSMglFGLQGjYBSMglEwyigYBaNgFIwyCkbBKBgFo4yCUTAKRsEoo2AUjIJRMMooGAWjYBSMMgpGwSgYBaNglFEwCkbBKP7DvwIMAEfG+3iTGmo+AAAAAElFTkSuQmCC"

/***/ },
/* 526 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 527 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 528 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 529 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 530 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 531 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 532 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 533 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 534 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAADZCAIAAAC4k9W8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAVdJREFUeNrs0UERAAAIwzDAv7SJwgJvLpXQdJLSo8YCoiIqoiIqokRFVERFVESJiqiIiqiIEhVRERVRESUqoiIqoiJKVERFVERFlKiIiqiIiqiIEhVRERVRESUqoiIqoiJKVERFVERFlKiIiqiIiihRERVRERVRoiIqoiIqoiJKVERFVERFlKiIiqiIiihRERVRERVRoiIqoiIqokRFVERFVESJiqiIiqiIiihRERVRERVRoiIqoiIqokRFVERFVESJiqiIiqiIEhVRERVRESUqoiIqoiJK1AKiIiqiIiqiREVUREVURImKqIiKqIgSFVERFVERJSqiIiqiIkpUREVUREWUqIiKqIiKqIgSFVERFVERJSqiIiqiIkpUREVUREWUqIiKqIiKKFERFVERFVGiIiqiIiqiIkpUREVUREWUqIiKqIiKKFERFVERFVGiIiqiIqpDK8AA9rQEFuZKcsgAAAAASUVORK5CYII="

/***/ },
/* 535 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAADZAgMAAABKn6p4AAAADFBMVEXMzMz4+Pjf39/r6+tGWSl3AAAB2klEQVRo3u3XoXKEMBAG4ABzAoHkEZCVeB4BkZKIE7F1yEpeAl9dX89L4Kv7FM3cLDNk2SQr25v9ze0d3+XYJTBzSiKRSCQSieSJ85qLOHEX965eOG7yxcpwsy8ahlt8Uebd9KjWrLOPqgsOfyEHp4dP0NwINzyq4ux0gxy0gRsZC+Qil8aVV2eg3E9uUcjBWNBgDLwLnIayPbUB73JuhHHmnINxphxMqs45mECVc/BJyZjLCOPMzdnB8unrBhe8z+0D+IFbbl9BY3Vyn74dbagiue+3FdpQZfI+Us1xvip1X2r/ao55Ju5z6+dxXJ8+8dxwvs8RDnWJ59DmP/qGQ83FoQlD6rjTZ1fFnVXnxJ0L3B51W+DamDMqSBdzOnS3mLOhq2POha6IuS10ZcQZhbLTTmO30s5i19POYdfRbsOuIZ1ROAXp9MVVpLPqEtK5q1spt11di5yBNnA65O4rtIFyQ876L46Eq5GbC2gDpUJu8FtjIVwZOm96o6jsgfOm0aRbA+dNNZKuDZz1xQfDzVdAuiHq+sAtzPUUb72J6e5MNzKdY7qN6RTPTUx3ZzrLdI7phoTrTm7hrWcUbz3NdJbpZqYbmO7nM5Gvv/H/6P87iUQikUgkkmfML56kvXJZerfGAAAAAElFTkSuQmCC"

/***/ },
/* 536 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(7);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(23);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utilsFormat = __webpack_require__(512);
	
	var _utilsFormat2 = _interopRequireDefault(_utilsFormat);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(556);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JacketCover = function (_BcReactComponent) {
	  _inherits(JacketCover, _BcReactComponent);
	
	  function JacketCover(props) {
	    _classCallCheck(this, JacketCover);
	
	    var _this = _possibleConstructorReturn(this, (JacketCover.__proto__ || Object.getPrototypeOf(JacketCover)).call(this, props));
	
	    _this.state = {
	      imgSrc: null
	    };
	    return _this;
	  }
	
	  _createClass(JacketCover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.validateImage();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_immutable2.default.is(this.props.src, nextProps.src)) {
	        this.props = nextProps;
	        this.setState({ imgSrc: this.getDefaultImage() });
	        this.validateImage();
	      }
	    }
	  }, {
	    key: 'getSourceImage',
	    value: function getSourceImage() {
	      if (typeof this.props.src === 'string') {
	        if (this.props.src.indexOf('ftp://') !== 0) {
	          return [this.props.src];
	        }
	      }
	
	      if (_immutable2.default.Iterable.isIterable(this.props.src)) {
	        return _lodash2.default.compact([this.getLocalImageUrl(), this.props.src.get(this.props.size)]);
	      }
	
	      return [];
	    }
	  }, {
	    key: 'getLocalImageUrl',
	    value: function getLocalImageUrl() {
	      if (_immutable2.default.Iterable.isIterable(this.props.src)) {
	        var localUrl = this.props.src.get('local_url');
	        var isUrlHttp = localUrl && localUrl.indexOf('http://') !== -1;
	
	        // Use core CDN for image proxying http links to https
	        if (this.context.coreCdnHost && isUrlHttp) {
	          localUrl = this.context.coreCdnHost + '/image_proxy?url=' + localUrl;
	        }
	
	        return localUrl;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'validateImage',
	    value: function validateImage() {
	      var _this2 = this;
	
	      var currentImageIndex = 0;
	      var src = this.getSourceImage();
	
	      if (src.length > 0) {
	        var testImage = new Image();
	
	        testImage.onload = function () {
	          if (testImage.width > 1 && testImage.height > 1) {
	            _this2.setState({ imgSrc: testImage.src });
	          }
	          currentImageIndex += 1;
	        };
	
	        testImage.onerror = function () {
	          if (src.length > currentImageIndex + 1) {
	            currentImageIndex += 1;
	            testImage.src = src[currentImageIndex];
	          }
	        };
	        testImage.src = src[0];
	      }
	    }
	  }, {
	    key: 'renderDefault',
	    value: function renderDefault() {
	      if (this.props.renderDefault) {
	        return this.props.renderDefault();
	      }
	
	      return this.renderImage(_utilsFormat2.default.getDefaultImage(this.props.format));
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(src) {
	      var jacketClass = (0, _classnames2.default)('cp-jacket-cover', {
	        'img-responsive': this.props.responsive,
	        'drop-shadow': this.props.dropShadow
	      });
	
	      return _react2.default.createElement('img', {
	        alt: this.props.alt,
	        src: src,
	        className: jacketClass,
	        'data-test-id': this.props.testId });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.imgSrc) {
	        return this.renderImage(this.state.imgSrc);
	      }
	      return this.renderDefault();
	    }
	  }]);
	
	  return JacketCover;
	}(_baseBcReactComponent2.default);
	
	JacketCover.propTypes = {
	  format: _react.PropTypes.string,
	  src: _react.PropTypes.oneOfType([_react.PropTypes.string, _reactImmutableProptypes2.default.map, _reactImmutableProptypes2.default.mapOf({
	    local_url: _react.PropTypes.string,
	    large: _react.PropTypes.string,
	    medium: _react.PropTypes.string,
	    small: _react.PropTypes.string,
	    type: _react.PropTypes.string
	  })]),
	  border: _react.PropTypes.bool,
	  dropShadow: _react.PropTypes.bool,
	  size: _react.PropTypes.string,
	  responsive: _react.PropTypes.bool,
	  testId: _react.PropTypes.string,
	  renderDefault: _react.PropTypes.func
	};
	
	JacketCover.defaultProps = {
	  size: 'medium',
	  responsive: false,
	  border: false,
	  dropShadow: false
	};
	
	JacketCover.contextTypes = {
	  coreCdnHost: _react.PropTypes.string
	};
	
	exports.default = JacketCover;

/***/ },
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */
306,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(700);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var CardWrapper = function CardWrapper(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      border = _ref.border;
	
	  var cardClasses = (0, _classnames2.default)('cp-card', className, { border: border });
	  return _react2.default.createElement('div', { className: cardClasses }, children);
	};
	
	CardWrapper.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  className: _react.PropTypes.string,
	  border: _react.PropTypes.bool
	};
	
	CardWrapper.defaultProps = {
	  border: true
	};
	
	exports.default = CardWrapper;

/***/ },
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseHeadings = __webpack_require__(650);
	
	var _reactIntl = __webpack_require__(11);
	
	__webpack_require__(686);
	
	__webpack_require__(685);
	
	__webpack_require__(687);
	
	__webpack_require__(697);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardBody = function (_React$Component) {
	  _inherits(CardBody, _React$Component);
	
	  function CardBody() {
	    _classCallCheck(this, CardBody);
	
	    return _possibleConstructorReturn(this, (CardBody.__proto__ || Object.getPrototypeOf(CardBody)).apply(this, arguments));
	  }
	
	  _createClass(CardBody, [{
	    key: 'renderCreator',
	    value: function renderCreator() {
	      var _props = this.props,
	          creatorName = _props.creatorName,
	          creatorUrl = _props.creatorUrl;
	
	
	      var creatorLinks = creatorUrl ? _react2.default.createElement(
	        'a',
	        {
	          href: creatorUrl,
	          className: 'link-solid-true-underline-grey' },
	        creatorName
	      ) : creatorName;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'card-description' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_lists_by_creator', values: { creatorLinks: creatorLinks } })
	      );
	    }
	  }, {
	    key: 'renderDescription',
	    value: function renderDescription() {
	      var description = this.props.description;
	
	      return description && _react2.default.createElement(
	        'p',
	        { className: 'card-description' },
	        description
	      );
	    }
	  }, {
	    key: 'renderTags',
	    value: function renderTags() {
	      var tags = this.props.tags.map(CardBody.renderTag).reduce(function (accu, elem) {
	        return accu === null ? [elem] : [].concat(_toConsumableArray(accu), [' / ', elem]);
	      });
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'card-tags' },
	        tags
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cardImage = this.props.cardImage;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-card-body' },
	        cardImage,
	        _react2.default.createElement(
	          'div',
	          { className: 'info' },
	          _react2.default.createElement(_baseHeadings.ChevronHeading, { tag: this.props.cardHeadingTag, url: this.props.exitUrl, text: this.props.title, className: 'card-heading' }),
	          this.renderCreator(),
	          this.renderDescription(),
	          this.renderTags()
	        )
	      );
	    }
	  }], [{
	    key: 'renderTag',
	    value: function renderTag(tag) {
	      if (tag.url) {
	        return _react2.default.createElement(
	          'a',
	          { className: 'link-solid-faux-underline', href: tag.url },
	          tag.label
	        );
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        tag.label
	      );
	    }
	  }]);
	
	  return CardBody;
	}(_react2.default.Component);
	
	CardBody.propTypes = {
	  cardHeadingTag: _react.PropTypes.string,
	  title: _react.PropTypes.string.isRequired,
	  exitUrl: _react.PropTypes.string,
	  creatorName: _react.PropTypes.string,
	  creatorUrl: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  cardImage: _react.PropTypes.element,
	  tags: _react.PropTypes.arrayOf(_react.PropTypes.shape({ label: _react.PropTypes.string.isRequired, url: _react.PropTypes.string }).isRequired)
	};
	
	exports.default = CardBody;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(698);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardImage = function CardImage(_ref) {
	  var square = _ref.square,
	      rectangle = _ref.rectangle,
	      imageSrc = _ref.imageSrc,
	      imageAlt = _ref.imageAlt,
	      presentational = _ref.presentational,
	      exitUrl = _ref.exitUrl;
	
	  var className = (0, _classnames2.default)('cp-card-image', {
	    square: square,
	    rectangle: rectangle
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'a',
	      { href: exitUrl, className: 'link-solid-true-underline-grey' },
	      _react2.default.createElement('img', { src: imageSrc, alt: imageAlt, 'aria-hidden': presentational })
	    )
	  );
	};
	
	CardImage.propTypes = {
	  imageAlt: _react.PropTypes.string,
	  imageSrc: _react.PropTypes.string.isRequired,
	  presentational: _react.PropTypes.bool,
	  square: _react.PropTypes.bool,
	  rectangle: _react.PropTypes.bool,
	  exitUrl: _react.PropTypes.string
	};
	
	CardImage.defaultProps = {
	  square: false,
	  rectangle: false,
	  presentational: true,
	  imageAlt: ''
	};
	
	exports.default = CardImage;

/***/ },
/* 585 */,
/* 586 */,
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsLink = __webpack_require__(487);
	
	var _sharedJacketCover = __webpack_require__(485);
	
	var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);
	
	var _BibTextSlide = __webpack_require__(511);
	
	var _BibTextSlide2 = _interopRequireDefault(_BibTextSlide);
	
	__webpack_require__(597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderJacketCover = function SliderJacketCover(_ref) {
	  var handleClick = _ref.handleClick,
	      item = _ref.item;
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-slider-jacket-cover' },
	    _react2.default.createElement(
	      'a',
	      { key: item.id, onClick: handleClick, href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(item.id), target: '_parent' },
	      _react2.default.createElement(_sharedJacketCover2.default, { renderDefault: function renderDefault() {
	          return null;
	        }, format: item.format, src: item.jacket.medium, alt: item.title }),
	      _react2.default.createElement(_BibTextSlide2.default, { item: item })
	    )
	  );
	};
	
	SliderJacketCover.propTypes = {
	  handleClick: _react2.default.PropTypes.func,
	  item: _react2.default.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    format: _react.PropTypes.string.required,
	    jacket: _react.PropTypes.shape({
	      medium: _react.PropTypes.string.isRequired
	    }).isRequired,
	    title: _react.PropTypes.string.required
	  })
	};
	
	exports.default = SliderJacketCover;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BibTextSlide = __webpack_require__(511);
	
	Object.defineProperty(exports, 'BibTextSlide', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BibTextSlide).default;
	  }
	});
	
	var _SliderJacketCover = __webpack_require__(587);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SliderJacketCover).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */
306,
/* 597 */
306,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseIcons = __webpack_require__(14);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(695);
	
	__webpack_require__(694);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChevronHeading = function ChevronHeading(_ref) {
	  var tag = _ref.tag,
	      text = _ref.text,
	      url = _ref.url,
	      className = _ref.className;
	
	  var HeadingTag = tag;
	
	  var classNames = (0, _classnames2.default)('cp-chevron-heading', 'heading-medium', className);
	
	  return _react2.default.createElement(
	    HeadingTag,
	    { className: classNames },
	    url ? _react2.default.createElement(
	      'a',
	      { href: url, className: 'link-double-chevron' },
	      text
	    ) : text,
	    _react2.default.createElement(_baseIcons.Chevron.DoubleRight, { className: 'link-icon-double-chevron' })
	  );
	};
	
	ChevronHeading.propTypes = {
	  tag: _react.PropTypes.string,
	  url: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  text: _react.PropTypes.string.isRequired
	};
	
	ChevronHeading.defaultProps = {
	  tag: 'h1',
	  className: ''
	};
	
	exports.default = ChevronHeading;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ChevronHeading = __webpack_require__(649);
	
	Object.defineProperty(exports, 'ChevronHeading', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ChevronHeading).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(699);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardSection = function CardSection(_ref) {
	  var className = _ref.className,
	      renderProp = _ref.renderProp;
	  return _react2.default.createElement(
	    'div',
	    null,
	    renderProp('cp-card-section ' + className)
	  );
	};
	
	CardSection.propTypes = {
	  className: _react.PropTypes.string,
	  renderProp: _react.PropTypes.func.isRequired
	};
	
	exports.default = CardSection;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CardBody = __webpack_require__(583);
	
	var _CardBody2 = _interopRequireDefault(_CardBody);
	
	var _CardWrapper = __webpack_require__(569);
	
	var _CardWrapper2 = _interopRequireDefault(_CardWrapper);
	
	var _CardImage = __webpack_require__(584);
	
	var _CardImage2 = _interopRequireDefault(_CardImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GenericCard = function GenericCard(_ref) {
	  var border = _ref.border,
	      bottomImage = _ref.bottomImage,
	      cardHeadingTag = _ref.cardHeadingTag,
	      creatorName = _ref.creatorName,
	      creatorUrl = _ref.creatorUrl,
	      description = _ref.description,
	      exitUrl = _ref.exitUrl,
	      imageAlt = _ref.imageAlt,
	      imageSrc = _ref.imageSrc,
	      presentational = _ref.presentational,
	      rectangle = _ref.rectangle,
	      square = _ref.square,
	      tags = _ref.tags,
	      title = _ref.title;
	
	  var cardImageProps = {
	    imageAlt: imageAlt,
	    imageSrc: imageSrc,
	    presentational: presentational,
	    rectangle: rectangle,
	    square: square,
	    exitUrl: exitUrl
	  };
	
	  var cardBodyProps = {
	    border: border,
	    bottomImage: bottomImage,
	    cardHeadingTag: cardHeadingTag,
	    creatorName: creatorName,
	    creatorUrl: creatorUrl,
	    description: description,
	    exitUrl: exitUrl,
	    tags: tags,
	    title: title
	  };
	
	  var cardImage = _react2.default.createElement(_CardImage2.default, _extends({}, cardImageProps, { imageAlt: title + ' by ' + creatorName }));
	
	  return _react2.default.createElement(
	    _CardWrapper2.default,
	    null,
	    _react2.default.createElement(_CardBody2.default, _extends({}, cardBodyProps, { cardImage: cardImage }))
	  );
	};
	
	GenericCard.propTypes = {
	  border: _react.PropTypes.bool,
	  bottomImage: _react.PropTypes.bool,
	  square: _react.PropTypes.bool,
	  rectangle: _react.PropTypes.bool,
	  exitUrl: _react.PropTypes.string,
	  cardHeadingTag: _react.PropTypes.string,
	  imageSrc: _react.PropTypes.string,
	  imageAlt: _react.PropTypes.string,
	  presentational: _react.PropTypes.bool,
	  title: _react.PropTypes.string.isRequired,
	  creatorName: _react.PropTypes.string,
	  creatorUrl: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  tags: _react.PropTypes.arrayOf(_react.PropTypes.shape({ label: _react.PropTypes.string.isRequired, url: _react.PropTypes.string }).isRequired)
	};
	
	GenericCard.defaultProps = {
	  border: true,
	  bottomImage: false,
	  square: false,
	  rectangle: false
	};
	
	exports.default = GenericCard;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardWrapper = __webpack_require__(569);
	
	Object.defineProperty(exports, 'CardWrapper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardWrapper).default;
	  }
	});
	
	var _CardImage = __webpack_require__(584);
	
	Object.defineProperty(exports, 'CardImage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardImage).default;
	  }
	});
	
	var _CardBody = __webpack_require__(583);
	
	Object.defineProperty(exports, 'CardBody', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardBody).default;
	  }
	});
	
	var _CardSection = __webpack_require__(655);
	
	Object.defineProperty(exports, 'CardSection', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardSection).default;
	  }
	});
	
	var _GenericCard = __webpack_require__(656);
	
	Object.defineProperty(exports, 'GenericCard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GenericCard).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _baseBcReactComponent = __webpack_require__(3);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(14);
	
	var _baseButtons = __webpack_require__(29);
	
	__webpack_require__(704);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Rating = function (_BcReactComponent) {
	  _inherits(Rating, _BcReactComponent);
	
	  function Rating(props) {
	    _classCallCheck(this, Rating);
	
	    var _this = _possibleConstructorReturn(this, (Rating.__proto__ || Object.getPrototypeOf(Rating)).call(this, props));
	
	    _this.state = {
	      selectedRating: 0,
	      submitted: false
	    };
	
	    _this.bindAll('updateRating', 'handleRatingButtonClick', 'handleRemoveItemRating', 'renderStars');
	    return _this;
	  }
	
	  _createClass(Rating, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          rating = _props.rating,
	          readOnly = _props.readOnly;
	
	      if (rating && !readOnly) {
	        this.setState({
	          selectedRating: rating,
	          submitted: true
	        });
	      }
	    }
	  }, {
	    key: 'updateRating',
	    value: function updateRating(selectedRating) {
	      if (this.state.submitted || this.props.rating) {
	        return false;
	      }
	
	      return this.setState({ selectedRating: selectedRating });
	    }
	  }, {
	    key: 'handleRatingButtonClick',
	    value: function handleRatingButtonClick(rating) {
	      if (this.state.submitted) {
	        return;
	      }
	
	      this.setState({ selectedRating: rating });
	      this.props.handleButtonClick(rating);
	      this.setState({ submitted: true });
	    }
	  }, {
	    key: 'handleRemoveItemRating',
	    value: function handleRemoveItemRating() {
	      var _props2 = this.props,
	          metadataId = _props2.metadataId,
	          removeItemRating = _props2.removeItemRating;
	
	
	      this.setState({ selectedRating: 0, submitted: false });
	      removeItemRating(metadataId);
	    }
	  }, {
	    key: 'renderStars',
	    value: function renderStars() {
	      var stars = [];
	      var _props3 = this.props,
	          metadataId = _props3.metadataId,
	          readOnly = _props3.readOnly;
	
	      var rating = this.props.rating || 0;
	      var normalizedRating = void 0;
	
	      if (readOnly) {
	        // If the rating is read only, round up to the nearest star
	        normalizedRating = Math.round(rating / 10) * 10;
	      } else if (this.state.selectedRating > 0) {
	        normalizedRating = this.state.selectedRating;
	      } else {
	        normalizedRating = rating;
	      }
	
	      var halfStars = normalizedRating % 20 > 0 ? 1 : 0;
	
	      // Full stars
	      _lodash2.default.times(Math.floor(normalizedRating / 20), function (n) {
	        stars.push(_react2.default.createElement(_baseIcons.StarFull, { key: 'star_full_' + n + '_' + metadataId, className: 'rating-star star-full', color: '#f4a204' }));
	      });
	
	      // Half stars
	      _lodash2.default.times(halfStars, function (n) {
	        stars.push(_react2.default.createElement(_baseIcons.StarHalf, { key: 'star_half_' + n + '_' + metadataId, className: 'rating-star star-half', color: '#f4a204' }));
	      });
	
	      // Empty stars
	      _lodash2.default.times(5 - Math.round(normalizedRating / 20), function (n) {
	        stars.push(_react2.default.createElement(_baseIcons.StarEmpty, { key: 'star_empty_' + n + '_' + metadataId, className: 'rating-star star-empty', color: '#f4a204' }));
	      });
	
	      return stars;
	    }
	  }, {
	    key: 'renderButtons',
	    value: function renderButtons() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          metadataId = _props4.metadataId,
	          readOnly = _props4.readOnly;
	
	
	      if (readOnly) {
	        return _react2.default.createElement('noop', null);
	      }
	
	      return _lodash2.default.times(10, function (n) {
	        var value = (n + 1) * 10;
	        var starCount = (n + 1) / 2;
	        return _react2.default.createElement(
	          _baseButtons.DefaultButton,
	          {
	            key: 'rating_button_' + n + '_' + metadataId,
	            className: 'rating-button',
	            role: 'button',
	            onMouseOver: function onMouseOver() {
	              return _this2.updateRating(value);
	            },
	            onTouchStart: function onTouchStart() {
	              return _this2.handleRatingButtonClick(value);
	            },
	            onFocus: function onFocus() {
	              return _this2.updateRating(value);
	            },
	            handleClick: function handleClick() {
	              return _this2.handleRatingButtonClick(value);
	            } },
	          starCount + ' star' + (starCount === 1 ? '' : 's')
	        );
	      });
	    }
	  }, {
	    key: 'renderRemoveButton',
	    value: function renderRemoveButton() {
	      var readOnly = this.props.readOnly;
	
	      if (this.props.rating && !readOnly) {
	        return _react2.default.createElement(
	          _baseButtons.TextButton,
	          { className: 'remove-rating-button', 'aria-label': 'Remove rating button', handleClick: this.handleRemoveItemRating },
	          _react2.default.createElement(_baseIcons.Remove, null)
	        );
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          id = _props5.id,
	          metadataId = _props5.metadataId,
	          rating = _props5.rating,
	          readOnly = _props5.readOnly,
	          type = _props5.type;
	
	
	      if (!rating && readOnly) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-rating ' + type, 'aria-labelledby': id },
	        _react2.default.createElement(
	          'div',
	          { className: 'rating-star-wrap' },
	          this.renderStars()
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            role: 'region',
	            id: 'rating_select_' + metadataId,
	            className: 'rating-star-button-wrap ' + (this.state.submitted ? 'submitted' : ''),
	            onMouseLeave: function onMouseLeave() {
	              return _this3.updateRating(0);
	            },
	            onBlur: function onBlur() {
	              return _this3.updateRating(0);
	            } },
	          _react2.default.createElement(
	            'div',
	            { 'aria-controls': 'rating_select_' + metadataId, 'aria-label': 'Rating stars' },
	            this.renderButtons()
	          )
	        ),
	        this.renderRemoveButton(),
	        _react2.default.createElement(
	          'span',
	          { className: 'sr-only', id: id },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'screenReaderStarRating',
	            values: {
	              rating: rating / 20
	            } })
	        )
	      );
	    }
	  }]);
	
	  return Rating;
	}(_baseBcReactComponent2.default);
	
	Rating.propTypes = {
	  rating: _react.PropTypes.number, // integer 0 - 100
	  id: _react.PropTypes.string.isRequired,
	  type: _react.PropTypes.string.isRequired,
	  readOnly: _react.PropTypes.bool,
	  handleButtonClick: _react.PropTypes.func,
	  removeItemRating: _react.PropTypes.func,
	  metadataId: _react.PropTypes.string
	};
	
	Rating.displayName = 'Rating';
	
	exports.default = Rating;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Rating = __webpack_require__(665);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rating).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */
306,
/* 686 */
306,
/* 687 */
306,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */
306,
/* 695 */
306,
/* 696 */,
/* 697 */
306,
/* 698 */
306,
/* 699 */
306,
/* 700 */
306,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */
306,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sharedSliderJacketCover = __webpack_require__(588);
	
	var _sharedSliderJacketCover2 = _interopRequireDefault(_sharedSliderJacketCover);
	
	var _rating = __webpack_require__(666);
	
	var _rating2 = _interopRequireDefault(_rating);
	
	var _baseCard = __webpack_require__(657);
	
	var _reactIntl = __webpack_require__(11);
	
	__webpack_require__(1193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RatingCard = function RatingCard(_ref) {
	  var className = _ref.className,
	      item = _ref.item,
	      rating = _ref.rating,
	      creator = _ref.creator,
	      border = _ref.border;
	
	  var creatorUrl = '/user_profile/' + creator.id;
	  var renderProp = function renderProp(sectionClass) {
	    return _react2.default.createElement(
	      'div',
	      { className: sectionClass },
	      _react2.default.createElement(_rating2.default, { readOnly: true, rating: rating.rating, id: item.id, metadataId: item.id, type: 'average' }),
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'by_authors', values: { authorLinks: _react2.default.createElement(
	            'a',
	            { className: 'author-links', href: creatorUrl },
	            creator.name
	          ) } })
	    );
	  };
	
	  var cardClass = 'cp-rating-card ' + className;
	  return _react2.default.createElement(
	    _baseCard.CardWrapper,
	    { border: border, className: cardClass },
	    _react2.default.createElement(_sharedSliderJacketCover2.default, { item: item }),
	    _react2.default.createElement(_baseCard.CardSection, { className: 'rating-body', renderProp: renderProp })
	  );
	};
	
	RatingCard.propTypes = {
	  className: _react.PropTypes.string,
	  border: _react.PropTypes.bool,
	  item: _react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    format: _react.PropTypes.string.required,
	    jacket: _react.PropTypes.shape({
	      medium: _react.PropTypes.string.isRequired
	    }).isRequired,
	    title: _react.PropTypes.string.required
	  }).isRequired,
	  creator: _react.PropTypes.shape({ id: _react.PropTypes.string, name: _react.PropTypes.string }).isRequired,
	  rating: _react.PropTypes.shape({
	    rating: _react.PropTypes.number.isRequired, // integer 0 - 100
	    id: _react.PropTypes.string.isRequired,
	    type: _react.PropTypes.string.isRequired,
	    readOnly: _react.PropTypes.bool,
	    metadataId: _react.PropTypes.string
	  }).isRequired
	};
	
	RatingCard.defaultProps = {
	  border: false,
	  rating: {
	    readOnly: true,
	    type: 'average'
	  }
	};
	
	exports.default = RatingCard;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RatingCard = __webpack_require__(989);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RatingCard).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */
306,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Down = __webpack_require__(__webpack_module_template_argument_0__);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Down).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Left = __webpack_require__(__webpack_module_template_argument_0__);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Left).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Right = __webpack_require__(__webpack_module_template_argument_0__);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Right).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(__webpack_module_template_argument_0__), src$en$$ = __webpack_require__(__webpack_module_template_argument_1__);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// RatingCard-d592c387342d83190391.js